import React from "react";

export const ICONS = {
  CLIENTS_LIST: "CLIENT LIST",
  DASHBOARDS_LIST: "DASHBOARD LIST",
  DASHBOARD_PAGE_ICON: "DASHBOARD_PAGE_ICON",
  BALANCE_SHEET_PAGE_ICON: "BALANCE_SHEET_PAGE_ICON",
  REMOVE: "REMOVE",
  PLAY: "PLAY",
  SEND: "SEND",
  GRID: "GRID",
  MENU: "MENU",
  TRELLO: "TRELLO",
  STAR: "STAR",
  CALENDAR: "CALENDAR",
  FILTER: "FILTER",
  SETTING: "SETTING",
  HOME: "HOME",
  ASSOCIATE: "ASSOCIATE",
  DIAPORAMA: "DIAPORAMA",
  FULL_SCREEN: "FULL_SCREEN",
  AIR_PLAY: "AIR_PLAY",
  EyeIcon: "EyeIcon",
  SimpleArrowUp: "SimpleArrowUp",
  SimpleArrowRight: "SimpleArrowRight",
  DoubleArrowUp: "DoubleArrowUp",
  Garbage: "Garbage",
  Validate: "Validate",
  DELETE_ICON: "Delete",
  EXIT_ICON: "EXIT_ICON",
  EDIT_ICON: "Edit",
  LOOP_ICON: "LOOP_ICON",
  PLUS_ICON: "Plus",
  REPEAT_ICON: "REPEAT_ICON",
  CLOSED_EYE: "CLOSED_EYE",
  OPEN_EYE: "OPEN_EYE",
  SIMPLE_PLUS_ICON: "SIMPLE_PLUS_ICON",
  TREE_DOTS_ICON: "TREE_DOTS_ICON",
  DUPLICATE_ICON: "duplicate",
  DROP_DOWN: "DropDown",
  CloseIcon: "CloseIcon",
  CheckAuthorisationIcon: "CheckAuthorisationIcon",
  AddIcon: "AddIcon",
  CreateSlide: "CreateSlide",
  MODELE_SLIDE: "MODELE_SLIDE",
  DashboardList: "DashboardList",
  Pause: "Pause",
  Collaborator: "Collaborator",
  ThreeDots: "ThreeDots",
  PENCIL: "PENCIL",
  CLIPBOARD: "CLIPBOARD",
  MIC_ICONE: "MIC_ICONE",
  PAUSE_ICONE: "PAUSE_ICONE",
  STOP_ICONE: "STOP_ICONE",
  SWITCH_SLIDE: "SWITCH_SLIDE",
  MOVE_SLIDE: "MOVE_SLIDE",
  DollarMoneyBagWithCoinStacks: "DollarMoneyBagWithCoinStacks",
  PiggyBank: "PiggyBank",
  ProfitBarChartIcon: "ProfitBarChartIcon",
  DeficitBarChartIcon: "DeficitBarChartIcon",
  TrafficLight: "TrafficLight",
  FolderFilter: "folder",
  BriefCase: "BriefCase",
  ALERT_CIRCLE: "AlertCircle",
  Euro: "Euro",
  Google: "Google",
  Office365: "Office356",
  Outlook: "Outlook",
  Calendar: "Calendar",
  Share: "Share",
  Original: "Original",
  Lock: "Lock",
  Unshared: "Unshared",
  Duplicated: "Duplicate",
  CheckMarkCircleIcon: "CheckMarkCircleIcon",
  InfoCircleIcon: "InfoCircleIcon",
  Standard: "Standard",
  SyncIcon: "SYNCINCON"
};

export function SvgIcon({ icon, className, color }) {
  // eslint-disable-next-line default-case
  switch (icon) {
    case ICONS.CLIENTS_LIST: {
      return <ClientListIcon className={className} />;
    }
    case ICONS.DASHBOARD_PAGE_ICON: {
      return <DashboardPageIcon className={className} />;
    }
    case ICONS.BALANCE_SHEET_PAGE_ICON: {
      return <BalanceSheetIcon className={className} />;
    }
    case ICONS.FILTER: {
      return <FilterIcon className={className} />;
    }
    case ICONS.CLIPBOARD: {
      return <ClipboardIcon className={className} />;
    }
    case ICONS.TREE_DOTS_ICON: {
      return <TreeDotsIcon className={className} />;
    }
    case ICONS.SETTING: {
      return <SettingIcon className={className} />;
    }
    case ICONS.PLAY: {
      return <PlayIcon className={className} />;
    }
    case ICONS.STAR: {
      return <StarIcon className={className} color={color} />;
    }
    case ICONS.REMOVE: {
      return <RemoveIcon className={className} />;
    }
    case ICONS.SEND: {
      return <SendIcon className={className} />;
    }
    case ICONS.GRID: {
      return <GridIcon className={className} />;
    }
    case ICONS.MENU: {
      return <MenuIcon className={className} />;
    }
    case ICONS.TRELLO: {
      return <TrelloIcon className={className} />;
    }
    case ICONS.CALENDAR: {
      return <CalendarIcon className={className} />;
    }
    case ICONS.HOME: {
      return <HomeIcon className={className} />;
    }
    case ICONS.ASSOCIATE: {
      return <AssociateIcon className={className} color={color} />;
    }
    case ICONS.CLOSED_EYE: {
      return <CloseEyeIcon className={className} color={color} />;
    }
    case ICONS.OPEN_EYE: {
      return <OpenEyeIcon className={className} color={color} />;
    }
    case ICONS.DIAPORAMA: {
      return <DiaporamaIcon className={className} />;
    }
    case ICONS.MOVE_SLIDE: {
      return <MoveUpDownIcon className={className} />;
    }
    case ICONS.CHECK: {
      return <CheckIcon className={className} />;
    }
    case ICONS.FULL_SCREEN: {
      return <FullScreenIcon className={className} />;
    }
    case ICONS.AIR_PLAY: {
      return <AirPlayIcon className={className} />;
    }
    case ICONS.EyeIcon: {
      return <EyeIcon className={className} />;
    }
    case ICONS.SimpleArrowUp: {
      return <SimpleArrowUp className={className} />;
    }
    case ICONS.SimpleArrowRight: {
      return <SimpleArrowRight className={className} />;
    }
    case ICONS.DoubleArrowUp: {
      return <DoubleArrowUp className={className} />;
    }
    case ICONS.Garbage: {
      return <Garbage className={className} />;
    }
    case ICONS.Validate: {
      return <Validate className={className} />;
    }
    case ICONS.DELETE_ICON: {
      return <DeleteIcon className={className} />;
    }
    case ICONS.SWITCH_SLIDE: {
      return <SwitchSlideIcon className={className} />;
    }
    case ICONS.REPEAT_ICON: {
      return <RepeatIcon className={className} />;
    }
    case ICONS.EDIT_ICON: {
      return <EditIcon className={className} />;
    }
    case ICONS.EXIT_ICON: {
      return <ExitIcone className={className} />;
    }
    case ICONS.MIC_ICONE: {
      return <MicIcon className={className} />;
    }
    case ICONS.PAUSE_ICONE: {
      return <PauseIcon className={className} />;
    }
    case ICONS.STOP_ICONE: {
      return <StopIcon className={className} />;
    }
    case ICONS.PLUS_ICON: {
      return <PlusIcon className={className} />;
    }
    case ICONS.LOOP_ICON: {
      return <LoopIcon className={className} />;
    }
    case ICONS.SIMPLE_PLUS_ICON: {
      return <SimplePlusIcon className={className} />;
    }
    case ICONS.DUPLICATE_ICON: {
      return <DuplicateIcon className={className} />;
    }
    case ICONS.CreateSlide: {
      return <CreateSlideIcon className={className} />;
    }
    case ICONS.MODELE_SLIDE: {
      return <ModeleSlideIcon className={className} />;
    }
    case ICONS.CloseIcon: {
      return <CloseIcon className={className} />;
    }
    case ICONS.CheckAuthorisationIcon: {
      return <CheckAuthorisationIcon className={className} />;
    }
    case ICONS.AddIcon: {
      return <AddIcon className={className} />;
    }
    case ICONS.DashboardList: {
      return <DashboardList className={className} />;
    }
    // Dashboard Components Icons
    case ICONS.ThreeDots: {
      return <ThreeDots className={className} />;
    }
    case ICONS.DollarMoneyBagWithCoinStacks: {
      return <DollarMoneyBagWithCoinStacks className={className} />;
    }
    case ICONS.PiggyBank: {
      return <PiggyBank className={className} />;
    }
    case ICONS.ProfitBarChartIcon: {
      return <ProfitBarChartIcon className={className} />;
    }
    case ICONS.DeficitBarChartIcon: {
      return <DeficitBarChartIcon className={className} />;
    }
    case ICONS.TrafficLight: {
      return <TrafficLight className={className} />;
    }
    case ICONS.Pause: {
      return <Pause className={className} />;
    }
    case ICONS.PENCIL: {
      return <PencilIcon className={className} />;
    }
    case ICONS.Collaborator: {
      return <Collaborator className={className} />;
    }
    case ICONS.BriefCase: {
      return <BriefCase className={className} />;
    }
    case ICONS.ALERT_CIRCLE: {
      return <AlertCircleIcon className={className} />;
    }
    case ICONS.Euro: {
      return <Euro className={className} />;
    }
    case ICONS.FolderFilter: {
      return <FolderFilter className={className} color={color} />;
    }
    case ICONS.Google: {
      return <GoogleIcon className={className} />;
    }
    case ICONS.Office365: {
      return <Office365Icon className={className} />;
    }
    case ICONS.Outlook: {
      return <OutlookIcon className={className} />;
    }
    case ICONS.Calendar: {
      return <AgendaIcon className={className} />;
    }
    case ICONS.Share: {
      return <ShareIcon className={className} />;
    }
    case ICONS.Lock: {
      return <LockIcon className={className} />;
    }
    case ICONS.Unshared: {
      return <UnsharedIcon className={className} />;
    }
    case ICONS.Duplicated: {
      return <DuplicatedIcon className={className} />;
    }
    case ICONS.Original: {
      return <OriginalIcon className={className} />;
    }
    case ICONS.CheckMarkCircleIcon: {
      return <CheckMarkCircleIcon className={className} />;
    }
    case ICONS.InfoCircleIcon: {
      return <InfoCircleIcon className={className} />;
    }
    case ICONS.Standard: {
      return <StandardIcon className={className} />;
    }
    case ICONS.SyncIcon: {
      return <SyncIcon className={className} fill={color} />;
    }
  }
}

export function SyncIcon({ className, fill }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="15"
      height="15"
      viewBox="0 0 50 50"
      className={className}
    >
      <path
        d="M 25 5 C 13.964844 5 5 13.964844 5 25 C 4.996094 25.359375 5.183594 25.695313 5.496094 25.878906 C 5.808594 26.058594 6.191406 26.058594 6.503906 25.878906 C 6.816406 25.695313 7.003906 25.359375 7 25 C 7 15.046875 15.046875 7 25 7 C 31.246094 7 36.726563 10.179688 39.957031 15 L 33 15 C 32.640625 14.996094 32.304688 15.183594 32.121094 15.496094 C 31.941406 15.808594 31.941406 16.191406 32.121094 16.503906 C 32.304688 16.816406 32.640625 17.003906 33 17 L 43 17 L 43 7 C 43.003906 6.730469 42.898438 6.46875 42.707031 6.277344 C 42.515625 6.085938 42.253906 5.980469 41.984375 5.984375 C 41.433594 5.996094 40.992188 6.449219 41 7 L 41 13.011719 C 37.347656 8.148438 31.539063 5 25 5 Z M 43.984375 23.984375 C 43.433594 23.996094 42.992188 24.449219 43 25 C 43 34.953125 34.953125 43 25 43 C 18.753906 43 13.269531 39.820313 10.042969 35 L 17 35 C 17.359375 35.007813 17.695313 34.816406 17.878906 34.507813 C 18.058594 34.195313 18.058594 33.808594 17.878906 33.496094 C 17.695313 33.1875 17.359375 32.996094 17 33 L 8.445313 33 C 8.316406 32.976563 8.1875 32.976563 8.058594 33 L 7 33 L 7 43 C 6.996094 43.359375 7.183594 43.695313 7.496094 43.878906 C 7.808594 44.058594 8.191406 44.058594 8.503906 43.878906 C 8.816406 43.695313 9.003906 43.359375 9 43 L 9 36.984375 C 12.648438 41.847656 18.460938 45 25 45 C 36.035156 45 45 36.035156 45 25 C 45.003906 24.730469 44.898438 24.46875 44.707031 24.277344 C 44.515625 24.085938 44.253906 23.980469 43.984375 23.984375 Z"
        fill={fill}
      />
    </svg>
  );
}

export function ClientListIcon({ className }) {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.102 17.7803C36.5332 17.2556 35.7594 16.9314 34.979 16.8908C34.0927 16.845 33.2624 17.161 32.644 17.7797L28.4187 21.9606C28.3352 21.8159 28.2398 21.6794 28.1329 21.5527C27.613 20.9355 26.8529 20.5957 25.9927 20.5957H20.0778C18.9625 20.5957 17.8744 20.451 16.8441 20.166C14.1577 19.423 11.5914 19.9657 9.4219 21.7365C8.53969 22.4567 7.89607 23.24 7.48903 23.8112L6.42851 22.782C6.28906 22.6466 6.10003 22.5697 5.9055 22.5697C5.90376 22.5697 5.90231 22.5697 5.90057 22.5697C5.69908 22.5712 5.50425 22.655 5.36451 22.7999L0.208919 28.1521C0.0709186 28.2953 -0.00416986 28.4878 0.000178893 28.6867C0.00452765 28.8859 0.0877339 29.0749 0.231823 29.212L8.95166 37.515C9.09633 37.6527 9.28187 37.7214 9.46713 37.7214C9.66167 37.7214 9.8562 37.6457 10.0026 37.4955L15.1101 32.2556C15.2495 32.1124 15.3269 31.9167 15.3232 31.7166C15.3194 31.5195 15.2368 31.3293 15.0953 31.1919L14.6506 30.7605L15.6685 30.646C16.2842 30.5743 16.9105 30.5381 17.5303 30.5381H26.5296C27.992 30.5381 29.234 30.2183 30.2214 29.5875C30.2295 29.5822 30.2377 29.5767 30.2458 29.5712C30.5995 29.3254 30.9204 29.034 31.1993 28.7055L37.2638 21.571C38.3017 20.3501 38.2368 18.8266 37.102 17.7803ZM9.44771 35.923L1.80723 28.6478L5.92318 24.3748L13.519 31.7459L9.44771 35.923ZM36.1247 20.6026L30.0602 27.7375C29.8677 27.9639 29.6471 28.1651 29.4039 28.3356C28.6625 28.805 27.6957 29.0433 26.5296 29.0433H17.53C16.8531 29.0433 16.1686 29.083 15.4986 29.161L13.261 29.4121L8.57593 24.8656C8.9015 24.3829 9.50018 23.6027 10.3673 22.8947C12.17 21.4231 14.2151 20.9897 16.4454 21.6069C17.6057 21.9279 18.8277 22.0908 20.0778 22.0908H25.9927C27.055 22.0908 27.3385 23.011 27.3385 23.5546C27.3385 23.9518 27.2109 24.3298 26.9886 24.5919C26.7473 24.8757 26.4044 25.0195 25.9692 25.0195H20.8203C20.4074 25.0195 20.0729 25.3544 20.0729 25.7672C20.0729 26.1801 20.4074 26.5146 20.8203 26.5146H25.9692C26.8384 26.5146 27.6049 26.1754 28.1279 25.5596C28.5631 25.0477 28.8113 24.3745 28.8321 23.6549L33.6984 18.8397C34.3939 18.1442 35.4805 18.3187 36.0885 18.8794C36.4027 19.1693 36.8254 19.7784 36.1247 20.6026Z"
        fill="#3C4E64"
      />
      <path
        d="M18.489 25.568C18.3948 25.1659 17.9927 24.9168 17.5906 25.0108C17.1888 25.105 16.9392 25.5071 17.0337 25.9092L17.0406 25.9397C17.1215 26.2841 17.4285 26.5166 17.7677 26.5166C17.8243 26.5166 17.8817 26.5102 17.9391 26.4969C18.3412 26.4027 18.5905 26.0003 18.4963 25.5984L18.489 25.568Z"
        fill="#3C4E64"
      />
      <path
        d="M5.05263 16.0684H12.3365C12.7331 16.0684 13.1001 15.9396 13.3988 15.7222C13.6974 15.9396 14.0644 16.0684 14.461 16.0684H21.7452C22.1418 16.0684 22.5088 15.9396 22.8074 15.7222C23.1061 15.9396 23.4731 16.0684 23.8697 16.0684H31.1536C32.1515 16.0684 32.9632 15.2563 32.9632 14.2584V10.8617C32.9632 9.3362 32.1094 8.01099 30.8315 7.35722C31.4507 6.6104 31.8236 5.65251 31.8236 4.60881C31.8236 2.2312 29.8892 0.296875 27.5116 0.296875C25.134 0.296875 23.1997 2.2312 23.1997 4.60881C23.1997 5.65251 23.5725 6.61069 24.1918 7.35722C23.6395 7.64018 23.1666 8.04868 22.8074 8.54415C22.4482 8.04839 21.9754 7.63989 21.4228 7.35722C22.0421 6.61069 22.4149 5.65251 22.4149 4.60881C22.4149 2.2312 20.4806 0.296875 18.103 0.296875C15.7253 0.296875 13.791 2.2312 13.791 4.60881C13.791 5.65251 14.1641 6.61069 14.7834 7.35751C14.2308 7.64018 13.758 8.04868 13.3988 8.54444C13.0396 8.04868 12.5667 7.64018 12.0141 7.35722C12.6334 6.61069 13.0062 5.65251 13.0062 4.6091C13.0062 2.2312 11.0719 0.296875 8.69428 0.296875C6.31696 0.296875 4.38263 2.2312 4.38263 4.6091C4.38263 5.65251 4.75546 6.61069 5.37473 7.35751C4.09677 8.01128 3.24268 9.33678 3.24268 10.862V14.2584C3.24268 15.2563 4.05473 16.0684 5.05263 16.0684ZM27.5119 1.79198C29.065 1.79198 30.3288 3.05544 30.3288 4.60881C30.3288 6.1619 29.065 7.42565 27.5119 7.42565C25.9586 7.42565 24.6951 6.16219 24.6951 4.60881C24.6948 3.05544 25.9586 1.79198 27.5119 1.79198ZM25.5698 8.45688C26.154 8.75289 26.8135 8.92075 27.5116 8.92075C28.21 8.92075 28.8696 8.75289 29.4535 8.45688C30.6152 8.65924 31.4684 9.66033 31.4684 10.8617V14.2584C31.4684 14.4321 31.3272 14.5733 31.1536 14.5733H23.8697C23.6963 14.5733 23.5551 14.4321 23.5551 14.2584V10.8617C23.5548 9.66062 24.4084 8.65924 25.5698 8.45688ZM18.1032 1.79198C19.6563 1.79198 20.9201 3.05544 20.9201 4.60881C20.9201 6.1619 19.6563 7.42565 18.1032 7.42565C16.5499 7.42565 15.2864 6.16219 15.2864 4.60881C15.2864 3.05544 16.5499 1.79198 18.1032 1.79198ZM16.1614 8.45688C16.7453 8.75289 17.4048 8.92075 18.1032 8.92075C18.8017 8.92075 19.4609 8.75289 20.0451 8.45688C21.2065 8.65924 22.06 9.66033 22.06 10.8617V14.2584C22.06 14.4321 21.9188 14.5733 21.7452 14.5733H14.4613C14.2876 14.5733 14.1465 14.4321 14.1465 14.2584V10.8617C14.1465 9.66062 15 8.65924 16.1614 8.45688ZM8.69457 1.79198C10.2477 1.79198 11.5114 3.05544 11.5114 4.60881C11.5114 6.1619 10.2477 7.42565 8.69457 7.42565C7.14148 7.42565 5.87773 6.1619 5.87773 4.60881C5.87773 3.05544 7.14148 1.79198 8.69457 1.79198ZM4.73778 10.8617C4.73778 9.66062 5.59129 8.65924 6.7527 8.45688C7.33689 8.75289 7.99616 8.92075 8.69457 8.92075C9.39298 8.92075 10.0522 8.75289 10.6364 8.45688C11.7981 8.65924 12.6514 9.66033 12.6514 10.8617V14.2584C12.6514 14.4321 12.5102 14.5733 12.3365 14.5733H5.05263C4.87897 14.5733 4.73778 14.4321 4.73778 14.2584V10.8617Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function ArrowLeftIcon({ className, width, height }) {
  return (
    <svg
      width={width ? width : "14"}
      height={height ? height : "13"}
      viewBox="0 0 14 13"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.259444 6.71442L5.55299 11.9383C5.89429 12.2761 6.44627 12.2717 6.78408 11.9296C7.1219 11.5874 7.11842 11.0363 6.77536 10.6985L2.99241 6.96518L13.1294 6.96518C13.6108 6.96518 14 6.57601 14 6.09455C14 5.61309 13.6108 5.22388 13.1294 5.22388L2.99241 5.22388L6.77536 1.49056C7.11838 1.15274 7.121 0.601627 6.78408 0.259469C6.61345 0.0870787 6.38881 2.45072e-05 6.16418 2.45269e-05C5.94302 2.45462e-05 5.7219 0.0835979 5.55299 0.250788L0.259444 5.47468C0.0940155 5.63835 -5.53185e-07 5.86127 -5.32787e-07 6.09459C-5.12397e-07 6.32783 0.0931554 6.54985 0.259444 6.71442Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function RepeatIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_51947_36377)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.8618 0.195262C11.1221 -0.0650874 11.5442 -0.0650874 11.8046 0.195262L14.4712 2.86193C14.7316 3.12228 14.7316 3.54439 14.4712 3.80474L11.8046 6.4714C11.5442 6.73175 11.1221 6.73175 10.8618 6.4714C10.6014 6.21105 10.6014 5.78894 10.8618 5.5286L13.057 3.33333L10.8618 1.13807C10.6014 0.877722 10.6014 0.455612 10.8618 0.195262Z"
          fill="#18A0FB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.66683 4.00033C4.1364 4.00033 3.62769 4.21104 3.25262 4.58611C2.87754 4.96118 2.66683 5.46989 2.66683 6.00033V7.33366C2.66683 7.70185 2.36835 8.00033 2.00016 8.00033C1.63197 8.00033 1.3335 7.70185 1.3335 7.33366V6.00033C1.3335 5.11627 1.68469 4.26842 2.30981 3.6433C2.93493 3.01818 3.78277 2.66699 4.66683 2.66699H14.0002C14.3684 2.66699 14.6668 2.96547 14.6668 3.33366C14.6668 3.70185 14.3684 4.00033 14.0002 4.00033H4.66683Z"
          fill="#18A0FB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.13823 9.52827C5.39858 9.78862 5.39858 10.2107 5.13823 10.4711L2.94297 12.6663L5.13823 14.8616C5.39858 15.122 5.39858 15.5441 5.13823 15.8044C4.87788 16.0648 4.45577 16.0648 4.19543 15.8044L1.52876 13.1377C1.26841 12.8774 1.26841 12.4553 1.52876 12.1949L4.19543 9.52827C4.45577 9.26792 4.87788 9.26792 5.13823 9.52827Z"
          fill="#18A0FB"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.0002 8C14.3684 8 14.6668 8.29848 14.6668 8.66667V10C14.6668 10.8841 14.3156 11.7319 13.6905 12.357C13.0654 12.9821 12.2176 13.3333 11.3335 13.3333H2.00016C1.63197 13.3333 1.3335 13.0349 1.3335 12.6667C1.3335 12.2985 1.63197 12 2.00016 12H11.3335C11.8639 12 12.3726 11.7893 12.7477 11.4142C13.1228 11.0391 13.3335 10.5304 13.3335 10V8.66667C13.3335 8.29848 13.632 8 14.0002 8Z"
          fill="#18A0FB"
        />
      </g>
      <defs>
        <clipPath id="clip0_51947_36377">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export function AlertCircleIcon({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.00016 1.74967C4.10067 1.74967 1.75016 4.10018 1.75016 6.99967C1.75016 9.89917 4.10067 12.2497 7.00016 12.2497C9.89966 12.2497 12.2502 9.89917 12.2502 6.99967C12.2502 4.10018 9.89966 1.74967 7.00016 1.74967ZM0.583496 6.99967C0.583496 3.45585 3.45634 0.583008 7.00016 0.583008C10.544 0.583008 13.4168 3.45585 13.4168 6.99967C13.4168 10.5435 10.544 13.4163 7.00016 13.4163C3.45634 13.4163 0.583496 10.5435 0.583496 6.99967Z"
        fill="#B2BCC6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.99984 4.08301C7.322 4.08301 7.58317 4.34418 7.58317 4.66634V6.99968C7.58317 7.32184 7.322 7.58301 6.99984 7.58301C6.67767 7.58301 6.4165 7.32184 6.4165 6.99968V4.66634C6.4165 4.34418 6.67767 4.08301 6.99984 4.08301Z"
        fill="#B2BCC6"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.4165 9.33333C6.4165 9.01117 6.67767 8.75 6.99984 8.75H7.00567C7.32784 8.75 7.589 9.01117 7.589 9.33333C7.589 9.6555 7.32784 9.91667 7.00567 9.91667H6.99984C6.67767 9.91667 6.4165 9.6555 6.4165 9.33333Z"
        fill="#B2BCC6"
      />
    </svg>
  );
}

export function SwitchSlideIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      fill=" #18a0fb"
      viewBox="0 0 452.025 452.025"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="M362.612,34.125h-55.2l13.6-13.6c4.7-4.7,4.7-12.3,0-17s-12.3-4.7-17,0l-34,34.1c-2.3,2.3-3.5,5.3-3.5,8.5
            s1.3,6.2,3.5,8.5l34.1,34.1c2.3,2.3,5.4,3.5,8.5,3.5s6.1-1.2,8.5-3.5c4.7-4.7,4.7-12.3,0-17l-13.6-13.6h55.2c35.9,0,65,29.2,65,65
            v40.3c0,6.6,5.4,12,12,12s12-5.4,12-12v-40.3C451.712,74.025,411.712,34.125,362.612,34.125z"
          />
          <path
            d="M438.812,230.925h-197.1c-6.6,0-12,5.4-12,12v197.1c0,6.6,5.4,12,12,12h197.1c6.6,0,12-5.4,12-12v-197.1
            C450.812,236.225,445.412,230.925,438.812,230.925z M426.812,428.025h-173.1v-173.1h173.1L426.812,428.025L426.812,428.025z"
          />
          <path
            d="M147.912,363.325c-4.7-4.7-12.3-4.7-17,0c-4.7,4.7-4.7,12.3,0,17l13.6,13.6h-55.2c-35.9,0-65-29.2-65-65v-40.3
            c0-6.6-5.4-12-12-12s-12,5.4-12,12v40.3c0,49.1,39.9,89,89,89h55.2l-13.6,13.6c-4.7,4.7-4.7,12.3,0,17c2.3,2.3,5.4,3.5,8.5,3.5
            s6.1-1.2,8.5-3.5l34.1-34.1c4.7-4.7,4.7-12.3,0-17L147.912,363.325z"
          />
          <path
            d="M13.212,24.025c3.2,0,6.3-1.3,8.5-3.5s3.5-5.3,3.5-8.5c0-3.1-1.3-6.3-3.5-8.5s-5.3-3.5-8.5-3.5s-6.3,1.3-8.5,3.5
            s-3.5,5.3-3.5,8.5s1.3,6.3,3.5,8.5C7.012,22.725,10.012,24.025,13.212,24.025z"
          />
          <path d="M111.812,24.025c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S105.112,24.025,111.812,24.025z" />
          <path d="M62.512,24.025c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S55.912,24.025,62.512,24.025z" />
          <path d="M161.012,24.025c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S154.412,24.025,161.012,24.025z" />
          <path
            d="M210.312,0.025c-3.1,0-6.3,1.3-8.5,3.5s-3.5,5.3-3.5,8.5s1.3,6.3,3.5,8.5s5.3,3.5,8.5,3.5s6.3-1.3,8.5-3.5
            s3.5-5.3,3.5-8.5s-1.3-6.3-3.5-8.5S213.512,0.025,210.312,0.025z"
          />
          <path d="M210.312,147.925c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C222.312,153.225,217.012,147.925,210.312,147.925z" />
          <path d="M210.312,98.625c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C222.312,103.925,217.012,98.625,210.312,98.625z" />
          <path d="M210.312,49.325c-6.6,0-12,5.4-12,12s5.4,12,12,12s12-5.4,12-12C222.312,54.725,217.012,49.325,210.312,49.325z" />
          <path
            d="M210.312,197.125c-3.2,0-6.3,1.3-8.5,3.5s-3.5,5.3-3.5,8.5c0,3.1,1.3,6.3,3.5,8.5s5.3,3.5,8.5,3.5s6.3-1.3,8.5-3.5
            s3.5-5.3,3.5-8.5s-1.3-6.3-3.5-8.5C216.613,198.425,213.512,197.125,210.312,197.125z"
          />
          <path d="M161.012,221.125c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12C149.012,215.825,154.412,221.125,161.012,221.125z" />
          <path d="M111.812,221.125c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12C99.812,215.825,105.112,221.125,111.812,221.125z" />
          <path d="M62.512,221.125c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12C50.512,215.825,55.912,221.125,62.512,221.125z" />
          <path
            d="M13.212,221.125c3.2,0,6.3-1.3,8.5-3.5s3.5-5.3,3.5-8.5s-1.3-6.3-3.5-8.5s-5.3-3.5-8.5-3.5s-6.3,1.3-8.5,3.5
            s-3.5,5.3-3.5,8.5c0,3.1,1.3,6.3,3.5,8.5C7.012,219.825,10.012,221.125,13.212,221.125z"
          />
          <path d="M13.212,171.925c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S6.612,171.925,13.212,171.925z" />
          <path d="M13.212,122.625c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12C1.212,117.225,6.612,122.625,13.212,122.625z" />
          <path d="M13.212,73.325c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S6.612,73.325,13.212,73.325z" />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}

export function MaximizeIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6666 2.50033C11.6666 2.04009 12.0397 1.66699 12.5 1.66699H17.5C17.9602 1.66699 18.3333 2.04009 18.3333 2.50033V7.50032C18.3333 7.96056 17.9602 8.33366 17.5 8.33366C17.0397 8.33366 16.6666 7.96056 16.6666 7.50032V3.33366H12.5C12.0397 3.33366 11.6666 2.96056 11.6666 2.50033Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.49996 11.667C2.9602 11.667 3.33329 12.0401 3.33329 12.5003V16.667H7.49996C7.9602 16.667 8.33329 17.0401 8.33329 17.5003C8.33329 17.9606 7.9602 18.3337 7.49996 18.3337H2.49996C2.03972 18.3337 1.66663 17.9606 1.66663 17.5003V12.5003C1.66663 12.0401 2.03972 11.667 2.49996 11.667Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0893 1.91107C18.4147 2.23651 18.4147 2.76414 18.0893 3.08958L12.256 8.92291C11.9305 9.24835 11.4029 9.24835 11.0775 8.92291C10.752 8.59748 10.752 8.06984 11.0775 7.7444L16.9108 1.91107C17.2362 1.58563 17.7639 1.58563 18.0893 1.91107Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92255 11.0771C9.24799 11.4025 9.24799 11.9302 8.92255 12.2556L3.08922 18.0889C2.76378 18.4144 2.23614 18.4144 1.9107 18.0889C1.58527 17.7635 1.58527 17.2359 1.9107 16.9104L7.74404 11.0771C8.06947 10.7516 8.59711 10.7516 8.92255 11.0771Z"
        fill="white"
      />
    </svg>
  );
}

export function MinimizeIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4993 2.83398C10.9596 2.83398 11.3327 3.20708 11.3327 3.66732V7.83398H15.4993C15.9596 7.83398 16.3327 8.20708 16.3327 8.66732C16.3327 9.12755 15.9596 9.50065 15.4993 9.50065H10.4993C10.0391 9.50065 9.66602 9.12755 9.66602 8.66732V3.66732C9.66602 3.20708 10.0391 2.83398 10.4993 2.83398Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.83203 11.0003C2.83203 10.5401 3.20513 10.167 3.66536 10.167H8.66536C9.1256 10.167 9.4987 10.5401 9.4987 11.0003V16.0003C9.4987 16.4606 9.1256 16.8337 8.66536 16.8337C8.20513 16.8337 7.83203 16.4606 7.83203 16.0003V11.8337H3.66536C3.20513 11.8337 2.83203 11.4606 2.83203 11.0003Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.25592 10.4111C9.58136 10.7365 9.58136 11.2641 9.25592 11.5896L3.42259 17.4229C3.09715 17.7484 2.56951 17.7484 2.24408 17.4229C1.91864 17.0975 1.91864 16.5698 2.24408 16.2444L8.07741 10.4111C8.40285 10.0856 8.93049 10.0856 9.25592 10.4111Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9219 2.24408C17.2474 2.56951 17.2474 3.09715 16.9219 3.42259L11.0886 9.25592C10.7632 9.58136 10.2355 9.58136 9.91009 9.25592C9.58466 8.93049 9.58466 8.40285 9.91009 8.07741L15.7434 2.24408C16.0689 1.91864 16.5965 1.91864 16.9219 2.24408Z"
        fill="white"
      />
    </svg>
  );
}

export function MicIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 490.9 490.9"
    >
      <g>
        <g>
          <path
            d="M245.5,322.9c53,0,96.2-43.2,96.2-96.2V96.2c0-53-43.2-96.2-96.2-96.2s-96.2,43.2-96.2,96.2v130.5
            C149.3,279.8,192.5,322.9,245.5,322.9z M173.8,96.2c0-39.5,32.2-71.7,71.7-71.7s71.7,32.2,71.7,71.7v130.5
            c0,39.5-32.2,71.7-71.7,71.7s-71.7-32.2-71.7-71.7V96.2z"
          />
          <path
            d="M94.4,214.5c-6.8,0-12.3,5.5-12.3,12.3c0,85.9,66.7,156.6,151.1,162.8v76.7h-63.9c-6.8,0-12.3,5.5-12.3,12.3
            s5.5,12.3,12.3,12.3h152.3c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3h-63.9v-76.7c84.4-6.3,151.1-76.9,151.1-162.8
            c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3c0,76.6-62.3,138.9-138.9,138.9s-138.9-62.3-138.9-138.9
            C106.6,220,101.2,214.5,94.4,214.5z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}

export function ExitIcone({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="18"
      height="18"
      viewBox="0 0 56 56"
    >
      <g>
        <path
          d="M54.424,28.382c0.101-0.244,0.101-0.519,0-0.764c-0.051-0.123-0.125-0.234-0.217-0.327L42.208,15.293
          c-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L51.087,27H20.501c-0.552,0-1,0.447-1,1s0.448,1,1,1h30.586L40.794,39.293
          c-0.391,0.391-0.391,1.023,0,1.414C40.989,40.902,41.245,41,41.501,41s0.512-0.098,0.707-0.293l11.999-11.999
          C54.299,28.616,54.373,28.505,54.424,28.382z"
        />
        <path
          d="M36.501,33c-0.552,0-1,0.447-1,1v20h-32V2h32v20c0,0.553,0.448,1,1,1s1-0.447,1-1V1c0-0.553-0.448-1-1-1h-34
          c-0.552,0-1,0.447-1,1v54c0,0.553,0.448,1,1,1h34c0.552,0,1-0.447,1-1V34C37.501,33.447,37.053,33,36.501,33z"
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}

export function PauseIcon({ className }) {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M384 810.666667c-25.6 0-42.666667-17.066667-42.666667-42.666667L341.333333 256c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667l0 512C426.666667 793.6 409.6 810.666667 384 810.666667z" />
      <path d="M640 810.666667c-25.6 0-42.666667-17.066667-42.666667-42.666667L597.333333 256c0-25.6 17.066667-42.666667 42.666667-42.666667s42.666667 17.066667 42.666667 42.666667l0 512C682.666667 793.6 665.6 810.666667 640 810.666667z" />
    </svg>
  );
}

export function StopIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 1024 1024"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M256 192h512c35.392 0 64 28.608 64 64v512c0 35.392-28.608 64-64 64H256c-35.392 0-64-28.608-64-64V256c0-35.392 28.608-64 64-64z"
        fill=""
      />
    </svg>
  );
}

export function OpenEyeIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8215 4.52681C14.988 3.16372 13.8674 2.06848 12.4598 1.24113C11.052 0.41374 9.56549 0 8 0C6.43451 0 4.94793 0.413583 3.54018 1.24113C2.1324 2.06848 1.01183 3.16372 0.178505 4.52681C0.0595122 4.73511 0 4.94048 0 5.14291C0 5.34534 0.0595122 5.55071 0.178505 5.75896C1.01183 7.12211 2.1324 8.21744 3.54018 9.0446C4.94793 9.87208 6.43451 10.2855 8 10.2855C9.56552 10.2855 11.052 9.87346 12.4598 9.04911C13.8674 8.22472 14.9882 7.12796 15.8215 5.75896C15.9405 5.55071 16 5.34543 16 5.14291C16 4.94048 15.9405 4.73511 15.8215 4.52681ZM6.08469 2.0848C6.6174 1.5521 7.25577 1.28566 7.99991 1.28566C8.1189 1.28566 8.22016 1.32744 8.30353 1.41072C8.38678 1.49403 8.42863 1.59526 8.42863 1.71428C8.42863 1.8334 8.38678 1.93457 8.30372 2.01775C8.22047 2.10116 8.11915 2.14281 8.00012 2.14281C7.48825 2.14281 7.05062 2.32445 6.68757 2.68746C6.3244 3.0507 6.14292 3.48814 6.14292 4.00001C6.14292 4.1192 6.10114 4.2203 6.01786 4.30367C5.93446 4.38711 5.83332 4.42873 5.7143 4.42873C5.59518 4.42873 5.49401 4.38702 5.41064 4.30367C5.32724 4.2203 5.28558 4.11907 5.28558 4.00001C5.28558 3.25603 5.55202 2.61754 6.08469 2.0848ZM11.8795 8.05823C10.686 8.78126 9.39289 9.14299 8 9.14299C6.60714 9.14299 5.31401 8.78148 4.12057 8.05823C2.92714 7.33498 1.93457 6.36324 1.14293 5.14291C2.04768 3.7381 3.18161 2.68743 4.54469 1.99114C4.18162 2.61009 4.00002 3.2798 4.00002 3.99998C4.00002 5.10129 4.39146 6.04301 5.17412 6.82586C5.95679 7.60871 6.89885 7.99997 8 7.99997C9.10124 7.99997 10.043 7.60849 10.8259 6.82586C11.6087 6.04323 12 5.10129 12 3.99998C12 3.2798 11.8184 2.61 11.4553 1.99114C12.8183 2.68743 13.9523 3.7382 14.857 5.14291C14.0655 6.36324 13.073 7.33498 11.8795 8.05823Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function CloseEyeIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.2946 9.12084C11.7648 8.43921 12.0001 7.68473 12.0001 6.85747C12.0001 6.62536 11.9763 6.37534 11.9286 6.10742L9.42871 10.5895C10.2023 10.292 10.8244 9.80214 11.2946 9.12084Z"
          fill="white"
        />
        <path
          d="M11.6608 2.9462C11.6667 2.93438 11.6695 2.90758 11.6695 2.86589C11.6695 2.76466 11.6219 2.68445 11.5266 2.62462C11.5088 2.61274 11.4508 2.5785 11.3524 2.52183C11.2543 2.46538 11.1604 2.41028 11.0713 2.35665C10.9821 2.30308 10.884 2.24807 10.7767 2.19153C10.6695 2.13495 10.5773 2.08883 10.5 2.05308C10.4225 2.0174 10.369 1.99951 10.3393 1.99951C10.2321 1.99951 10.1488 2.0472 10.0893 2.1424L9.60727 3.00853C9.06575 2.90739 8.52989 2.85673 8.00012 2.85673C6.39892 2.85673 4.92275 3.26159 3.57148 4.07108C2.22031 4.8807 1.08942 5.98479 0.178599 7.38359C0.0595122 7.56826 0 7.77362 0 7.99982C0 8.22595 0.0595122 8.43142 0.178599 8.61583C0.702357 9.43121 1.32293 10.1606 2.04021 10.8033C2.75748 11.4463 3.54165 11.961 4.39283 12.3481C4.13092 12.7944 3.99998 13.0535 3.99998 13.125C3.99998 13.2321 4.04764 13.3153 4.1429 13.3748C4.86903 13.7917 5.26779 13.9998 5.33927 13.9998C5.44629 13.9998 5.5297 13.952 5.58921 13.8567L6.02671 13.0622C6.65771 11.9374 7.59811 10.2498 8.84821 7.99985C10.0983 5.74981 11.0357 4.06527 11.6608 2.9462ZM4.95537 11.3481C3.4078 10.6517 2.13687 9.53566 1.14293 7.99991C2.04768 6.59511 3.18161 5.54444 4.54469 4.84815C4.18162 5.4671 4.00002 6.13678 4.00002 6.85702C4.00002 7.49389 4.14578 8.09792 4.43752 8.66943C4.7292 9.24091 5.13397 9.71394 5.65185 10.089L4.95537 11.3481ZM8.30372 4.87467C8.22047 4.95807 8.11902 4.99973 8 4.99973C7.48813 4.99973 7.05052 5.18136 6.68745 5.54438C6.32428 5.90761 6.1428 6.34505 6.1428 6.85692C6.1428 6.97611 6.10102 7.07721 6.01774 7.16058C5.9343 7.24399 5.83317 7.28564 5.71417 7.28564C5.59506 7.28564 5.49386 7.24393 5.41051 7.16058C5.32711 7.07721 5.28545 6.97598 5.28545 6.85692C5.28545 6.11295 5.5519 5.47448 6.08457 4.94172C6.61727 4.40902 7.25564 4.1426 7.99975 4.1426C8.11877 4.1426 8.22 4.18438 8.3035 4.26766C8.38675 4.35097 8.42847 4.4522 8.42847 4.57123C8.4285 4.69032 8.38678 4.79151 8.30372 4.87467Z"
          fill="white"
        />
        <path
          d="M15.8214 7.38339C15.482 6.81798 15.052 6.27027 14.5312 5.74051C14.0107 5.21078 13.4673 4.75554 12.9017 4.37451L12.3392 5.37452C13.3333 6.05902 14.1726 6.9341 14.857 7.99953C14.137 9.11853 13.2395 10.0323 12.1654 10.7405C11.0909 11.4492 9.92272 11.8567 8.66077 11.9638L8 13.1424C9.3215 13.1424 10.57 12.8597 11.7455 12.2942C12.9211 11.7289 13.9555 10.9342 14.8483 9.91045C15.2649 9.42819 15.5893 8.99669 15.8215 8.61573C15.9406 8.4132 16 8.20774 16 7.99959C16 7.79128 15.9405 7.58591 15.8214 7.38339Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function BalanceSheetIcon({ className }) {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6685 19H12.1421C11.7323 19 11.3999 19.3323 11.3999 19.7422C11.3999 20.1521 11.7323 20.4844 12.1421 20.4844H23.6685C24.0784 20.4844 24.4107 20.1521 24.4107 19.7422C24.4107 19.3323 24.0784 19 23.6685 19Z"
        fill="#3C4E64"
      />
      <path
        d="M23.6685 24.3438H12.1421C11.7323 24.3438 11.3999 24.676 11.3999 25.0859C11.3999 25.4958 11.7323 25.8281 12.1421 25.8281H23.6685C24.0784 25.8281 24.4107 25.4958 24.4107 25.0859C24.4107 24.676 24.0784 24.3438 23.6685 24.3438Z"
        fill="#3C4E64"
      />
      <path
        d="M23.6685 29.6875H12.1421C11.7323 29.6875 11.3999 30.0198 11.3999 30.4297C11.3999 30.8396 11.7323 31.1719 12.1421 31.1719H23.6685C24.0784 31.1719 24.4107 30.8396 24.4107 30.4297C24.4107 30.0198 24.0784 29.6875 23.6685 29.6875Z"
        fill="#3C4E64"
      />
      <path
        d="M33.2429 14.9561C33.2428 14.9533 33.2423 14.9505 33.2421 14.9477C33.2412 14.9359 33.2399 14.9254 33.2382 14.9158C33.2209 14.7498 33.1496 14.5905 33.0266 14.4674L25.3078 6.74864C25.1734 6.6143 24.9962 6.54001 24.8138 6.53244C24.8043 6.5317 24.7944 6.53125 24.783 6.53125H19.7485V5.19531C19.7485 2.33062 17.418 0 14.5532 0C11.6885 0 9.35791 2.33062 9.35791 5.19531V6.53125H7.7251C6.08813 6.53125 4.75635 7.86303 4.75635 9.5V35.0312C4.75635 36.6682 6.08813 38 7.7251 38H30.2752C31.9122 38 33.244 36.6682 33.244 35.0312V14.9922C33.244 14.9792 33.2435 14.9673 33.2429 14.9561ZM25.5252 9.06523L30.7098 14.25H27.195C26.2743 14.25 25.5251 13.5009 25.5251 12.5801V9.06523H25.5252ZM14.5531 1.48438C16.5994 1.48438 18.2641 3.1491 18.2641 5.19531V11.9905C18.2641 13.2364 17.2505 14.25 16.0046 14.25C14.7587 14.25 13.7451 13.2364 13.7451 11.9905V5.14032C13.7451 4.70376 14.1002 4.34862 14.5367 4.34862C14.9732 4.34862 15.3284 4.70376 15.3284 5.14032V11.8997C15.3284 12.3096 15.6607 12.6419 16.0706 12.6419C16.4804 12.6419 16.8127 12.3096 16.8127 11.8997V5.14032C16.8127 3.88528 15.7917 2.86425 14.5367 2.86425C13.2817 2.86425 12.2607 3.88528 12.2607 5.14032V6.53125H10.8423V5.19531H10.8422C10.8422 3.1491 12.5069 1.48438 14.5531 1.48438ZM31.7594 35.0312C31.7596 35.8497 31.0937 36.5156 30.2752 36.5156H7.72502C6.90654 36.5156 6.24065 35.8497 6.24065 35.0312V9.5C6.24065 8.68152 6.90654 8.01562 7.72502 8.01562H12.2606V11.9905C12.2606 14.0549 13.9401 15.7344 16.0045 15.7344C18.0689 15.7344 19.7484 14.0549 19.7484 11.9905V8.01562H24.0407V12.5801C24.0407 14.3194 25.4557 15.7344 27.195 15.7344H31.7594V35.0312V35.0312Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function SettingIcon({ className, fill, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "26"}
      height={size ? size : "26"}
      viewBox="0 0 26 26"
      fill={fill ? fill : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.6692 15.7284L22.8442 16.0379C22.6541 16.6517 22.4097 17.2437 22.111 17.8086L23.1864 19.313C23.6426 19.9539 23.572 20.8284 23.0126 21.3824L21.3941 23.0009C21.0899 23.3051 20.688 23.4734 20.2589 23.4734C19.9222 23.4734 19.6017 23.3703 19.3302 23.1747L17.8202 22.0993C17.2337 22.4089 16.6199 22.6642 15.9844 22.8543L15.6803 24.6575C15.5499 25.4342 14.8819 25.999 14.0943 25.999H11.8077C11.0202 25.999 10.3521 25.4342 10.2218 24.6575L9.90677 22.8108C9.29846 22.6207 8.70644 22.3709 8.14158 22.0667L6.64796 23.1421C6.3764 23.3377 6.05052 23.4409 5.71377 23.4409C5.2847 23.4409 4.87735 23.2725 4.57862 22.9683L2.95465 21.3498C2.40065 20.7958 2.32462 19.9214 2.78085 19.2805L3.86712 17.7542C3.56839 17.184 3.32941 16.5919 3.14475 15.9782L1.34154 15.674C0.56486 15.5437 0 14.8756 0 14.0881V11.8015C0 11.0139 0.56486 10.3459 1.34154 10.2155L3.1882 9.90052C3.3783 9.29221 3.62814 8.7002 3.93229 8.13534L2.86232 6.64715C2.40609 6.00625 2.47669 5.13181 3.03612 4.57781L4.65466 2.95927C4.95882 2.65512 5.36074 2.48674 5.78981 2.48674C6.12655 2.48674 6.447 2.58994 6.71857 2.78547L8.24478 3.87173C8.79334 3.58387 9.36907 3.35032 9.96108 3.16566L10.2652 1.34073C10.3956 0.564047 11.0636 -0.000812531 11.8512 -0.000812531H14.1432C14.9308 -0.000812531 15.5988 0.564047 15.7292 1.34073L16.0388 3.16566C16.6525 3.35576 17.2445 3.60017 17.8094 3.89889L19.3139 2.82349C19.5854 2.62796 19.9113 2.52476 20.248 2.52476C20.6771 2.52476 21.079 2.69313 21.3832 2.99729L23.0017 4.61583C23.5557 5.16983 23.6318 6.04427 23.1755 6.68517L22.1001 8.19508C22.3989 8.76538 22.6487 9.35739 22.8334 9.9657L24.6583 10.2699C25.435 10.4002 25.9998 11.0683 25.9998 11.8558V14.1424C26.0107 14.9299 25.4458 15.598 24.6692 15.7284ZM24.5442 11.8558C24.5442 11.7852 24.4954 11.7255 24.4248 11.7146L22.1436 11.3344C21.8557 11.2855 21.6276 11.0737 21.557 10.7967C21.3506 9.99829 21.0356 9.23247 20.6119 8.52096C20.4653 8.27112 20.4762 7.96153 20.6445 7.72256L21.9861 5.83245C22.0241 5.77814 22.0187 5.69667 21.9698 5.64778L20.3512 4.02924C20.3132 3.99122 20.2752 3.98579 20.248 3.98579C20.2155 3.98579 20.1883 3.99666 20.1666 4.01295L18.2819 5.35449C18.0484 5.52286 17.7333 5.53373 17.4835 5.38708C16.772 4.96343 16.0062 4.64842 15.2078 4.44203C14.9253 4.37142 14.7135 4.13787 14.6701 3.85544L14.2844 1.57428C14.2736 1.50367 14.2138 1.45479 14.1432 1.45479H11.8566C11.786 1.45479 11.7263 1.50367 11.7154 1.57428L11.3352 3.85544C11.2863 4.1433 11.0745 4.37142 10.7975 4.44203C10.0208 4.64298 9.2713 4.95257 8.57066 5.35449C8.4566 5.41967 8.32625 5.45226 8.20133 5.45226C8.05468 5.45226 7.9026 5.4088 7.77768 5.31647L5.87671 3.96407C5.84956 3.94777 5.8224 3.93691 5.79524 3.93691C5.77352 3.93691 5.73007 3.94234 5.69205 3.98036L4.07351 5.5989C4.02463 5.64778 4.01919 5.72382 4.05721 5.78357L5.39332 7.65738C5.5617 7.89636 5.57256 8.21138 5.42591 8.46122C5.00227 9.16729 4.67639 9.93311 4.47 10.7315C4.39396 11.0085 4.16584 11.2203 3.88341 11.2692L1.58595 11.6603C1.51534 11.6711 1.46646 11.7309 1.46646 11.8015V14.0881C1.46646 14.1587 1.51534 14.2184 1.58595 14.2293L3.85082 14.6095C4.13868 14.6584 4.37223 14.8702 4.44284 15.1526C4.6438 15.951 4.95339 16.7223 5.3716 17.4338C5.51824 17.6836 5.50195 17.9932 5.33358 18.2268L3.98117 20.1277C3.94316 20.1821 3.94859 20.2635 3.99747 20.3124L5.61601 21.9309C5.65403 21.969 5.69205 21.9744 5.7192 21.9744C5.75179 21.9744 5.77895 21.9635 5.80067 21.9472L7.67449 20.6111C7.91347 20.4428 8.22849 20.4319 8.47833 20.5785C9.1844 21.0022 9.95022 21.3281 10.7486 21.5345C11.0256 21.6105 11.2374 21.8386 11.2863 22.121L11.6774 24.4185C11.6883 24.4891 11.748 24.538 11.8186 24.538H14.1052C14.1758 24.538 14.2355 24.4891 14.2464 24.4185L14.6266 22.1536C14.6755 21.8658 14.8873 21.6322 15.1697 21.5616C15.9899 21.3552 16.772 21.0348 17.4998 20.6057C17.7496 20.4591 18.0592 20.4699 18.2982 20.6383L20.172 21.9853C20.1992 22.0016 20.2263 22.0124 20.2535 22.0124C20.2752 22.0124 20.3187 22.007 20.3567 21.969L21.9752 20.3504C22.0241 20.3015 22.0295 20.2255 21.9915 20.1658L20.65 18.2811C20.4816 18.0475 20.4707 17.7325 20.6174 17.4827C21.041 16.7712 21.356 16.0054 21.5624 15.2069C21.633 14.9245 21.8666 14.7127 22.149 14.6692L24.4302 14.2836C24.5008 14.2728 24.5497 14.213 24.5497 14.1424V11.8558H24.5442Z" />
      <path d="M13.0032 18.6133C9.90729 18.6133 7.39258 16.0986 7.39258 13.0027C7.39258 9.90684 9.90729 7.39213 13.0032 7.39213C16.099 7.39213 18.6137 9.90684 18.6137 13.0027C18.6137 16.0986 16.099 18.6133 13.0032 18.6133ZM13.0032 8.85859C10.7166 8.85859 8.85904 10.7161 8.85904 13.0027C8.85904 15.2893 10.7166 17.1468 13.0032 17.1468C15.2897 17.1468 17.1473 15.2893 17.1473 13.0027C17.1473 10.7161 15.2897 8.85859 13.0032 8.85859Z" />
    </svg>
  );
}

export function ToolIcon({ className, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "31"}
      height={size ? size : "31"}
      viewBox={size ? `0 0 ${size} ${size}` : "0 0 31 31"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.457 3.28976C20.7728 3.21244 20.0771 3.23485 19.3919 3.35969C17.9753 3.61779 16.6711 4.30147 15.6529 5.31962C14.6348 6.33777 13.9511 7.64204 13.693 9.0586C13.4349 10.4752 13.6146 11.9367 14.2083 13.2486C14.4514 13.7858 14.3363 14.4174 13.9193 14.8343L4.13015 24.6235C3.83224 24.9214 3.66488 25.3255 3.66488 25.7468C3.66488 26.1681 3.83224 26.5721 4.13015 26.87C4.42806 27.168 4.83211 27.3353 5.25341 27.3353C5.67472 27.3353 6.07877 27.168 6.37668 26.87L16.1658 17.0809C16.5828 16.6639 17.2144 16.5488 17.7516 16.7919C19.0635 17.3856 20.525 17.5653 21.9416 17.3072C23.3582 17.0491 24.6624 16.3654 25.6806 15.3473C26.6987 14.3291 27.3824 13.0249 27.6405 11.6083C27.7654 10.9231 27.7878 10.2274 27.7104 9.54323L24.0668 13.1869C23.5372 13.706 22.825 13.9967 22.0834 13.9967C21.3418 13.9967 20.6297 13.706 20.1001 13.1868L20.09 13.1769L17.8133 10.9002C17.2942 10.3705 17.0035 9.65842 17.0035 8.91678C17.0035 8.17514 17.2942 7.46308 17.8134 6.93345L17.8233 6.92333L21.457 3.28976ZM18.884 0.572245C20.8672 0.210904 22.9134 0.462538 24.75 1.29361C25.1737 1.48534 25.4763 1.87282 25.5596 2.33034C25.643 2.78787 25.4965 3.25717 25.1677 3.58602L19.8369 8.91678L22.0834 11.1633L27.4142 5.83255C27.743 5.5037 28.2123 5.3572 28.6699 5.44056C29.1274 5.52392 29.5149 5.82653 29.7066 6.25023C30.5377 8.08678 30.7893 10.133 30.428 12.1162C30.0666 14.0994 29.1095 15.9253 27.684 17.3507C26.2586 18.7762 24.4327 19.7333 22.4495 20.0947C20.7956 20.396 19.0979 20.271 17.5145 19.7392L8.38015 28.8735C7.55089 29.7028 6.42617 30.1686 5.25341 30.1686C4.08066 30.1686 2.95594 29.7028 2.12668 28.8735C1.29742 28.0443 0.831543 26.9195 0.831543 25.7468C0.831543 24.574 1.29742 23.4493 2.12668 22.62L11.261 13.4857C10.7292 11.9023 10.6042 10.2046 10.9055 8.55072C11.2669 6.56753 12.224 4.74156 13.6495 3.31615C15.0749 1.89074 16.9008 0.933586 18.884 0.572245Z"
        fill="#B2BCC6"
      />
    </svg>
  );
}

export function SettingIconTwo({ className, fill, size }) {
  return (
    <svg
      className={className}
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4877 5.98128L12.1009 5.74993C12.0001 5.33785 11.8532 4.94394 11.6618 4.57654L12.5496 3.47576C12.7384 3.24312 12.7298 2.9084 12.5307 2.68387L11.9792 2.06313C11.7792 1.83883 11.4477 1.7914 11.1948 1.95118L10.0088 2.69672C9.48716 2.33226 8.89627 2.06313 8.25885 1.90696L8.02682 0.5127C7.97814 0.217473 7.72266 0.000854492 7.42276 0.000854492H6.59157C6.29228 0.000854492 6.03594 0.217473 5.98833 0.5127L5.75504 1.9074C5.22804 2.03642 4.73393 2.2447 4.28301 2.519L3.1551 1.71406C2.91201 1.54039 2.57813 1.56755 2.366 1.77923L1.77878 2.36687C1.5671 2.579 1.53994 2.91288 1.71406 3.15597L2.52088 4.28603C2.24916 4.73355 2.04302 5.22485 1.91401 5.74716L0.511814 5.9813C0.217041 6.02998 0 6.28548 0 6.58539V7.41593C0 7.71581 0.217041 7.97134 0.511814 8.02002L1.91401 8.25416C2.01996 8.68396 2.17377 9.09451 2.3782 9.47517L1.49444 10.5697C1.30626 10.8021 1.31417 11.1371 1.51324 11.3614L2.06438 11.9822C2.26433 12.2069 2.59605 12.2535 2.84898 12.0941L4.05207 11.3383C4.56114 11.6865 5.13704 11.9424 5.75504 12.0941L5.98833 13.4886C6.03596 13.7838 6.29228 14.0004 6.59157 14.0004H7.42276C7.72266 14.0004 7.97814 13.7838 8.02682 13.4886L8.25924 12.0941C8.77966 11.9668 9.26751 11.7622 9.71442 11.4926L10.8893 12.3317C11.132 12.506 11.4661 12.4786 11.678 12.2663L12.2655 11.6788C12.4769 11.4673 12.5055 11.1337 12.33 10.8901L11.4935 9.71737C11.766 9.26835 11.9732 8.77617 12.1014 8.25153L13.4882 8.01997C13.7838 7.97129 14 7.71578 14 7.41588V6.58534C13.9996 6.28548 13.7834 6.02998 13.4877 5.98128ZM7.02199 9.62559C5.57259 9.62559 4.39706 8.44984 4.39706 7.00066C4.39706 5.55126 5.57259 4.37573 7.02199 4.37573C8.47114 4.37573 9.64689 5.55126 9.64689 7.00066C9.64689 8.44984 8.47114 9.62559 7.02199 9.62559Z"
        fill={fill}
      />
    </svg>
  );
}

export function QuestionIcon({ className }) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5175 5.17673C10.741 4.91792 9.83522 5.17673 9.18813 5.69434C8.54104 6.21195 8.15283 6.98844 8.15283 7.89434C8.15283 8.28255 8.41164 8.54143 8.79992 8.54143C9.18813 8.54143 9.44701 8.28262 9.44701 7.89434C9.44701 7.50613 9.57641 6.98844 9.96462 6.72964C10.3528 6.47083 10.7411 6.34143 11.2587 6.47083C11.9058 6.60023 12.294 7.11792 12.4234 7.63553C12.5528 8.28262 12.4234 8.80023 11.9058 9.18852C10.8705 9.96501 10.3528 11.1297 10.3528 12.2944C10.3528 12.6826 10.6116 12.9415 10.9999 12.9415C11.3881 12.9415 11.647 12.6827 11.5175 12.2944C11.5175 11.5179 12.0351 10.7414 12.6822 10.2238C13.5881 9.44732 13.9763 8.41202 13.7175 7.37673C13.4587 6.21202 12.5528 5.43553 11.5175 5.17673Z" />
      <path d="M10.4824 15.659C10.353 15.7884 10.353 16.0472 10.353 16.1766C10.353 16.306 10.353 16.4354 10.4824 16.5648C10.6118 16.6942 10.8706 16.8236 11 16.8236C11.1294 16.8236 11.3882 16.6942 11.3882 16.5648C11.5177 16.5648 11.6471 16.306 11.6471 16.1766C11.6471 15.9178 11.5177 15.7884 11.3882 15.659C11.1294 15.4001 10.7412 15.4001 10.4824 15.659Z" />
      <path
        className="question-icon"
        d="M21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.20101 5.20101 0.5 11 0.5C16.799 0.5 21.5 5.20101 21.5 11Z"
      />
    </svg>
  );
}

export function SendIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1379 0.861766C15.3983 1.12212 15.3983 1.54423 15.1379 1.80458L7.80458 9.13791C7.54423 9.39826 7.12212 9.39826 6.86177 9.13791C6.60142 8.87756 6.60142 8.45545 6.86177 8.1951L14.1951 0.861766C14.4554 0.601417 14.8776 0.601417 15.1379 0.861766Z"
        fill="#18A0FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1379 0.861785C15.319 1.04288 15.3804 1.3117 15.2957 1.55342L10.6291 14.8868C10.5388 15.1448 10.3001 15.3215 10.027 15.3326C9.7539 15.3438 9.50165 15.1871 9.39063 14.9373L6.8281 9.17159L1.06241 6.60906C0.812628 6.49805 0.655919 6.2458 0.667061 5.97268C0.678204 5.69956 0.85494 5.46092 1.11294 5.37062L14.4463 0.70395C14.688 0.619347 14.9568 0.680693 15.1379 0.861785ZM3.14056 6.07359L7.60393 8.05731C7.75475 8.12435 7.87535 8.24494 7.94238 8.39576L9.9261 12.8591L13.5799 2.41984L3.14056 6.07359Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function PlayIcon({ className }) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.01371 0.415022C1.22776 0.298162 1.48854 0.307502 1.69368 0.439378L11.027 6.43938C11.2178 6.56204 11.3332 6.77332 11.3332 7.00016C11.3332 7.22701 11.2178 7.43828 11.027 7.56095L1.69368 13.5609C1.48854 13.6928 1.22776 13.7022 1.01371 13.5853C0.799663 13.4684 0.666504 13.244 0.666504 13.0002V1.00016C0.666504 0.756292 0.799663 0.531882 1.01371 0.415022ZM1.99984 2.22127V11.7791L9.43367 7.00016L1.99984 2.22127Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function GridIcon({ className }) {
  return (
    <svg
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0.666667C0 0.489856 0.0702379 0.320286 0.195262 0.195262C0.320286 0.0702379 0.489856 0 0.666667 0H2.66667C2.84348 0 3.01305 0.0702379 3.13807 0.195262C3.2631 0.320286 3.33333 0.489856 3.33333 0.666667V2.66667C3.33333 2.84348 3.2631 3.01305 3.13807 3.13807C3.01305 3.2631 2.84348 3.33333 2.66667 3.33333H0.666667C0.489856 3.33333 0.320286 3.2631 0.195262 3.13807C0.0702379 3.01305 0 2.84348 0 2.66667V0.666667Z"
        fill="#6D7F92"
      />
      <path
        d="M0 5.00016C0 4.82335 0.0702379 4.65378 0.195262 4.52876C0.320286 4.40373 0.489856 4.3335 0.666667 4.3335H2.66667C2.84348 4.3335 3.01305 4.40373 3.13807 4.52876C3.2631 4.65378 3.33333 4.82335 3.33333 5.00016V7.00016C3.33333 7.17697 3.2631 7.34654 3.13807 7.47157C3.01305 7.59659 2.84348 7.66683 2.66667 7.66683H0.666667C0.489856 7.66683 0.320286 7.59659 0.195262 7.47157C0.0702379 7.34654 0 7.17697 0 7.00016V5.00016Z"
        fill="#6D7F92"
      />
      <path
        d="M0 9.33317C0 9.15636 0.0702379 8.98679 0.195262 8.86177C0.320286 8.73674 0.489856 8.6665 0.666667 8.6665H2.66667C2.84348 8.6665 3.01305 8.73674 3.13807 8.86177C3.2631 8.98679 3.33333 9.15636 3.33333 9.33317V11.3332C3.33333 11.51 3.2631 11.6796 3.13807 11.8046C3.01305 11.9296 2.84348 11.9998 2.66667 11.9998H0.666667C0.489856 11.9998 0.320286 11.9296 0.195262 11.8046C0.0702379 11.6796 0 11.51 0 11.3332V9.33317Z"
        fill="#6D7F92"
      />
      <path
        d="M4.33331 0.666667C4.33331 0.489856 4.40355 0.320286 4.52858 0.195262C4.6536 0.0702379 4.82317 0 4.99998 0H6.99998C7.17679 0 7.34636 0.0702379 7.47138 0.195262C7.59641 0.320286 7.66665 0.489856 7.66665 0.666667V2.66667C7.66665 2.84348 7.59641 3.01305 7.47138 3.13807C7.34636 3.2631 7.17679 3.33333 6.99998 3.33333H4.99998C4.82317 3.33333 4.6536 3.2631 4.52858 3.13807C4.40355 3.01305 4.33331 2.84348 4.33331 2.66667V0.666667Z"
        fill="#6D7F92"
      />
      <path
        d="M4.33331 5.00016C4.33331 4.82335 4.40355 4.65378 4.52858 4.52876C4.6536 4.40373 4.82317 4.3335 4.99998 4.3335H6.99998C7.17679 4.3335 7.34636 4.40373 7.47138 4.52876C7.59641 4.65378 7.66665 4.82335 7.66665 5.00016V7.00016C7.66665 7.17697 7.59641 7.34654 7.47138 7.47157C7.34636 7.59659 7.17679 7.66683 6.99998 7.66683H4.99998C4.82317 7.66683 4.6536 7.59659 4.52858 7.47157C4.40355 7.34654 4.33331 7.17697 4.33331 7.00016V5.00016Z"
        fill="#6D7F92"
      />
      <path
        d="M4.33331 9.33317C4.33331 9.15636 4.40355 8.98679 4.52858 8.86177C4.6536 8.73674 4.82317 8.6665 4.99998 8.6665H6.99998C7.17679 8.6665 7.34636 8.73674 7.47138 8.86177C7.59641 8.98679 7.66665 9.15636 7.66665 9.33317V11.3332C7.66665 11.51 7.59641 11.6796 7.47138 11.8046C7.34636 11.9296 7.17679 11.9998 6.99998 11.9998H4.99998C4.82317 11.9998 4.6536 11.9296 4.52858 11.8046C4.40355 11.6796 4.33331 11.51 4.33331 11.3332V9.33317Z"
        fill="#6D7F92"
      />
      <path
        d="M8.66669 0.666667C8.66669 0.489856 8.73692 0.320286 8.86195 0.195262C8.98697 0.0702379 9.15654 0 9.33335 0H11.3334C11.5102 0 11.6797 0.0702379 11.8048 0.195262C11.9298 0.320286 12 0.489856 12 0.666667V2.66667C12 2.84348 11.9298 3.01305 11.8048 3.13807C11.6797 3.2631 11.5102 3.33333 11.3334 3.33333H9.33335C9.15654 3.33333 8.98697 3.2631 8.86195 3.13807C8.73692 3.01305 8.66669 2.84348 8.66669 2.66667V0.666667Z"
        fill="#6D7F92"
      />
      <path
        d="M8.66669 5.00016C8.66669 4.82335 8.73692 4.65378 8.86195 4.52876C8.98697 4.40373 9.15654 4.3335 9.33335 4.3335H11.3334C11.5102 4.3335 11.6797 4.40373 11.8048 4.52876C11.9298 4.65378 12 4.82335 12 5.00016V7.00016C12 7.17697 11.9298 7.34654 11.8048 7.47157C11.6797 7.59659 11.5102 7.66683 11.3334 7.66683H9.33335C9.15654 7.66683 8.98697 7.59659 8.86195 7.47157C8.73692 7.34654 8.66669 7.17697 8.66669 7.00016V5.00016Z"
        fill="#6D7F92"
      />
      <path
        d="M8.66669 9.33317C8.66669 9.15636 8.73692 8.98679 8.86195 8.86177C8.98697 8.73674 9.15654 8.6665 9.33335 8.6665H11.3334C11.5102 8.6665 11.6797 8.73674 11.8048 8.86177C11.9298 8.98679 12 9.15636 12 9.33317V11.3332C12 11.51 11.9298 11.6796 11.8048 11.8046C11.6797 11.9296 11.5102 11.9998 11.3334 11.9998H9.33335C9.15654 11.9998 8.98697 11.9296 8.86195 11.8046C8.73692 11.6796 8.66669 11.51 8.66669 11.3332V9.33317Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function MenuIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8H14"
        stroke="#6D7F92"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 4H14"
        stroke="#6D7F92"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12H14"
        stroke="#6D7F92"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RemoveIcon({ className }) {
  return (
    <svg
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0303 0.96967C11.3232 1.26256 11.3232 1.73744 11.0303 2.03033L2.03033 11.0303C1.73744 11.3232 1.26256 11.3232 0.96967 11.0303C0.676777 10.7374 0.676777 10.2626 0.96967 9.96967L9.96967 0.96967C10.2626 0.676777 10.7374 0.676777 11.0303 0.96967Z"
        fill="#F9626D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.96967 0.96967C1.26256 0.676777 1.73744 0.676777 2.03033 0.96967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L0.96967 2.03033C0.676777 1.73744 0.676777 1.26256 0.96967 0.96967Z"
        fill="#F9626D"
      />
    </svg>
  );
}

export function CalendarIcon({ className, fill }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5 2.5C2.22386 2.5 2 2.72386 2 3V10C2 10.2761 2.22386 10.5 2.5 10.5H9.5C9.77614 10.5 10 10.2761 10 10V3C10 2.72386 9.77614 2.5 9.5 2.5H2.5ZM1 3C1 2.17157 1.67157 1.5 2.5 1.5H9.5C10.3284 1.5 11 2.17157 11 3V10C11 10.8284 10.3284 11.5 9.5 11.5H2.5C1.67157 11.5 1 10.8284 1 10V3Z"
        fill={fill ? fill : "#6D7F92"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0.5C8.27614 0.5 8.5 0.723858 8.5 1V3C8.5 3.27614 8.27614 3.5 8 3.5C7.72386 3.5 7.5 3.27614 7.5 3V1C7.5 0.723858 7.72386 0.5 8 0.5Z"
        fill={fill ? fill : "#6D7F92"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.5C4.27614 0.5 4.5 0.723858 4.5 1V3C4.5 3.27614 4.27614 3.5 4 3.5C3.72386 3.5 3.5 3.27614 3.5 3V1C3.5 0.723858 3.72386 0.5 4 0.5Z"
        fill={fill ? fill : "#6D7F92"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 5C1 4.72386 1.22386 4.5 1.5 4.5H10.5C10.7761 4.5 11 4.72386 11 5C11 5.27614 10.7761 5.5 10.5 5.5H1.5C1.22386 5.5 1 5.27614 1 5Z"
        fill={fill ? fill : "#6D7F92"}
      />
    </svg>
  );
}

export function FilterIcon({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7379 8.01789L12.9818 8.01789C13.5441 8.01789 14 7.56194 14 6.99973C14 6.43737 13.5441 5.98145 12.9818 5.98145L11.7379 5.98145C11.8799 6.29268 11.9637 6.6358 11.9637 6.99973C11.9637 7.36351 11.8799 7.70663 11.7379 8.01789Z"
        fill="#6D7F92"
      />
      <path
        d="M7.25 5.98145L1.01928 5.98145C0.456982 5.98145 0.00114582 6.4374 0.0011458 6.99973C0.00114577 7.56194 0.456982 8.01789 1.01928 8.01789L7.24974 8.01789C7.1078 7.70663 7.02399 7.36351 7.02399 6.99973C7.02399 6.6358 7.10806 6.29268 7.25 5.98145Z"
        fill="#6D7F92"
      />
      <path
        d="M10.9453 6.99968C10.9453 6.19925 10.2937 5.54785 9.49311 5.54785C8.69245 5.54785 8.04087 6.19925 8.04087 6.99968C8.04087 7.80052 8.69245 8.45224 9.49311 8.45224C10.2938 8.45227 10.9453 7.80052 10.9453 6.99968Z"
        fill="#6D7F92"
      />
      <path
        d="M1.64844 11.0723L1.01779 11.0723C0.455487 11.0723 -0.000348111 11.5282 -0.000348136 12.0904C-0.00034816 12.6528 0.455487 13.1085 1.01779 13.1085L1.64818 13.1085C1.50623 12.7975 1.42252 12.4544 1.42252 12.0904C1.42249 11.7264 1.5065 11.3835 1.64844 11.0723Z"
        fill="#6D7F92"
      />
      <path
        d="M6.13795 13.1085L12.9818 13.1085C13.5441 13.1085 14 12.6528 14 12.0904C14 11.5282 13.5441 11.0723 12.9818 11.0723L6.13795 11.0723C6.27983 11.3835 6.36364 11.7264 6.36364 12.0904C6.36364 12.4543 6.27983 12.7975 6.13795 13.1085Z"
        fill="#6D7F92"
      />
      <path
        d="M5.34375 12.0905C5.34375 11.2901 4.69229 10.6389 3.89154 10.6389C3.09088 10.6389 2.43931 11.2901 2.43931 12.0905C2.43931 12.8916 3.09088 13.5433 3.89154 13.5433C4.69229 13.5433 5.34375 12.8916 5.34375 12.0905Z"
        fill="#6D7F92"
      />
      <path
        d="M2.66797 0.890625L1.0191 0.890625C0.4568 0.890625 0.000966052 1.3464 0.000966028 1.90879C0.000966003 2.471 0.4568 2.92695 1.0191 2.92695L2.66771 2.92695C2.52574 2.61569 2.44193 2.27274 2.44193 1.90879C2.44193 1.54483 2.526 1.20188 2.66797 0.890625Z"
        fill="#6D7F92"
      />
      <path
        d="M7.15608 2.92671L12.9818 2.92671C13.5441 2.92671 14 2.47076 14 1.90854C14 1.34616 13.5441 0.890381 12.9818 0.890381L7.15608 0.890381C7.29802 1.20164 7.38183 1.54459 7.38183 1.90854C7.38183 2.2725 7.29802 2.61545 7.15608 2.92671Z"
        fill="#6D7F92"
      />
      <path
        d="M6.36328 1.90869C6.36328 1.10823 5.71171 0.457031 4.91104 0.457031C4.11041 0.457031 3.45884 1.10823 3.45884 1.90869C3.45884 2.7095 4.11041 3.36142 4.91104 3.36142C5.71171 3.36142 6.36328 2.70947 6.36328 1.90869Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function FolderIcon({ fill }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.810224 5.805L0.750224 4.5C0.750224 3.70435 1.06629 2.94129 1.6289 2.37868C2.19151 1.81607 2.95457 1.5 3.75022 1.5H9.25822C10.0538 1.50017 10.8167 1.81635 11.3792 2.379L12.6212 3.621C13.1837 4.18365 13.9466 4.49983 14.7422 4.5H20.7152C21.1321 4.49996 21.5444 4.5868 21.9259 4.75499C22.3073 4.92317 22.6495 5.16902 22.9307 5.47683C23.2118 5.78465 23.4257 6.14768 23.5587 6.54276C23.6917 6.93785 23.741 7.35633 23.7032 7.7715L22.7477 18.2715C22.68 19.0169 22.3361 19.71 21.7835 20.2148C21.231 20.7197 20.5097 20.9997 19.7612 21H4.23922C3.49078 20.9997 2.76948 20.7197 2.21692 20.2148C1.66436 19.71 1.32046 19.0169 1.25272 18.2715L0.297224 7.7715C0.233304 7.07667 0.414815 6.38141 0.810224 5.8065V5.805ZM3.28522 6C3.07685 5.99999 2.87077 6.04339 2.6801 6.12744C2.48943 6.21149 2.31836 6.33434 2.1778 6.48816C2.03725 6.64199 1.93028 6.82341 1.86372 7.02086C1.79716 7.21832 1.77247 7.42747 1.79122 7.635L2.74672 18.135C2.7804 18.5077 2.95217 18.8543 3.22831 19.1069C3.50445 19.3594 3.86501 19.4996 4.23922 19.5H19.7612C20.1354 19.4996 20.496 19.3594 20.7721 19.1069C21.0483 18.8543 21.22 18.5077 21.2537 18.135L22.2092 7.635C22.228 7.42747 22.2033 7.21832 22.1367 7.02086C22.0702 6.82341 21.9632 6.64199 21.8226 6.48816C21.6821 6.33434 21.511 6.21149 21.3204 6.12744C21.1297 6.04339 20.9236 5.99999 20.7152 6H3.28522ZM10.3202 3.4395C10.1808 3.30002 10.0152 3.18941 9.83299 3.114C9.65076 3.03858 9.45544 2.99984 9.25822 3H3.75022C3.35729 2.99993 2.98001 3.15405 2.69951 3.42922C2.41902 3.70439 2.25769 4.07864 2.25022 4.4715L2.25922 4.68C2.58022 4.563 2.92522 4.5 3.28522 4.5H11.3792L10.3187 3.4395H10.3202Z"
        fill={fill ? fill : "#06D9B1"}
      />
    </svg>
  );
}

export function DashboardIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0H10C11.1046 0 12 0.895431 12 2V10C12 11.1046 11.1046 12 10 12H2C0.895431 12 0 11.1046 0 10V2C0 0.895431 0.89543 0 2 0ZM15 5H18C19.1046 5 20 5.89543 20 7V10C20 11.1046 19.1046 12 18 12H15C13.8954 12 13 11.1046 13 10V7C13 5.89543 13.8954 5 15 5ZM15 13H18C19.1046 13 20 13.8954 20 15V18C20 19.1046 19.1046 20 18 20H15C13.8954 20 13 19.1046 13 18V15C13 13.8954 13.8954 13 15 13ZM7 13H10C11.1046 13 12 13.8954 12 15V18C12 19.1046 11.1046 20 10 20H7C5.89543 20 5 19.1046 5 18V15C5 13.8954 5.89543 13 7 13ZM2 1C1.44772 1 1 1.44772 1 2V10C1 10.5523 1.44772 11 2 11H10C10.5523 11 11 10.5523 11 10V2C11 1.44772 10.5523 1 10 1H2ZM15 6C14.4477 6 14 6.44772 14 7V10C14 10.5523 14.4477 11 15 11H18C18.5523 11 19 10.5523 19 10V7C19 6.44772 18.5523 6 18 6H15ZM14 15C14 14.4477 14.4477 14 15 14H18C18.5523 14 19 14.4477 19 15V18C19 18.5523 18.5523 19 18 19H15C14.4477 19 14 18.5523 14 18V15ZM7 14C6.44772 14 6 14.4477 6 15V18C6 18.5523 6.44772 19 7 19H10C10.5523 19 11 18.5523 11 18V15C11 14.4477 10.5523 14 10 14H7Z"
        fill="#C7E8FE"
      />
    </svg>
  );
}

export function UserIcon({ className, size }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 17 17"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.60427 9.02126C3.15125 8.47428 3.89312 8.16699 4.66667 8.16699H9.33333C10.1069 8.16699 10.8487 8.47428 11.3957 9.02126C11.9427 9.56825 12.25 10.3101 12.25 11.0837V12.2503C12.25 12.5725 11.9888 12.8337 11.6667 12.8337C11.3445 12.8337 11.0833 12.5725 11.0833 12.2503V11.0837C11.0833 10.6195 10.899 10.1744 10.5708 9.84622C10.2426 9.51803 9.79746 9.33366 9.33333 9.33366H4.66667C4.20254 9.33366 3.75742 9.51803 3.42923 9.84622C3.10104 10.1744 2.91667 10.6195 2.91667 11.0837V12.2503C2.91667 12.5725 2.6555 12.8337 2.33333 12.8337C2.01117 12.8337 1.75 12.5725 1.75 12.2503V11.0837C1.75 10.3101 2.05729 9.56825 2.60427 9.02126Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99992 2.33366C6.03342 2.33366 5.24992 3.11716 5.24992 4.08366C5.24992 5.05016 6.03342 5.83366 6.99992 5.83366C7.96642 5.83366 8.74992 5.05016 8.74992 4.08366C8.74992 3.11716 7.96642 2.33366 6.99992 2.33366ZM4.08325 4.08366C4.08325 2.47283 5.38909 1.16699 6.99992 1.16699C8.61075 1.16699 9.91658 2.47283 9.91658 4.08366C9.91658 5.69449 8.61075 7.00033 6.99992 7.00033C5.38909 7.00033 4.08325 5.69449 4.08325 4.08366Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function UsersIcon({ className, size }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.46447 15.4645C2.40215 14.5268 3.67392 14 5 14H13C14.3261 14 15.5979 14.5268 16.5355 15.4645C17.4732 16.4021 18 17.6739 18 19V21C18 21.5523 17.5523 22 17 22C16.4477 22 16 21.5523 16 21V19C16 18.2044 15.6839 17.4413 15.1213 16.8787C14.5587 16.3161 13.7956 16 13 16H5C4.20435 16 3.44129 16.3161 2.87868 16.8787C2.31607 17.4413 2 18.2044 2 19V21C2 21.5523 1.55228 22 1 22C0.447715 22 0 21.5523 0 21V19C0 17.6739 0.526784 16.4021 1.46447 15.4645Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0318 14.8801C19.1698 14.3454 19.7153 14.0238 20.25 14.1619C21.3227 14.4388 22.273 15.0642 22.9517 15.9398C23.6304 16.8153 23.9992 17.8915 24 18.9994L24 21.0001C24 21.5524 23.5523 22.0001 23 22.0001C22.4477 22.0001 22 21.5524 22 21.0001L22 19.0009C22 19.0008 22 19.001 22 19.0009C21.9994 18.3363 21.7782 17.6904 21.371 17.1651C20.9638 16.6398 20.3936 16.2645 19.75 16.0984C19.2153 15.9603 18.8937 15.4149 19.0318 14.8801Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0312 2.88208C15.1682 2.34706 15.713 2.02439 16.248 2.16137C17.3236 2.43675 18.2768 3.06225 18.9576 3.93926C19.6383 4.81627 20.0078 5.89491 20.0078 7.00512C20.0078 8.11534 19.6383 9.19397 18.9576 10.071C18.2768 10.948 17.3236 11.5735 16.248 11.8489C15.713 11.9859 15.1682 11.6632 15.0312 11.1282C14.8943 10.5931 15.2169 10.0484 15.752 9.91137C16.3973 9.74615 16.9692 9.37085 17.3777 8.84464C17.7861 8.31843 18.0078 7.67125 18.0078 7.00512C18.0078 6.339 17.7861 5.69181 17.3777 5.16561C16.9692 4.6394 16.3973 4.2641 15.752 4.09887C15.2169 3.96189 14.8943 3.41711 15.0312 2.88208Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function TrelloIcon({ className, fill, size }) {
  return (
    <svg
      width={size ? size : "24"}
      height={size ? size : "24"}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 21L19 21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5L3 19C3 20.1046 3.89543 21 5 21Z"
        stroke={fill ? fill : "#29394D"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 17L17 17L17 8L14 8L14 17Z"
        stroke={fill ? fill : "#29394D"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 17L10 17L10 12L7 12L7 17Z"
        stroke={fill ? fill : "#29394D"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function HistoryIcon({ className, size, fill }) {
  return (
    <svg
      width={size ? size : "14"}
      height={size ? size : "14"}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.54688 3.77344V6.77348L9.53775 8.76436C9.75133 8.97794 9.75133 9.32419 9.53775 9.53775C9.32416 9.75133 8.97791 9.7513 8.76436 9.53775L6.6133 7.3867C6.51074 7.28416 6.45312 7.14503 6.45312 7V3.77344C6.45312 3.4714 6.69796 3.22656 7 3.22656C7.30204 3.22656 7.54688 3.4714 7.54688 3.77344ZM9.15105 0H4.84895C3.70352 0 2.57348 0.402555 1.66931 1.18885V0.546875C1.66931 0.244836 1.42447 0 1.12243 0C0.820395 0 0.575559 0.244836 0.575559 0.546875V2.69793C0.575559 2.99996 0.8225 3.2448 1.12243 3.2448H3.27348C3.57552 3.2448 3.82036 2.99996 3.82036 2.69793C3.82036 2.39589 3.57552 2.15105 3.27348 2.15105H2.23899C2.93117 1.48373 3.86553 1.09375 4.84895 1.09375H9.15102C11.2217 1.09375 12.9062 2.77832 12.9062 4.84895V9.15102C12.9062 11.2217 11.2217 12.9062 9.15105 12.9062H4.84895C2.77832 12.9062 1.09375 11.2217 1.09375 9.15105V7C1.09375 6.69796 0.848914 6.45312 0.546875 6.45312C0.244836 6.45312 0 6.69796 0 7V9.15105C0 11.8248 2.17522 14 4.84895 14H9.15102C11.8248 14 14 11.8248 14 9.15105V4.84895C14 2.17522 11.8248 0 9.15105 0V0Z"
        fill={fill ? fill : "#29394D"}
      />
    </svg>
  );
}

export function AttachmentIcon({ className, fill }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.2721 1.06145C7.82641 1.06145 7.39897 1.22932 7.08382 1.52813L1.93976 6.4055C1.41455 6.90348 1.11949 7.5789 1.11949 8.28315C1.11949 8.98741 1.41455 9.66282 1.93976 10.1608C2.46498 10.6588 3.17732 10.9385 3.92008 10.9385C4.66285 10.9385 5.37519 10.6588 5.9004 10.1608L11.0445 5.28343C11.2631 5.07617 11.6175 5.07617 11.8361 5.28343C12.0546 5.4907 12.0546 5.82673 11.8361 6.03399L6.692 10.9114C5.95684 11.6084 4.95975 12 3.92008 12C2.88041 12 1.88332 11.6084 1.14817 10.9114C0.413007 10.2143 0 9.26892 0 8.28315C0 7.29738 0.413007 6.35199 1.14817 5.65494L6.29222 0.777575C6.81732 0.279702 7.5295 0 8.2721 0C9.0147 0 9.72688 0.279702 10.252 0.777575C10.7771 1.27545 11.0721 1.95071 11.0721 2.65481C11.0721 3.35891 10.7771 4.03417 10.252 4.53204L5.10232 9.40941C4.78729 9.70811 4.36001 9.87592 3.91448 9.87592C3.46896 9.87592 3.04168 9.70811 2.72665 9.40941C2.41161 9.11071 2.23463 8.70558 2.23463 8.28315C2.23463 7.86072 2.41161 7.4556 2.72665 7.15689L7.47911 2.65612C7.69784 2.44898 8.05225 2.44918 8.27071 2.65656C8.48918 2.86395 8.48897 3.19998 8.27025 3.40712L3.51824 7.90745C3.4133 8.00707 3.35412 8.14234 3.35412 8.28315C3.35412 8.42406 3.41316 8.55921 3.51824 8.65885C3.62333 8.75849 3.76587 8.81447 3.91448 8.81447C4.0631 8.81447 4.20563 8.75849 4.31072 8.65885L9.46038 3.78148C9.77539 3.48269 9.95258 3.0773 9.95258 2.65481C9.95258 2.23222 9.77553 1.82695 9.46038 1.52813C9.14523 1.22932 8.71779 1.06145 8.2721 1.06145Z"
        fill={fill ? fill : "#29394D"}
      />
    </svg>
  );
}

export function ClipboardIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3.33333C3.82319 3.33333 3.65362 3.40357 3.5286 3.5286C3.40357 3.65362 3.33333 3.82319 3.33333 4V13.3333C3.33333 13.5101 3.40357 13.6797 3.5286 13.8047C3.65362 13.9298 3.82319 14 4 14H12C12.1768 14 12.3464 13.9298 12.4714 13.8047C12.5964 13.6797 12.6667 13.5101 12.6667 13.3333V4C12.6667 3.82319 12.5964 3.65362 12.4714 3.5286C12.3464 3.40357 12.1768 3.33333 12 3.33333H10.6667C10.2985 3.33333 10 3.03486 10 2.66667C10 2.29848 10.2985 2 10.6667 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V13.3333C14 13.8638 13.7893 14.3725 13.4142 14.7475C13.0391 15.1226 12.5304 15.3333 12 15.3333H4C3.46957 15.3333 2.96086 15.1226 2.58579 14.7475C2.21071 14.3725 2 13.8638 2 13.3333V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H5.33333C5.70152 2 6 2.29848 6 2.66667C6 3.03486 5.70152 3.33333 5.33333 3.33333H4Z"
        fill="#18A0FB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.6665 2.00033C4.6665 1.26395 5.26346 0.666992 5.99984 0.666992H9.99984C10.7362 0.666992 11.3332 1.26395 11.3332 2.00033V3.33366C11.3332 4.07004 10.7362 4.66699 9.99984 4.66699H5.99984C5.26346 4.66699 4.6665 4.07004 4.6665 3.33366V2.00033ZM9.99984 2.00033H5.99984V3.33366H9.99984V2.00033Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function TreeDotsIcon({ className }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 7.5C2.32843 7.5 3 6.82843 3 6C3 5.17157 2.32843 4.5 1.5 4.5C0.671573 4.5 0 5.17157 0 6C0 6.82843 0.671573 7.5 1.5 7.5Z"
        fill="white"
      />
      <path
        d="M1.5 12C2.32843 12 3 11.3284 3 10.5C3 9.67157 2.32843 9 1.5 9C0.671573 9 0 9.67157 0 10.5C0 11.3284 0.671573 12 1.5 12Z"
        fill="white"
      />
      <path
        d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
        fill="white"
      />
    </svg>
  );
}

export function DashboardPageIcon({ className }) {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.1022 33.8887H0.89775C0.401894 33.8887 0 34.2906 0 34.7864C0 35.2821 0.401894 35.6842 0.89775 35.6842H37.1022C37.598 35.6842 38 35.2821 38 34.7864C38 34.2906 37.5981 33.8887 37.1022 33.8887Z"
        fill="#3C4E64"
      />
      <path
        d="M34.7618 6.55386H28.4571C27.9614 6.55386 27.5593 6.9559 27.5593 7.45161V13.5554H23.05V3.21342C23.05 2.71772 22.648 2.31567 22.1523 2.31567H15.8474C15.3517 2.31567 14.9496 2.71772 14.9496 3.21342V20.2008H10.4403V12.5697C10.4403 12.0738 10.0383 11.6719 9.54257 11.6719H3.23784C2.74198 11.6719 2.34009 12.0738 2.34009 12.5697V29.756C2.34009 30.2518 2.74213 30.6537 3.23784 30.6537H9.54257H15.8473H22.1522H28.457H34.7617C35.2576 30.6537 35.6595 30.2517 35.6595 29.756V7.45161C35.6596 6.9559 35.2577 6.55386 34.7618 6.55386ZM8.6449 28.8582H4.13559V13.4674H8.6449V28.8582ZM14.9498 28.8582H10.4405V21.9963H14.9498V28.8582ZM21.2546 14.4531V28.8582H16.7452V4.11117H21.2546V14.4531ZM27.5595 28.8582H23.0502V15.3509H27.5595V28.8582ZM33.8642 28.8582H29.355V14.4531V8.34936H33.8643V28.8582H33.8642Z"
        fill="#3C4E64"
      />
    </svg>
  );
}

export function DiaporamaIcon({ className }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8647 7.6003L1.22127 13.8397C0.888978 14.0037 0.5 13.7619 0.5 13.3914L0.500001 1.53815C0.500001 1.1764 0.872277 0.934366 1.2029 1.08117L13.8463 6.69494C14.2337 6.86695 14.2448 7.41272 13.8647 7.6003Z"
        stroke="#18A0FB"
      />
    </svg>
  );
}

export function AssociateIcon({ className, color }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5145 7.80295C9.3169 8.00055 9.3169 8.31745 9.5145 8.51505C10.331 9.33153 10.331 10.6588 9.5145 11.4753L5.22701 15.7628C4.41052 16.5793 3.08326 16.5793 2.26678 15.7628L1.62179 15.1178C0.805302 14.3013 0.805302 12.974 1.62179 12.1575L5.90928 7.87006C6.10688 7.67246 6.10688 7.35556 5.90928 7.15796C5.71168 6.96037 5.39478 6.96037 5.19718 7.15796L0.909693 11.4455C0.324358 12.0308 0 12.81 0 13.6377C0 14.4653 0.32063 15.2445 0.909693 15.8299L1.55468 16.4749C2.15866 17.0788 2.95278 17.3808 3.74689 17.3808C4.54101 17.3808 5.33513 17.0788 5.93911 16.4749L10.2266 12.1874C11.4345 10.9794 11.4345 9.01091 10.2266 7.80295C10.0327 7.60535 9.7121 7.60535 9.5145 7.80295Z"
        fill={color ? color : "#18A0FB"}
      />
      <path
        d="M17.094 2.17009L16.449 1.52511C15.241 0.317152 13.2725 0.317152 12.0646 1.52511L7.77706 5.8126C6.56911 7.02055 6.56911 8.98907 7.77706 10.197C7.97466 10.3946 8.29156 10.3946 8.48916 10.197C8.68675 9.99943 8.68675 9.68253 8.48916 9.48493C7.67267 8.66844 7.67267 7.34118 8.48916 6.5247L12.7766 2.2372C13.5931 1.42072 14.9204 1.42072 15.7369 2.2372L16.3819 2.88219C17.1984 3.69868 17.1984 5.02594 16.3819 5.84243L12.0944 10.1299C11.8968 10.3275 11.8968 10.6444 12.0944 10.842C12.1913 10.9389 12.3218 10.9911 12.4486 10.9911C12.5753 10.9911 12.7058 10.9427 12.8027 10.842L17.0902 6.55452C17.6756 5.96919 17.9999 5.18998 17.9999 4.36231C17.9999 3.53464 17.6793 2.75543 17.094 2.17009Z"
        fill={color ? color : "#18A0FB"}
      />
    </svg>
  );
}

export function PencilIcon({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.0932 0.906185C11.8881 -0.302062 9.92824 -0.302062 8.72312 0.906185L0.710863 8.91641C0.64822 8.97906 0.609442 9.05961 0.59751 9.14613L0.00389841 13.5435C-0.0139994 13.6688 0.0307452 13.7942 0.117251 13.8807C0.191826 13.9552 0.29623 14 0.400634 14C0.418531 14 0.436429 14 0.454327 13.997L3.10321 13.639C3.32395 13.6092 3.47906 13.4063 3.44923 13.1856C3.4194 12.9648 3.21656 12.8097 2.99582 12.8395L0.871943 13.1259L1.28658 10.059L4.51415 13.287C4.58873 13.3616 4.69313 13.4063 4.79753 13.4063C4.90194 13.4063 5.00634 13.3646 5.08092 13.287L13.0932 5.27676C13.6778 4.69202 14 3.91636 14 3.08998C14 2.2636 13.6778 1.48793 13.0932 0.906185ZM8.87824 1.89068L10.2236 3.23616L2.9123 10.5483L1.56698 9.20281L8.87824 1.89068ZM4.80052 12.4338L3.48503 11.1181L10.7963 3.80598L12.1118 5.12162L4.80052 12.4338ZM12.6726 4.54584L9.45395 1.32683C9.86262 0.989718 10.3727 0.804752 10.9096 0.804752C11.5212 0.804752 12.0939 1.04342 12.5264 1.47302C12.9589 1.90262 13.1946 2.4784 13.1946 3.08998C13.1946 3.62996 13.0097 4.13713 12.6726 4.54584Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function CheckIcon({ className }) {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.40454 16C4.93107 16 4.48328 15.7673 4.19541 15.3682L0.307554 9.97459C-0.198119 9.2731 -0.0664787 8.27423 0.601297 7.7428C1.27016 7.21114 2.22037 7.35034 2.72626 8.05137L5.28334 11.5984L11.7146 0.750751C12.1574 0.00445974 13.0923 -0.223885 13.8043 0.240576C14.5154 0.705493 14.7325 1.68836 14.2895 2.43533L6.69222 15.2491C6.42829 15.6946 5.97266 15.9749 5.47373 15.9986C5.45045 15.9995 5.42761 16 5.40454 16Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function HomeIcon({ className }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 512 512"
      className={className}
    >
      <g>
        <g>
          <path
            d="M506.555,208.064L263.859,30.367c-4.68-3.426-11.038-3.426-15.716,0L5.445,208.064
			c-5.928,4.341-7.216,12.665-2.875,18.593s12.666,7.214,18.593,2.875L256,57.588l234.837,171.943c2.368,1.735,5.12,2.57,7.848,2.57
			c4.096,0,8.138-1.885,10.744-5.445C513.771,220.729,512.483,212.405,506.555,208.064z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M442.246,232.543c-7.346,0-13.303,5.956-13.303,13.303v211.749H322.521V342.009c0-36.68-29.842-66.52-66.52-66.52
			s-66.52,29.842-66.52,66.52v115.587H83.058V245.847c0-7.347-5.957-13.303-13.303-13.303s-13.303,5.956-13.303,13.303v225.053
			c0,7.347,5.957,13.303,13.303,13.303h133.029c6.996,0,12.721-5.405,13.251-12.267c0.032-0.311,0.052-0.651,0.052-1.036v-128.89
			c0-22.009,17.905-39.914,39.914-39.914s39.914,17.906,39.914,39.914v128.89c0,0.383,0.02,0.717,0.052,1.024
			c0.524,6.867,6.251,12.279,13.251,12.279h133.029c7.347,0,13.303-5.956,13.303-13.303V245.847
			C455.549,238.499,449.593,232.543,442.246,232.543z"
          />
        </g>
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}

export function EyeIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="11"
      viewBox="0 0 16 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8215 4.42694C14.988 3.09392 13.8674 2.02284 12.4598 1.21374C11.052 0.404612 9.56549 0 8 0C6.43451 0 4.94793 0.404459 3.54018 1.21374C2.1324 2.02284 1.01183 3.09392 0.178505 4.42694C0.0595122 4.63065 0 4.83149 0 5.02945C0 5.22741 0.0595122 5.42825 0.178505 5.6319C1.01183 6.96498 2.1324 8.03615 3.54018 8.84506C4.94793 9.65429 6.43451 10.0586 8 10.0586C9.56552 10.0586 11.052 9.65563 12.4598 8.84947C13.8674 8.04327 14.9882 6.9707 15.8215 5.6319C15.9405 5.42825 16 5.2275 16 5.02945C16 4.83149 15.9405 4.63065 15.8215 4.42694ZM6.08469 2.03881C6.6174 1.51786 7.25577 1.25729 7.99991 1.25729C8.1189 1.25729 8.22016 1.29815 8.30353 1.37959C8.38678 1.46107 8.42863 1.56006 8.42863 1.67646C8.42863 1.79295 8.38678 1.89189 8.30372 1.97324C8.22047 2.0548 8.11915 2.09554 8.00013 2.09554C7.48825 2.09554 7.05062 2.27317 6.68757 2.62817C6.3244 2.98339 6.14292 3.41119 6.14292 3.91177C6.14292 4.02832 6.10114 4.12719 6.01786 4.20873C5.93446 4.29032 5.83332 4.33103 5.7143 4.33103C5.59518 4.33103 5.49401 4.29023 5.41064 4.20873C5.32724 4.12719 5.28558 4.0282 5.28558 3.91177C5.28558 3.1842 5.55202 2.55979 6.08469 2.03881ZM11.8795 7.88045C10.686 8.58753 9.39289 8.94128 8 8.94128C6.60714 8.94128 5.31401 8.58774 4.12057 7.88045C2.92714 7.17316 1.93457 6.22286 1.14293 5.02945C2.04768 3.65564 3.18161 2.62814 4.54469 1.94721C4.18162 2.55251 4.00002 3.20744 4.00002 3.91174C4.00002 4.98874 4.39146 5.90969 5.17412 6.67527C5.95679 7.44085 6.89885 7.82347 8 7.82347C9.10124 7.82347 10.043 7.44064 10.8259 6.67527C11.6087 5.9099 12 4.98874 12 3.91174C12 3.20744 11.8184 2.55242 11.4553 1.94721C12.8183 2.62814 13.9523 3.65573 14.857 5.02945C14.0655 6.22286 13.073 7.17316 11.8795 7.88045Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function MoveUpDownIcon({ className }) {
  return (
    <svg
      className={className}
      height="20"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M399.786667 143.786667L146.346667 397.226667c-13.226667 13.226667-34.986667 13.226667-48.213334 0-13.226667-13.226667-13.226667-34.986667 0-48.213334l253.44-253.44c13.226667-13.226667 34.986667-13.226667 48.213334 0 13.226667 13.226667 13.226667 34.56 0 48.213334z"
        fill="#4C4C4C"
      />
      <path
        d="M375.466667 938.666667c-18.773333 0-34.133333-15.36-34.133334-34.133334V119.466667c0-18.773333 15.36-34.133333 34.133334-34.133334s34.133333 15.36 34.133333 34.133334v785.066666c0 18.773333-15.36 34.133333-34.133333 34.133334zM624.213333 880.213333l253.44-253.44c13.226667-13.226667 34.986667-13.226667 48.213334 0 13.226667 13.226667 13.226667 34.986667 0 48.213334l-253.44 253.44c-13.226667 13.226667-34.986667 13.226667-48.213334 0-13.226667-13.226667-13.226667-34.56 0-48.213334z"
        fill="#4C4C4C"
      />
      <path
        d="M648.533333 85.333333c18.773333 0 34.133333 15.36 34.133334 34.133334v785.066666c0 18.773333-15.36 34.133333-34.133334 34.133334s-34.133333-15.36-34.133333-34.133334V119.466667c0-18.773333 15.36-34.133333 34.133333-34.133334z"
        fill="#4C4C4C"
      />
    </svg>
  );
}

export function SimpleArrowUp({ className }) {
  return (
    <svg
      className={className}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M5.57169 2.87196L0.177143 8.26831C-0.0590474 8.5051 -0.0590474 8.88873 0.177143 9.12612C0.413333 9.36291 0.796967 9.36291 1.03316 9.12612L5.99968 4.15781L10.9662 9.12552C11.2024 9.36231 11.586 9.36231 11.8228 9.12552C12.059 8.88874 12.059 8.5045 11.8228 8.26771L6.42826 2.87137C6.19451 2.63817 5.80484 2.63817 5.57169 2.87196Z"
          fill="#18A0FB"
        />
      </g>
    </svg>
  );
}

export function SimpleArrowRight({ className }) {
  return (
    <svg
      className={className}
      width="8"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12804 5.57169L1.73169 0.177143C1.4949 -0.0590475 1.11127 -0.0590475 0.87388 0.177143C0.637092 0.413333 0.637092 0.796967 0.87388 1.03316L5.84219 5.99968L0.874478 10.9662C0.63769 11.2024 0.63769 11.586 0.874478 11.8228C1.11127 12.059 1.4955 12.059 1.73229 11.8228L7.12863 6.42826C7.36183 6.19451 7.36183 5.80484 7.12804 5.57169Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function AirPlayIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33301 3.33366C3.11199 3.33366 2.90003 3.42146 2.74375 3.57774C2.58747 3.73402 2.49967 3.94598 2.49967 4.16699V12.5003C2.49967 12.7213 2.58747 12.9333 2.74375 13.0896C2.90003 13.2459 3.11199 13.3337 3.33301 13.3337H4.16634C4.62658 13.3337 4.99967 13.7068 4.99967 14.167C4.99967 14.6272 4.62658 15.0003 4.16634 15.0003H3.33301C2.66997 15.0003 2.03408 14.7369 1.56524 14.2681C1.0964 13.7993 0.833008 13.1634 0.833008 12.5003V4.16699C0.833008 3.50395 1.0964 2.86807 1.56524 2.39923C2.03408 1.93038 2.66997 1.66699 3.33301 1.66699H16.6663C17.3294 1.66699 17.9653 1.93038 18.4341 2.39923C18.9029 2.86807 19.1663 3.50395 19.1663 4.16699V12.5003C19.1663 13.1634 18.9029 13.7993 18.4341 14.2681C17.9653 14.7369 17.3294 15.0003 16.6663 15.0003H15.833C15.3728 15.0003 14.9997 14.6272 14.9997 14.167C14.9997 13.7068 15.3728 13.3337 15.833 13.3337H16.6663C16.8874 13.3337 17.0993 13.2459 17.2556 13.0896C17.4119 12.9333 17.4997 12.7213 17.4997 12.5003V4.16699C17.4997 3.94598 17.4119 3.73402 17.2556 3.57774C17.0993 3.42146 16.8874 3.33366 16.6663 3.33366H3.33301Z"
        fill="#6D7F92"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 11.667C10.2473 11.667 10.4819 11.7768 10.6402 11.9668L14.8069 16.9668C15.0139 17.2152 15.0585 17.561 14.9213 17.8538C14.7842 18.1466 14.49 18.3337 14.1667 18.3337H5.83334C5.51 18.3337 5.21584 18.1466 5.07869 17.8538C4.94154 17.561 4.98616 17.2152 5.19316 16.9668L9.35983 11.9668C9.51816 11.7768 9.7527 11.667 10 11.667ZM7.61255 16.667H12.3875L10 13.802L7.61255 16.667Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function FullScreenIcon({ className }) {
  return (
    <svg
      className={className}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 64 64"
      enableBackground="new 0 0 64 64"
    >
      <g id="Responsive-scales">
        <path
          d="M44.8451996,18.5058994h-8c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1h5.5859985L32.4310989,30.5069008l1.4141006,1.4139996
		l10-10.0008011V27.5049c0,0.5527992,0.4473,1,1,1s1-0.4472008,1-1v-7.9990005
		C45.8451996,18.9531994,45.3978996,18.5058994,44.8451996,18.5058994z"
        />
        <path
          d="M22.3178005,42.0918007L10.8451996,53.5644989v-6.0585976c0-0.5527-0.4473-1-1-1s-1,0.4473-1,1v7.9990005
		c0,0.5527992,0.4473,1,1,1h8c0.5527,0,1-0.4472008,1-1c0-0.5527-0.4473-1-1-1h-5.1122999l10.9989996-10.9990005
		L22.3178005,42.0918007z"
        />
        <path
          d="M57.3041992,0H16.7884998C13.4946003,0,10.8139,2.6807001,10.8139,5.9747v4.1181002H6.6947999
		c-3.2939,0-5.9735999,2.6807003-5.9735999,5.9745998v41.9580002C0.7212,61.3194008,3.4008999,64,6.6947999,64h40.5165977
		c3.2938995,0,5.9746017-2.6805992,5.9746017-5.9746017v-2.6766968h4.1181984c3.2938995,0,5.9746017-2.6807022,5.9746017-5.9746017
		V5.9747C63.278801,2.6807001,60.5980988,0,57.3041992,0z M51.1860008,58.0253983
		C51.1860008,60.2168007,49.4028015,62,47.2113991,62H6.6947999C4.5033998,62,2.7212,60.2168007,2.7212,58.0253983V16.0674
		c0-2.1913996,1.7821999-3.9745998,3.9735999-3.9745998h40.5165977c2.1914024,0,3.9746017,1.7832003,3.9746017,3.9745998V58.0253983
		z M61.278801,49.3740997c0,2.1913986-1.7831993,3.9746017-3.9746017,3.9746017h-4.1181984V16.0674
		c0-3.2938995-2.6807022-5.9745998-5.9746017-5.9745998H12.8139V5.9747C12.8139,3.7832999,14.5971003,2,16.7884998,2h40.5157013
		c2.1914024,0,3.9746017,1.7832999,3.9746017,3.9747V49.3740997z"
        />
      </g>
    </svg>
  );
}

export function DoubleArrowUp({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M6.50838 7.83711L1.1555 13.2748C0.921139 13.5134 0.92409 13.897 1.1621 14.1326C1.4001 14.3675 1.78373 14.3646 2.01809 14.126L6.94624 9.11962L11.9508 14.049C12.1888 14.2839 12.5725 14.281 12.8074 14.0424C13.0418 13.8038 13.0388 13.4196 12.8008 13.1846L7.36491 7.82992C7.12938 7.59852 6.73972 7.60152 6.50838 7.83711Z"
          fill="#C7E8FE"
        />
      </g>
      <g clipPath="url(#clip1)">
        <path
          d="M6.58935 2.88323L1.19146 8.27623C0.955119 8.51288 0.954882 8.89651 1.19092 9.13404C1.42697 9.37098 1.8106 9.37121 2.04694 9.13457L7.01654 4.16934L11.98 9.14013C12.216 9.37707 12.5997 9.3773 12.8366 9.14066C13.0729 8.90402 13.0732 8.51979 12.8371 8.28285L7.44591 2.88316C7.21231 2.64982 6.82265 2.64958 6.58935 2.88323Z"
          fill="#18A0FB"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(1.00781 17.0078) rotate(-90.4408)"
          />
        </clipPath>
        <clipPath id="clip1">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(1.01172 12.0078) rotate(-89.9645)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Garbage({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.671 2.30263H11.342V1.75987C11.342 0.789474 10.5525 0 9.58213 0H6.41766C5.44727 0 4.65779 0.789474 4.65779 1.75987V2.30263H1.32884C1.08213 2.30263 0.884766 2.5 0.884766 2.74671C0.884766 2.99342 1.08213 3.19079 1.32884 3.19079H2.13148V13.625C2.13148 14.9342 3.19727 16 4.50648 16H11.4933C12.8025 16 13.8683 14.9342 13.8683 13.625V3.19079H14.671C14.9177 3.19079 15.115 2.99342 15.115 2.74671C15.115 2.5 14.9177 2.30263 14.671 2.30263ZM5.54595 1.75987C5.54595 1.27961 5.9374 0.888158 6.41766 0.888158H9.58213C10.0624 0.888158 10.4538 1.27961 10.4538 1.75987V2.30263H5.54595V1.75987ZM12.9802 13.625C12.9802 14.4441 12.3124 15.1118 11.4933 15.1118H4.50648C3.6874 15.1118 3.01963 14.4441 3.01963 13.625V3.19079H12.9835V13.625H12.9802Z"
        fill="#18A0FB"
      />
      <path
        d="M7.99876 13.52C8.24547 13.52 8.44283 13.3227 8.44283 13.076V5.22728C8.44283 4.98057 8.24547 4.7832 7.99876 4.7832C7.75205 4.7832 7.55469 4.98057 7.55469 5.22728V13.0727C7.55469 13.3194 7.75205 13.52 7.99876 13.52Z"
        fill="#18A0FB"
      />
      <path
        d="M5.10228 13.0294C5.34899 13.0294 5.54636 12.832 5.54636 12.5853V5.71361C5.54636 5.4669 5.34899 5.26953 5.10228 5.26953C4.85557 5.26953 4.6582 5.4669 4.6582 5.71361V12.5853C4.6582 12.832 4.85886 13.0294 5.10228 13.0294Z"
        fill="#18A0FB"
      />
      <path
        d="M10.8972 13.0294C11.1439 13.0294 11.3413 12.832 11.3413 12.5853V5.71361C11.3413 5.4669 11.1439 5.26953 10.8972 5.26953C10.6505 5.26953 10.4531 5.4669 10.4531 5.71361V12.5853C10.4531 12.832 10.6505 13.0294 10.8972 13.0294Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function Validate({ className }) {
  return (
    <svg
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2113 24C14.7547 24 14.323 23.7964 14.0454 23.4472L10.2966 18.7278C9.80897 18.114 9.9359 17.24 10.5798 16.7749C11.2247 16.3097 12.141 16.4315 12.6288 17.045L15.0944 20.1486L21.2957 10.6569C21.7226 10.0039 22.6242 9.8041 23.3107 10.2105C23.9963 10.6173 24.2057 11.4773 23.7785 12.1309L16.4529 23.343C16.1984 23.7328 15.7591 23.978 15.278 23.9988C15.2556 23.9996 15.2335 24 15.2113 24Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

// Dashboard Components Icons

export function ThreeDots({ className }) {
  return (
    <svg
      className={className}
      width="33"
      height="6"
      viewBox="0 0 33 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="3" fill="#6D7F92" fillOpacity="0.2" />
      <circle cx="30" cy="3" r="3" fill="#6D7F92" fillOpacity="0.2" />
      <circle cx="16" cy="3" r="3" fill="#6D7F92" fillOpacity="0.2" />
    </svg>
  );
}

export function DollarMoneyBagWithCoinStacks({ className }) {
  return (
    <svg
      className={className}
      width="101"
      height="101"
      viewBox="0 0 101 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M58.6568 20.7686H78.5193C79.2987 20.7686 79.9228 20.1667 79.9228 19.4243C79.9228 18.6893 79.2913 18.0889 78.5193 18.0889H58.6568C57.8819 18.0889 57.2578 18.6893 57.2578 19.4243C57.2578 20.1667 57.8922 20.7686 58.6568 20.7686Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M76.4715 16.0418C77.4017 11.1437 80.8903 4.43554 80.8903 4.43554C80.8903 4.43554 66.1358 -2.29483 62.7078 0.825601C61.3236 2.08265 64.7175 6.88161 63.4635 8.26288C62.2656 9.59979 56.291 8.26288 56.291 8.26288C56.291 8.26288 58.5921 12.4392 59.6702 16.0418H76.4715Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M86.3279 61.1505C85.5485 60.627 84.0948 60.0547 81.9357 59.4513V52.6544C83.2164 52.7002 84.1614 53.1823 84.7411 54.1318C85.0516 54.6449 85.2439 55.2542 85.3149 55.9626H87.7506C87.7003 54.3846 87.1901 53.1158 86.1904 52.1471C85.1995 51.1932 83.7887 50.6401 81.9342 50.5129V48.6865H80.6047V50.541C78.7355 50.5617 77.2862 51.1415 76.2465 52.2758C75.2054 53.4101 74.6878 54.6804 74.6878 56.0942C74.6878 57.6766 75.1744 58.91 76.1327 59.8092C77.0969 60.7024 78.589 61.3339 80.6047 61.7214V69.3287C79.0342 69.1971 77.9502 68.6085 77.369 67.5481C77.0377 66.9669 76.841 66.0382 76.7701 64.7575H74.293C74.293 66.3606 74.5606 67.628 75.0856 68.5671C76.0498 70.3077 77.8895 71.2646 80.5988 71.4465V74.1528H81.9342V71.4465C83.6142 71.2586 84.9023 70.8727 85.7926 70.3003C87.4045 69.2548 88.2075 67.4964 88.2075 65.0326C88.209 63.32 87.579 62.029 86.3279 61.1505ZM80.6062 59.191C79.568 58.978 78.7369 58.6172 78.1232 58.1025C77.5065 57.582 77.196 56.8603 77.196 55.9404C77.196 55.1699 77.4592 54.4423 77.9812 53.7472C78.4974 53.0448 79.3743 52.6706 80.6047 52.6351V59.191H80.6062ZM85.2217 67.6561C84.6213 68.7446 83.5269 69.3287 81.9357 69.3997V62.06C83.0951 62.3765 83.9262 62.7137 84.4187 63.0657C85.275 63.672 85.6994 64.5564 85.6994 65.7276C85.6964 66.4508 85.5456 67.0986 85.2217 67.6561Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M79.1359 22.7471C78.9362 22.7855 78.7321 22.8121 78.5177 22.8121H58.6552C58.2943 22.8121 57.9631 22.7397 57.6377 22.6436C46.984 32.7857 40.1236 46.8247 37.5371 58.1795C39.3916 57.6871 41.4398 57.4076 43.6226 57.4076C49.7525 57.4076 54.8811 59.5268 57.3641 62.6531L57.4041 62.4978L57.4677 62.7655C58.4097 64.0034 58.982 65.3802 58.982 66.8665C58.982 67.0794 58.9539 67.282 58.9214 67.495H59.0027V93.6134C62.0861 94.5008 65.3115 94.9903 68.5857 94.9903C85.2554 94.9903 100.822 82.6357 100.822 67.3885C100.823 55.3623 93.1214 37.4737 79.1359 22.7471ZM78.0859 77.4685C69.232 77.4685 62.0388 70.2827 62.0388 61.4197C62.0388 52.5657 69.2231 45.3754 78.0859 45.3754C86.9413 45.3754 94.1344 52.5598 94.1344 61.4197C94.133 70.2827 86.9487 77.4685 78.0859 77.4685Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M47.3341 64.6426C46.3359 64.6426 45.5684 64.8615 45.0478 65.2933C44.7373 65.5284 44.4504 65.9469 44.1738 66.5208H50.5329C50.4634 65.731 49.9709 65.1824 49.02 64.8822C48.5468 64.721 47.9804 64.6426 47.3341 64.6426Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M41.674 67.1885H35.9922C36.038 67.7963 36.3516 68.2355 36.9608 68.4988C37.5687 68.7591 38.2001 68.8759 38.8641 68.8759C39.6583 68.8759 40.2809 68.728 40.729 68.4174C41.1919 68.1172 41.5054 67.7031 41.674 67.1885Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M36.0226 66.5248H41.9129C42.4305 65.4482 42.9318 64.7236 43.3843 64.3331C44.1445 63.7061 45.2669 63.3955 46.7532 63.3955C48.9019 63.3955 50.4207 63.7934 51.3258 64.6053C51.8271 65.0519 52.1554 65.6878 52.3166 66.5352H54.6665V67.1963H52.3166C52.1628 68.5465 51.3361 69.4634 49.8203 69.9425C49.004 70.2087 47.9067 70.3374 46.5225 70.3374V69.1025C47.6242 69.0626 48.4243 68.9709 48.9315 68.8053C49.8484 68.5154 50.3586 67.9786 50.4725 67.1963H43.8812C43.5485 68.1989 42.991 68.9487 42.2264 69.4235C41.4411 69.9085 40.3778 70.1377 39.0054 70.1377C37.7736 70.1377 36.6674 69.8878 35.6869 69.3658C34.7094 68.8496 34.2021 68.128 34.1799 67.1963H32.5739V66.5352H34.1622C34.2775 65.6109 34.7493 64.9055 35.5789 64.4041C36.413 63.9117 37.5133 63.6558 38.8753 63.6292V64.8493C38.2586 64.8862 37.7307 64.9779 37.29 65.1391C36.4855 65.4157 36.0536 65.8875 36.0226 66.5248ZM43.6224 58.8643C35.9412 58.8643 29.7227 62.4431 29.7227 66.8591C29.7227 71.2706 35.9472 74.8539 43.6224 74.8539C51.2992 74.8539 57.5163 71.2706 57.5163 66.8591C57.5163 62.4431 51.2947 58.8643 43.6224 58.8643Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 75.9261C36.5727 75.9261 30.7697 72.9033 29.8646 68.9961C29.7892 69.3466 29.7227 69.7045 29.7227 70.0698C29.7227 74.4827 35.9472 78.0646 43.6224 78.0646C51.2992 78.0646 57.5163 74.4827 57.5163 70.0698C57.5163 69.7089 57.4557 69.3481 57.3847 68.9961C56.4737 72.9033 50.6692 75.9261 43.6224 75.9261Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 79.1381C36.5727 79.1381 30.7697 76.1226 29.8646 72.2051C29.7892 72.563 29.7227 72.9105 29.7227 73.2787C29.7227 77.6932 35.9472 81.2795 43.6224 81.2795C51.2992 81.2795 57.5163 77.6932 57.5163 73.2787C57.5163 72.9209 57.4557 72.5644 57.3847 72.2051C56.4737 76.1226 50.6692 79.1381 43.6224 79.1381Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 82.3534C36.5727 82.3534 30.7697 79.3306 29.8646 75.4189C29.7892 75.768 29.7227 76.1273 29.7227 76.4911C29.7227 80.9071 35.9472 84.4859 43.6224 84.4859C51.2992 84.4859 57.5163 80.9071 57.5163 76.4911C57.5163 76.1347 57.4557 75.7694 57.3847 75.4189C56.4737 79.3306 50.6692 82.3534 43.6224 82.3534Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 85.5482C36.5727 85.5482 30.7697 82.5328 29.8646 78.6182C29.7892 78.9761 29.7227 79.3265 29.7227 79.6948C29.7227 84.1107 35.9472 87.6867 43.6224 87.6867C51.2992 87.6867 57.5163 84.1107 57.5163 79.6948C57.5163 79.331 57.4557 78.9775 57.3847 78.6182C56.4737 82.5328 50.6692 85.5482 43.6224 85.5482Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 89.2377C36.5727 89.2377 30.7697 86.2148 29.8646 82.3047C29.7892 82.6552 29.7227 83.0131 29.7227 83.3784C29.7227 87.7943 35.9472 91.3732 43.6224 91.3732C51.2992 91.3732 57.5163 87.7943 57.5163 83.3784C57.5163 83.0205 57.4557 82.6567 57.3847 82.3047C56.4737 86.2148 50.6692 89.2377 43.6224 89.2377Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 92.4466C36.5727 92.4466 30.7697 89.4312 29.8646 85.5166C29.7892 85.8701 29.7227 86.222 29.7227 86.5829C29.7227 91.0018 35.9472 94.5851 43.6224 94.5851C51.2992 94.5851 57.5163 91.0018 57.5163 86.5829C57.5163 86.2265 57.4557 85.8715 57.3847 85.5166C56.4737 89.4312 50.6692 92.4466 43.6224 92.4466Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 95.6571C36.5727 95.6571 30.7697 92.6254 29.8646 88.7197C29.7892 89.0702 29.7227 89.4281 29.7227 89.7919C29.7227 94.2049 35.9472 97.7867 43.6224 97.7867C51.2992 97.7867 57.5163 94.2049 57.5163 89.7919C57.5163 89.4325 57.4557 89.0717 57.3847 88.7197C56.4737 92.6254 50.6692 95.6571 43.6224 95.6571Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M43.6224 98.8636C36.5727 98.8636 30.7697 95.8438 29.8646 91.9307C29.7892 92.2856 29.7227 92.6391 29.7227 93.0014C29.7227 97.4203 35.9472 101.002 43.6224 101.002C51.2992 101.002 57.5163 97.4203 57.5163 93.0014C57.5163 92.6435 57.4557 92.2871 57.3847 91.9307C56.4737 95.8438 50.6692 98.8636 43.6224 98.8636Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M17.7898 72.4658C16.7901 72.4658 16.0152 72.6817 15.502 73.1136C15.187 73.3531 14.9031 73.7672 14.6191 74.341H20.9871C20.9146 73.5528 20.4163 73.0056 19.4742 72.7024C18.9892 72.5472 18.4257 72.4658 17.7898 72.4658Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M12.1329 75.0127H6.45117C6.4911 75.6205 6.81053 76.0583 7.41391 76.323C8.02024 76.5788 8.65023 76.7075 9.31868 76.7075C10.1202 76.7075 10.7339 76.5581 11.188 76.2461C11.642 75.9444 11.9555 75.5303 12.1329 75.0127Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M6.47027 74.3412H12.3591C12.89 73.269 13.381 72.5429 13.835 72.1495C14.5936 71.5225 15.7279 71.2149 17.2053 71.2149C19.3511 71.2149 20.8729 71.6068 21.772 72.4187C22.2763 72.8638 22.6002 73.5042 22.7702 74.3412H25.1113V75.0097H22.7702C22.6105 76.3525 21.7853 77.2694 20.2695 77.7545C19.4591 78.0147 18.3558 78.1538 16.9702 78.1538V76.9189C18.0749 76.879 18.8779 76.7769 19.3851 76.6216C20.2961 76.3259 20.8034 75.7949 20.9187 75.0067H14.3319C14.005 76.0079 13.4446 76.7577 12.677 77.2398C11.9021 77.7219 10.8299 77.9541 9.462 77.9541C8.23307 77.9541 7.12245 77.7012 6.14196 77.1747C5.16 76.669 4.65276 75.9443 4.63945 75.0067H3.02601V74.3412H4.61431C4.72966 73.4213 5.20585 72.7159 6.03105 72.2234C6.86808 71.7236 7.96687 71.4663 9.33038 71.4411V72.6656C8.71222 72.6967 8.18722 72.7928 7.74505 72.9511C6.94498 73.2454 6.51316 73.7171 6.47027 74.3412ZM14.0716 66.6865C6.39633 66.6865 0.177734 70.2698 0.177734 74.6887C0.177734 79.1047 6.39781 82.6806 14.0716 82.6806C21.7617 82.6806 27.9714 79.1047 27.9714 74.6887C27.9743 70.2698 21.7602 66.6865 14.0716 66.6865Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M14.0716 83.7572C7.02484 83.7572 1.22772 80.7344 0.319705 76.8242C0.239846 77.1791 0.177734 77.5326 0.177734 77.8934C0.177734 82.3123 6.39781 85.8912 14.0716 85.8912C21.7617 85.8912 27.9714 82.3123 27.9714 77.8934C27.9714 77.5356 27.9093 77.1791 27.8368 76.8242C26.9273 80.7344 21.1287 83.7572 14.0716 83.7572Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
        <path
          d="M14.0716 86.9677C7.02484 86.9677 1.22772 83.9448 0.319705 80.0332C0.239846 80.3911 0.177734 80.7416 0.177734 81.0995C0.177734 85.5258 6.39781 89.1046 14.0716 89.1046C21.7617 89.1046 27.9714 85.5258 27.9714 81.0995C27.9714 80.7431 27.9093 80.3911 27.8368 80.0332C26.9273 83.9448 21.1287 86.9677 14.0716 86.9677Z"
          fill="#6D7F92"
          fillOpacity="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="101" height="101" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PiggyBank({ className }) {
  return (
    <svg
      className={className}
      width="102"
      height="102"
      viewBox="0 0 102 102"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.17 53.9102C83.3502 53.9102 82.6856 54.5747 82.6856 55.3945C82.6856 56.4339 81.8402 57.2793 80.8008 57.2793C79.7617 57.2793 78.916 56.4339 78.916 55.3945C78.916 54.5745 78.2514 53.9102 77.4316 53.9102C76.6119 53.9102 75.9473 54.5747 75.9473 55.3945C75.9473 58.0708 78.1247 60.2481 80.8008 60.2481C83.4769 60.2481 85.6544 58.0706 85.6544 55.3945C85.6544 54.5743 84.9898 53.9102 84.17 53.9102Z"
        fill="#6D7F92"
        fillOpacity="0.88"
      />
      <path
        d="M98.1041 54.1532L93.9261 52.8148C93.391 52.6433 92.9692 52.2162 92.7981 51.6721C91.9175 48.8725 90.5887 46.2442 88.8486 43.8599C88.0555 42.7732 87.1735 41.7355 86.2101 40.7476C86.8265 38.0436 87.1616 34.9834 87.1182 32.3395C87.056 28.5574 86.3002 26.3391 84.8076 25.5573C84.0038 25.1358 81.5574 23.8552 68.3159 29.9166C68.0023 30.0601 67.7095 30.2368 67.4383 30.4392C66.5456 30.1993 65.6332 29.9774 64.7152 29.7782C64.6046 29.7541 64.4907 29.7327 64.3793 29.7092C65.4523 27.3652 66.0789 24.8194 66.1966 22.1913C66.2333 21.3721 65.5992 20.6785 64.78 20.642C63.963 20.6014 63.2671 21.2393 63.2306 22.0584C63.0372 26.3797 61.2446 30.4456 58.1834 33.5069C56.3544 35.336 54.2128 36.6646 51.9304 37.5013C47.9721 36.9459 43.9403 36.9459 39.982 37.5013C37.6994 36.6646 35.558 35.336 33.7289 33.5069C30.4629 30.241 28.6642 25.8986 28.6642 21.2797C28.6642 16.6606 30.4629 12.3184 33.7289 9.05245C36.9949 5.78626 41.3375 3.98751 45.9562 3.98751C50.5749 3.98751 54.9174 5.78626 58.1834 9.05245C59.4959 10.3649 60.5804 11.8626 61.407 13.5036C61.7757 14.2359 62.6684 14.5308 63.4006 14.1618C64.1329 13.7933 64.4275 12.9006 64.0588 12.1684C63.09 10.2442 61.8196 8.48966 60.283 6.95288C56.4562 3.12609 51.3682 1.01855 45.9564 1.01855C40.5446 1.01855 35.4566 3.12609 31.6298 6.95288C27.803 10.7799 25.6954 15.8677 25.6954 21.2795C25.6954 26.6913 27.803 31.7793 31.6298 35.6061C32.7336 36.71 33.9345 37.6593 35.2047 38.4545C35.2051 38.4545 35.2055 38.4543 35.2059 38.4543C34.283 38.6942 33.3669 38.9635 32.4611 39.2664C31.6836 39.5263 31.264 40.3672 31.524 41.145C31.7838 41.9225 32.6251 42.3421 33.4024 42.0823C41.4979 39.3759 50.4149 39.3759 58.5103 42.0823C58.6665 42.1345 58.8251 42.1592 58.9811 42.1592C59.6021 42.1592 60.181 41.7664 60.3888 41.145C60.6488 40.3674 60.2292 39.5263 59.4517 39.2664C58.5458 38.9635 57.6298 38.694 56.7068 38.4543C56.7072 38.4543 56.7076 38.4545 56.708 38.4545C57.9784 37.6593 59.1791 36.71 60.283 35.6061C61.2596 34.6295 62.1216 33.5631 62.8701 32.4298C63.2792 32.5093 63.6855 32.5925 64.0857 32.6794C64.6188 32.7951 65.1495 32.9194 65.6755 33.0499C65.6589 33.1145 65.642 33.1788 65.6282 33.2444C64.9043 36.6799 64.9513 39.7184 65.7679 42.275C66.5018 44.5729 67.8264 46.4346 69.7045 47.8087C71.918 49.4279 74.5903 50.1274 77.011 50.1274C78.8329 50.1274 80.5125 49.7309 81.746 49.0323C83.1414 48.242 84.3104 46.5767 85.2357 44.0765C85.6635 44.5757 86.0689 45.0871 86.451 45.6107C88.0003 47.7332 89.1831 50.0724 89.9664 52.563C90.4264 54.0259 91.5683 55.177 93.0208 55.6425L97.1988 56.9809C98.2951 57.3321 99.0316 58.3412 99.0316 59.4922V66.4201C99.0316 67.5712 98.2951 68.5802 97.1988 68.9314L90.4674 71.0876C89.3904 71.4328 88.479 72.1729 87.9011 73.1718C85.2565 77.7423 81.0986 81.5244 75.5422 84.4133C74.9003 84.7474 74.4556 85.3449 74.3217 86.0529L72.1658 97.4687C72.1062 97.7833 71.8307 98.0114 71.5106 98.0114H64.5007C64.1805 98.0114 63.905 97.7831 63.8454 97.4687L62.6513 91.1597C62.4162 89.9183 61.252 89.0938 59.9989 89.2836C56.9793 89.7402 53.868 89.9715 50.7516 89.9715C48.4331 89.9715 46.1442 89.8422 43.9483 89.587C42.734 89.4474 41.6029 90.2751 41.3759 91.474L40.2412 97.4687C40.1816 97.7833 39.9061 98.0114 39.586 98.0114H32.5761C32.2559 98.0114 31.9804 97.7831 31.92 97.4639L29.8442 86.6818C29.7105 85.9871 29.2742 85.3965 28.6465 85.0612C19.1748 80.0048 14.1684 71.5571 14.1684 60.632C14.1684 55.112 15.3761 50.231 17.7578 46.1239C19.9802 42.2911 23.2263 39.1221 27.4057 36.7046C28.1153 36.294 28.3578 35.386 27.9474 34.6762C27.537 33.9665 26.629 33.7245 25.9192 34.1345C17.8151 38.8225 12.9273 46.0549 11.5816 55.2409V55.2407C11.4387 55.2278 11.2957 55.2154 11.1533 55.2007C11.1792 54.2096 10.9999 53.2095 10.6094 52.2389C9.74817 50.0981 7.97911 48.5529 6.10227 48.3025C4.62327 48.1045 3.21579 48.7324 2.23902 50.023C0.822773 51.8944 1.05367 53.3754 1.49653 54.2883C2.2442 55.8288 4.16606 56.9185 7.35536 57.6036C7.2677 57.7349 7.17128 57.8668 7.06569 57.9993C5.18128 60.3626 2.96119 60.8852 1.51964 60.9344C0.67575 60.9629 0 61.6404 0 62.4849V62.4921C0 63.325 0.657223 64.0043 1.48936 64.0424C1.59594 64.0474 1.7073 64.05 1.82325 64.05C3.6473 64.05 6.57482 63.3772 9.38739 59.8504C9.83145 59.2938 10.1932 58.7065 10.4713 58.0997C10.7514 58.1314 11.0206 58.1585 11.2784 58.1824C11.2784 58.1818 11.2784 58.1814 11.2786 58.1808C11.228 58.9852 11.1999 59.8014 11.1999 60.632C11.1999 66.8133 12.6735 72.3247 15.5795 77.0137C18.259 81.3368 22.0954 84.8765 26.9858 87.5385L29.0039 98.0206C29.3284 99.7354 30.8307 100.98 32.5761 100.98H39.586C41.3313 100.98 42.8336 99.7354 43.1582 98.0206L44.1841 92.6002C46.315 92.8259 48.5211 92.9403 50.7514 92.9403C53.8114 92.9403 56.8678 92.7271 59.8465 92.3064L60.9281 98.0209C61.2528 99.7358 62.7551 100.98 64.5003 100.98H71.5102C73.2555 100.98 74.7578 99.7356 75.0826 98.0201L77.1817 86.9055C83.1121 83.7696 87.5821 79.6502 90.4704 74.6586C90.6786 74.2988 90.9991 74.0348 91.3729 73.9151L98.1041 71.7589C100.434 71.0121 102 68.8667 102 66.4197V59.4918C102 57.045 100.434 54.8997 98.1041 54.1532ZM83.9265 36.511C83.3551 41.397 81.8225 45.5766 80.2826 46.4488C78.5322 47.4403 74.4911 47.6318 71.457 45.4123C68.4193 43.1902 67.4083 39.1942 68.5328 33.8564C68.5328 33.8562 68.5328 33.8562 68.5328 33.8562C68.6458 33.3201 69.0267 32.8563 69.5517 32.616C76.9833 29.2142 81.2679 28.1015 82.8597 28.1015C83.0999 28.1015 83.2788 28.1268 83.3979 28.1735C83.8761 28.6831 84.5032 31.5799 83.9265 36.511ZM4.16786 52.9919C4.01426 52.6752 4.37684 52.1184 4.60673 51.8143C4.97111 51.333 5.30679 51.2346 5.56039 51.2346C5.61398 51.2346 5.66399 51.239 5.70981 51.2452C6.39233 51.3362 7.34858 52.0873 7.8552 53.3465C7.97453 53.643 8.12952 54.1341 8.16578 54.7465C6.11084 54.3207 4.5143 53.7069 4.16786 52.9919Z"
        fill="#6D7F92"
        fillOpacity="0.88"
      />
      <path
        d="M47.3974 19.578V14.266C49.2292 14.3969 49.9097 15.2342 50.5377 15.2342C51.3228 15.2342 51.6891 14.2399 51.6891 13.7427C51.6891 12.4603 49.1768 11.9109 47.3974 11.8585V11.1516C47.3974 10.8377 47.0047 10.5498 46.6122 10.5498C46.1672 10.5498 45.8532 10.8377 45.8532 11.1516V11.9105C43.3672 12.1722 40.8811 13.4807 40.8811 16.778C40.8811 20.1276 43.4981 21.0697 45.8532 21.9071V28.0567C43.1839 27.8474 42.4774 26.0156 41.6138 26.0156C40.9596 26.0156 40.4102 26.8792 40.4102 27.5073C40.4102 28.7895 42.6083 30.5428 45.8532 30.5952V31.4064C45.8532 31.7204 46.1674 32.0083 46.6122 32.0083C47.0049 32.0083 47.3974 31.7204 47.3974 31.4064V30.5167C50.2237 30.124 52.1601 28.3446 52.1601 25.1258C52.1601 21.567 49.674 20.4153 47.3974 19.578ZM46.0102 19.0809C44.6232 18.5576 43.498 18.0082 43.498 16.5166C43.498 15.1557 44.5447 14.5015 46.0102 14.3184V19.0809V19.0809ZM47.2402 28.0044V22.4828C48.5224 23.0323 49.543 23.765 49.543 25.4135C49.543 26.9055 48.6532 27.7428 47.2402 28.0044Z"
        fill="#6D7F92"
        fillOpacity="0.88"
      />
    </svg>
  );
}

export function ProfitBarChartIcon({ className }) {
  return (
    <svg
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 18.6953H1.7C0.761317 18.6953 0 19.4566 0 20.3953V31.7286C0 32.6673 0.761317 33.4286 1.7 33.4286H8.5C9.43868 33.4286 10.2 32.6673 10.2 31.7286V20.3953C10.2 19.4566 9.43868 18.6953 8.5 18.6953ZM9.06667 31.7286C9.06667 32.0417 8.81308 32.2953 8.5 32.2953H1.7C1.38692 32.2953 1.13333 32.0417 1.13333 31.7286V20.3953C1.13333 20.0822 1.38692 19.8286 1.7 19.8286H8.5C8.81308 19.8286 9.06667 20.0822 9.06667 20.3953V31.7286Z"
        fill="white"
      />
      <path
        d="M32.2998 13.0283H25.4998C24.5611 13.0283 23.7998 13.7896 23.7998 14.7283V31.7283C23.7998 32.667 24.5611 33.4283 25.4998 33.4283H32.2998C33.2385 33.4283 33.9998 32.667 33.9998 31.7283V14.7283C33.9998 13.7896 33.2385 13.0283 32.2998 13.0283ZM32.8665 31.7283C32.8665 32.0414 32.6129 32.295 32.2998 32.295H25.4998C25.1867 32.295 24.9331 32.0414 24.9331 31.7283V14.7283C24.9331 14.4152 25.1867 14.1617 25.4998 14.1617H32.2998C32.6129 14.1617 32.8665 14.4152 32.8665 14.7283V31.7283Z"
        fill="white"
      />
      <path
        d="M20.4004 15.8613H13.6004C12.6617 15.8613 11.9004 16.6226 11.9004 17.5613V31.728C11.9004 32.6667 12.6617 33.428 13.6004 33.428H20.4004C21.3391 33.428 22.1004 32.6667 22.1004 31.728V17.5613C22.1004 16.6226 21.3391 15.8613 20.4004 15.8613ZM20.9671 31.728C20.9671 32.0411 20.7135 32.2947 20.4004 32.2947H13.6004C13.2873 32.2947 13.0337 32.0411 13.0337 31.728V17.5613C13.0337 17.2482 13.2873 16.9947 13.6004 16.9947H20.4004C20.7135 16.9947 20.9671 17.2482 20.9671 17.5613V31.728Z"
        fill="white"
      />
      <path
        d="M21.1333 12.2955C21.3547 12.5166 21.7132 12.5166 21.9346 12.2955L31.734 2.49612V3.39486C31.734 3.70794 31.9875 3.96152 32.3006 3.96152C32.6137 3.96152 32.8673 3.70794 32.8673 3.39486V1.12819C32.8659 1.06047 32.8528 0.993465 32.8276 0.93014C32.8198 0.911157 32.8109 0.892315 32.8014 0.873473C32.7802 0.831398 32.7537 0.791732 32.7222 0.75589C32.6716 0.693273 32.6069 0.643832 32.533 0.611957C32.5276 0.611957 32.5239 0.60544 32.5186 0.60374C32.4557 0.578807 32.3892 0.56549 32.3217 0.564215C32.3131 0.56549 32.3076 0.561523 32.3006 0.561523H30.034C29.7209 0.561523 29.4673 0.815107 29.4673 1.12819C29.4673 1.44127 29.7209 1.69486 30.034 1.69486H30.9327L21.534 11.0936L16.5513 6.11089C16.3298 5.88975 15.9714 5.88975 15.75 6.11089L9.91729 11.9436L7.20126 9.22756C6.97983 9.00642 6.62141 9.00642 6.39999 9.22756L1.29999 14.3276C1.15266 14.4696 1.09358 14.6806 1.14543 14.8786C1.19742 15.0768 1.35198 15.2314 1.55017 15.2834C1.74822 15.3352 1.95916 15.2762 2.10126 15.1288L6.80062 10.4295L9.51666 13.1455C9.73808 13.3666 10.0965 13.3666 10.3179 13.1455L16.1506 7.31279L21.1333 12.2955Z"
        fill="white"
      />
    </svg>
  );
}

export function DeficitBarChartIcon({ className }) {
  return (
    <svg
      className={className}
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 15.3047H1.7C0.761317 15.3047 0 14.5434 0 13.6047V2.27135C0 1.33267 0.761317 0.57135 1.7 0.57135H8.5C9.43868 0.57135 10.2 1.33267 10.2 2.27135V13.6047C10.2 14.5434 9.43868 15.3047 8.5 15.3047ZM9.06667 2.27135C9.06667 1.95827 8.81308 1.70468 8.5 1.70468H1.7C1.38692 1.70468 1.13333 1.95827 1.13333 2.27135V13.6047C1.13333 13.9178 1.38692 14.1714 1.7 14.1714H8.5C8.81308 14.1714 9.06667 13.9178 9.06667 13.6047V2.27135Z"
        fill="white"
      />
      <path
        d="M32.2988 20.9717H25.4988C24.5601 20.9717 23.7988 20.2104 23.7988 19.2717V2.27169C23.7988 1.333 24.5601 0.571688 25.4988 0.571688H32.2988C33.2375 0.571688 33.9988 1.333 33.9988 2.27169V19.2717C33.9988 20.2104 33.2375 20.9717 32.2988 20.9717ZM32.8655 2.27169C32.8655 1.9586 32.6119 1.70502 32.2988 1.70502H25.4988C25.1857 1.70502 24.9322 1.9586 24.9322 2.27169V19.2717C24.9322 19.5848 25.1857 19.8383 25.4988 19.8383H32.2988C32.6119 19.8383 32.8655 19.5848 32.8655 19.2717V2.27169Z"
        fill="white"
      />
      <path
        d="M20.4004 18.1387H13.6004C12.6617 18.1387 11.9004 17.3774 11.9004 16.4387V2.27201C11.9004 1.33333 12.6617 0.572012 13.6004 0.572012H20.4004C21.3391 0.572012 22.1004 1.33333 22.1004 2.27201V16.4387C22.1004 17.3774 21.3391 18.1387 20.4004 18.1387ZM20.9671 2.27201C20.9671 1.95893 20.7135 1.70535 20.4004 1.70535H13.6004C13.2873 1.70535 13.0337 1.95893 13.0337 2.27201V16.4387C13.0337 16.7518 13.2873 17.0053 13.6004 17.0053H20.4004C20.7135 17.0053 20.9671 16.7518 20.9671 16.4387V2.27201Z"
        fill="white"
      />
      <path
        d="M21.1333 21.7045C21.3547 21.4834 21.7132 21.4834 21.9346 21.7045L31.734 31.5039V30.6051C31.734 30.2921 31.9875 30.0385 32.3006 30.0385C32.6137 30.0385 32.8673 30.2921 32.8673 30.6051V32.8718C32.8659 32.9395 32.8528 33.0065 32.8276 33.0699C32.8198 33.0888 32.8109 33.1077 32.8014 33.1265C32.7802 33.1686 32.7537 33.2083 32.7222 33.2441C32.6716 33.3067 32.6069 33.3562 32.533 33.388C32.5276 33.388 32.5239 33.3946 32.5186 33.3963C32.4557 33.4212 32.3892 33.4345 32.3217 33.4358C32.3131 33.4345 32.3076 33.4385 32.3006 33.4385H30.034C29.7209 33.4385 29.4673 33.1849 29.4673 32.8718C29.4673 32.5587 29.7209 32.3051 30.034 32.3051H30.9327L21.534 22.9064L16.5513 27.8891C16.3298 28.1103 15.9714 28.1103 15.75 27.8891L9.91729 22.0564L7.20126 24.7724C6.97983 24.9936 6.62141 24.9936 6.39999 24.7724L1.29999 19.6724C1.15266 19.5304 1.09358 19.3194 1.14543 19.1214C1.19742 18.9232 1.35198 18.7686 1.55017 18.7166C1.74822 18.6648 1.95916 18.7238 2.10126 18.8712L6.80062 23.5705L9.51666 20.8545C9.73808 20.6334 10.0965 20.6334 10.3179 20.8545L16.1506 26.6872L21.1333 21.7045Z"
        fill="white"
      />
    </svg>
  );
}

export function TrafficLight({ className }) {
  return (
    <svg
      className={className}
      width="51"
      height="128"
      viewBox="0 0 51 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d)">
        <path
          d="M1 5C1 2.23858 3.23858 0 6 0H41C43.7614 0 46 2.23858 46 5V104C46 106.761 43.7614 109 41 109H6C3.23858 109 1 106.761 1 104V5Z"
          fill="#9DD1F3"
          className={"fill_background"}
        />
        <path
          d="M1.5 5C1.5 2.51472 3.51472 0.5 6 0.5H41C43.4853 0.5 45.5 2.51472 45.5 5V104C45.5 106.485 43.4853 108.5 41 108.5H6C3.51472 108.5 1.5 106.485 1.5 104V5Z"
          stroke="#6D7F92"
          strokeOpacity="0.1"
          className={"fill_stroke"}
        />
      </g>
      <rect
        x="19"
        y="108"
        width="10"
        height="20"
        fill="#9DD1F3"
        className={"fill_background"}
      />
      <rect
        x="19.5"
        y="108.5"
        width="9"
        height="19"
        stroke="#6D7F92"
        strokeOpacity="0.1"
        className={"fill_stroke"}
      />
      <circle
        className={"blue_light"}
        cx="24"
        cy="88"
        r="13.5"
        fill="#18A0FB"
        stroke="white"
      />
      <circle
        className={"orange_light"}
        cx="24"
        cy="54"
        r="13.5"
        fill="#F9943A"
        stroke="white"
      />
      <circle
        className={"red_light"}
        cx="24"
        cy="20"
        r="13.5"
        fill="#FB1E5C"
        stroke="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="0"
          y="0"
          width="51"
          height="116"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dx="2" dy="4" />
          <feGaussianBlur stdDeviation="1.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export function EditIcon({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5446 1.28273C11.3906 1.28273 11.2381 1.31306 11.0958 1.372C10.9535 1.43093 10.8243 1.51731 10.7154 1.6262L2.17738 10.1642L1.55547 12.4445L3.83581 11.8226L12.3738 3.28464C12.4827 3.17574 12.5691 3.04646 12.628 2.90419C12.6869 2.76191 12.7173 2.60942 12.7173 2.45542C12.7173 2.30142 12.6869 2.14893 12.628 2.00665C12.5691 1.86437 12.4827 1.7351 12.3738 1.6262C12.2649 1.51731 12.1356 1.43093 11.9934 1.372C11.8511 1.31306 11.6986 1.28273 11.5446 1.28273ZM10.6049 0.186908C10.9028 0.0635111 11.2221 0 11.5446 0C11.867 0 12.1863 0.0635112 12.4842 0.186908C12.7821 0.310304 13.0528 0.491169 13.2808 0.719175C13.5088 0.947182 13.6897 1.21786 13.8131 1.51577C13.9365 1.81368 14 2.13297 14 2.45542C14 2.77787 13.9365 3.09716 13.8131 3.39507C13.6897 3.69297 13.5088 3.96366 13.2808 4.19166L4.6224 12.8501C4.54348 12.929 4.44532 12.986 4.33764 13.0153L0.810134 13.9774C0.588086 14.0379 0.350613 13.9749 0.187866 13.8121C0.0251199 13.6494 -0.0379445 13.4119 0.0226141 13.1899L0.984661 9.66236C1.01403 9.55468 1.07099 9.45652 1.14991 9.3776L9.80834 0.719175C10.0363 0.491169 10.307 0.310304 10.6049 0.186908Z"
        fill="#6D7F92"
      />
    </svg>
  );
}
export function DeleteIcon({ className }) {
  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.671 2.30263H11.342V1.75987C11.342 0.789474 10.5525 0 9.58213 0H6.41766C5.44727 0 4.65779 0.789474 4.65779 1.75987V2.30263H1.32884C1.08213 2.30263 0.884766 2.5 0.884766 2.74671C0.884766 2.99342 1.08213 3.19079 1.32884 3.19079H2.13148V13.625C2.13148 14.9342 3.19727 16 4.50648 16H11.4933C12.8025 16 13.8683 14.9342 13.8683 13.625V3.19079H14.671C14.9177 3.19079 15.115 2.99342 15.115 2.74671C15.115 2.5 14.9177 2.30263 14.671 2.30263ZM5.54595 1.75987C5.54595 1.27961 5.9374 0.888158 6.41766 0.888158H9.58213C10.0624 0.888158 10.4538 1.27961 10.4538 1.75987V2.30263H5.54595V1.75987ZM12.9802 13.625C12.9802 14.4441 12.3124 15.1118 11.4933 15.1118H4.50648C3.6874 15.1118 3.01963 14.4441 3.01963 13.625V3.19079H12.9835V13.625H12.9802Z"
        fill="#FE3745"
      />
      <path
        d="M7.99876 13.5198C8.24547 13.5198 8.44283 13.3224 8.44283 13.0757V5.22704C8.44283 4.98033 8.24547 4.78296 7.99876 4.78296C7.75205 4.78296 7.55469 4.98033 7.55469 5.22704V13.0724C7.55469 13.3191 7.75205 13.5198 7.99876 13.5198Z"
        fill="#FE3745"
      />
      <path
        d="M5.10228 13.0296C5.34899 13.0296 5.54636 12.8323 5.54636 12.5856V5.71385C5.54636 5.46714 5.34899 5.26978 5.10228 5.26978C4.85557 5.26978 4.6582 5.46714 4.6582 5.71385V12.5856C4.6582 12.8323 4.85886 13.0296 5.10228 13.0296Z"
        fill="#FE3745"
      />
      <path
        d="M10.8972 13.0296C11.1439 13.0296 11.3413 12.8323 11.3413 12.5856V5.71385C11.3413 5.46714 11.1439 5.26978 10.8972 5.26978C10.6505 5.26978 10.4531 5.46714 10.4531 5.71385V12.5856C10.4531 12.8323 10.6505 13.0296 10.8972 13.0296Z"
        fill="#FE3745"
      />
    </svg>
  );
}

export function CloseIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8118 13.0706L8.24661 9.50538C7.91843 9.1772 7.91843 8.64512 8.24661 8.31698C8.57479 7.9888 9.10683 7.9888 9.43501 8.31698L13.0003 11.8822L16.5655 8.31694C16.8937 7.98876 17.4257 7.98876 17.7539 8.31694C18.082 8.64512 18.082 9.1772 17.7539 9.50534L14.1887 13.0705L17.7539 16.6358C18.082 16.964 18.082 17.496 17.7539 17.8242C17.4257 18.1524 16.8937 18.1524 16.5655 17.8242L13.0003 14.2589L9.43501 17.8242C9.10688 18.1524 8.57479 18.1524 8.24661 17.8242C7.91843 17.496 7.91843 16.964 8.24661 16.6358L11.8118 13.0706Z"
      />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}

export function CheckAuthorisationIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M11.258 18.9999C10.885 18.9999 10.5322 18.8254 10.3054 18.5261L7.24231 14.4809C6.84391 13.9548 6.94762 13.2056 7.47374 12.8071C8.00071 12.4083 8.74934 12.5127 9.14791 13.0385L11.1625 15.6987L16.2295 7.56306C16.5783 7.00334 17.3149 6.83209 17.8759 7.18043C18.4361 7.52912 18.6072 8.26626 18.2581 8.82649L12.2725 18.4368C12.0646 18.7709 11.7056 18.9811 11.3125 18.9989C11.2942 18.9996 11.2762 18.9999 11.258 18.9999Z" />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}

export function AddIcon({ className }) {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1592 12.1597L12.1592 7.11772C12.1592 6.6536 12.5355 6.27736 12.9995 6.27739C13.4637 6.27739 13.8399 6.6536 13.8399 7.11771L13.8399 12.1597L18.8819 12.1597C19.346 12.1597 19.7222 12.5359 19.7222 13C19.7222 13.4641 19.346 13.8404 18.8819 13.8404L13.8399 13.8403L13.8399 18.8823C13.8399 19.3464 13.4637 19.7227 12.9996 19.7227C12.5355 19.7227 12.1593 19.3465 12.1593 18.8823L12.1593 13.8403L7.11727 13.8403C6.65318 13.8404 6.27694 13.4641 6.27694 13C6.27694 12.5359 6.65315 12.1597 7.11727 12.1597L12.1592 12.1597Z"
      />
      <circle cx="13" cy="13" r="12.35" strokeWidth="1.3" />
    </svg>
  );
}

export function SimplePlusIcon({ className }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3488 5.16276H6.83719V0.651161C6.83719 0.445639 6.55811 0 5.99998 0C5.44184 0 5.16276 0.445663 5.16276 0.651161V5.16279H0.651161C0.445663 5.16276 0 5.44184 0 5.99995C0 6.55806 0.445663 6.83716 0.651161 6.83716H5.16279V11.3488C5.16279 11.5543 5.44184 12 6 12C6.55816 12 6.83721 11.5543 6.83721 11.3488V6.83716H11.3488C11.5543 6.83716 12 6.55811 12 5.99995C12 5.44179 11.5543 5.16276 11.3488 5.16276Z"
        fill="#18A0FB"
      />
    </svg>
  );
}

export function LoopIcon({ className }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8404 17.082L13.4661 12.7078C14.6395 11.3588 15.3499 9.59867 15.3499 7.67494C15.3499 3.44035 11.9055 0 7.67494 0C3.44035 0 0 3.44435 0 7.67494C0 11.9055 3.44435 15.3499 7.67494 15.3499C9.59867 15.3499 11.3588 14.6395 12.7078 13.4661L17.082 17.8404C17.1858 17.9441 17.3255 18 17.4612 18C17.5969 18 17.7366 17.9481 17.8404 17.8404C18.0479 17.6328 18.0479 17.2896 17.8404 17.082ZM1.07361 7.67494C1.07361 4.03503 4.03503 1.07761 7.67095 1.07761C11.3109 1.07761 14.2683 4.03902 14.2683 7.67494C14.2683 11.3109 11.3109 14.2763 7.67095 14.2763C4.03503 14.2763 1.07361 11.3149 1.07361 7.67494Z"
        fill="#FFFFFF"
      />
    </svg>
  );
}

export function PlusIcon({ className }) {
  return (
    <svg
      width="26"
      height="27"
      viewBox="0 0 26 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.2903 12.8073L12.2903 7.56733C12.2903 7.08498 12.6727 6.69396 13.1445 6.694C13.6162 6.694 13.9987 7.08498 13.9987 7.56733L13.9987 12.8074L19.124 12.8074C19.5958 12.8074 19.9782 13.1983 19.9782 13.6807C19.9782 14.163 19.5957 14.554 19.124 14.554L13.9987 14.554L13.9987 19.794C13.9987 20.2764 13.6162 20.6674 13.1445 20.6674C12.6727 20.6674 12.2903 20.2764 12.2903 19.794L12.2903 14.554L7.16501 14.554C6.69326 14.554 6.3108 14.163 6.3108 13.6807C6.3108 13.1983 6.69322 12.8073 7.16501 12.8073L12.2903 12.8073Z"
        fill="#6D7F92"
      />
      <path
        d="M25.35 13.5C25.35 20.6202 19.7978 26.35 13 26.35C6.20219 26.35 0.65 20.6202 0.65 13.5C0.65 6.3798 6.20219 0.65 13 0.65C19.7978 0.65 25.35 6.3798 25.35 13.5Z"
        stroke="#6D7F92"
        strokeWidth="1.3"
      />
    </svg>
  );
}

export function ModeleSlideIcon({ className }) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.3995 22.5404H3.60001L3.60001 31.1993L32.3995 31.1993L32.3995 22.5404ZM3.60001 20.9404C2.71635 20.9404 2 21.6568 2 22.5404V31.1993C2 32.083 2.71635 32.7993 3.60001 32.7993H32.3995C33.2831 32.7993 33.9995 32.083 33.9995 31.1993V22.5404C33.9995 21.6568 33.2831 20.9404 32.3995 20.9404H3.60001Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1998 5.60001H3.60001L3.60001 9.1765H13.1998V5.60001ZM3.60001 4C2.71635 4 2 4.71635 2 5.60001V9.1765C2 10.0602 2.71635 10.7765 3.60001 10.7765H13.1998C14.0834 10.7765 14.7998 10.0602 14.7998 9.1765V5.60001C14.7998 4.71635 14.0834 4 13.1998 4H3.60001Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1998 14.0707H3.60001L3.60001 17.6472H13.1998V14.0707ZM3.60001 12.4707C2.71635 12.4707 2 13.1871 2 14.0707V17.6472C2 18.5309 2.71635 19.2472 3.60001 19.2472H13.1998C14.0834 19.2472 14.7998 18.5309 14.7998 17.6472V14.0707C14.7998 13.1871 14.0834 12.4707 13.1998 12.4707H3.60001Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4 5.60001L18.0003 5.60001L18.0003 17.6471L32.4 17.6471L32.4 5.60001ZM18.0003 4C17.1166 4 16.4003 4.71635 16.4003 5.60001V17.6471C16.4003 18.5308 17.1166 19.2471 18.0003 19.2471H32.4C33.2836 19.2471 34 18.5308 34 17.6471V5.60001C34 4.71635 33.2836 4 32.4 4H18.0003Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function CreateSlideIcon({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="0.5"
        y="13.0264"
        width="18.9996"
        height="6.36826"
        rx="0.5"
        stroke="#C7E8FE"
      />
      <rect
        x="0.5"
        y="2.5"
        width="6.99983"
        height="3.21043"
        rx="0.5"
        stroke="#C7E8FE"
      />
      <rect
        x="0.5"
        y="7.7627"
        width="6.99983"
        height="3.21043"
        rx="0.5"
        stroke="#C7E8FE"
      />
      <rect
        x="9.50024"
        y="2.5"
        width="9.99976"
        height="8.47348"
        rx="0.5"
        stroke="#C7E8FE"
      />
    </svg>
  );
}

export function CertifStar({ className }) {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15.3316 16.6373L13.4431 14.2095C14.055 14.0267 14.5836 13.6353 14.9371 13.1034C15.3818 12.3347 15.1807 11.3966 14.9861 10.4903C14.8685 10.0248 14.7981 9.5486 14.776 9.06896C14.798 8.5889 14.8684 8.11225 14.9861 7.64634C15.1795 6.73952 15.3818 5.80197 14.9371 5.03448C14.4766 4.23876 13.5493 3.94424 12.6524 3.65997C12.2059 3.53695 11.7735 3.36762 11.3623 3.15472C10.9891 2.91266 10.6426 2.63179 10.3285 2.31679C9.66311 1.69921 8.90867 1 7.94846 1C6.98825 1 6.2338 1.69921 5.56811 2.31648C5.25416 2.63156 4.90774 2.91254 4.53467 3.15472C4.12346 3.36719 3.69119 3.5361 3.24487 3.65872C2.34798 3.943 1.42067 4.23752 0.960114 5.03324C0.51539 5.80197 0.716493 6.74014 0.91108 7.64634C1.02874 8.11229 1.09903 8.5889 1.12087 9.06896C1.09892 9.54903 1.02855 10.0257 0.910769 10.4916C0.717425 11.3984 0.51508 12.336 0.959804 13.1034C1.31375 13.6355 1.84293 14.0268 2.45536 14.2092L0.565356 16.637C0.460149 16.7723 0.484549 16.9673 0.619899 17.0725C0.684916 17.1231 0.767312 17.1457 0.849011 17.1354L3.06798 16.8583L3.61573 18.775C3.64782 18.8873 3.7403 18.9721 3.85501 18.9944C3.87445 18.9981 3.89419 19 3.91398 19C4.0098 19.0001 4.1003 18.9559 4.15915 18.8802L6.14101 16.331C6.62872 16.8058 7.26935 17.0918 7.94846 17.1379C8.62757 17.0918 9.2682 16.8058 9.75591 16.331L11.7378 18.8793C11.7964 18.9553 11.8869 18.9998 11.9829 19C12.0027 19 12.0225 18.9981 12.0419 18.9944C12.1566 18.9721 12.2491 18.8873 12.2812 18.775L12.8289 16.8586L15.0479 17.1358C15.218 17.1571 15.3731 17.0365 15.3945 16.8665C15.4047 16.7848 15.3821 16.7024 15.3316 16.6373ZM4.04432 18.0165L3.59153 16.4319C3.54944 16.2849 3.40652 16.1905 3.2548 16.2094L1.51687 16.4266L3.07449 14.4243L3.24611 14.4792C3.692 14.6019 4.12385 14.7708 4.53467 14.9832C4.90786 15.2253 5.25435 15.5061 5.56842 15.8211L5.67518 15.9198L4.04432 18.0165ZM7.94846 16.5172C7.23156 16.5172 6.62856 15.9586 5.98987 15.3665C5.6424 15.0193 5.25858 14.7106 4.84501 14.4457C4.39505 14.2101 3.92139 14.0229 3.43201 13.8871C2.61177 13.6267 1.83684 13.3809 1.4967 12.7931C1.17208 12.2317 1.33967 11.4493 1.51749 10.6207C1.64547 10.1125 1.72058 9.59256 1.74156 9.06896C1.72069 8.54537 1.6457 8.02539 1.5178 7.51724C1.33998 6.68893 1.17239 5.90655 1.49701 5.34483C1.83839 4.75703 2.61208 4.51124 3.43232 4.25086C3.92162 4.11501 4.39513 3.92775 4.84501 3.69224C5.25847 3.42728 5.64221 3.11857 5.98956 2.77145C6.62856 2.17931 7.23156 1.62069 7.94846 1.62069C8.66536 1.62069 9.26835 2.17931 9.90704 2.77145C10.2545 3.11861 10.6383 3.42728 11.0519 3.69224C11.5019 3.92779 11.9755 4.11505 12.4649 4.25086C13.2851 4.51124 14.0601 4.75703 14.4002 5.34483C14.7248 5.90624 14.5573 6.68862 14.3794 7.51724C14.2514 8.02539 14.1763 8.54537 14.1554 9.06896C14.1762 9.59256 14.2512 10.1125 14.3791 10.6207C14.5569 11.449 14.7245 12.2314 14.3999 12.7931C14.0585 13.3809 13.2848 13.6267 12.4646 13.8871C11.9753 14.0229 11.5018 14.2102 11.0519 14.4457C10.6385 14.7106 10.2547 15.0194 9.90736 15.3665C9.26836 15.9586 8.66536 16.5172 7.94846 16.5172ZM12.6437 16.2094C12.4919 16.1905 12.349 16.2849 12.3069 16.4319L11.8526 18.0165L10.222 15.9201L10.3288 15.8214C10.6428 15.5064 10.9892 15.2254 11.3623 14.9832C11.7735 14.7707 12.2057 14.6018 12.652 14.4792L12.8237 14.4243L14.3816 16.4266L12.6437 16.2094Z"
        fill="#29394D"
        strokeWidth="0"
      />
      <path
        d="M12.09 7.76759C11.9603 7.58936 11.7532 7.48389 11.5328 7.4838H9.42172L8.76655 5.47449C8.64763 5.11264 8.25789 4.91574 7.89603 5.03467C7.68789 5.10307 7.52461 5.26635 7.45621 5.47449L6.80276 7.4838H4.69C4.30909 7.48363 4.00017 7.7922 4 8.17311C3.99987 8.3938 4.10539 8.60117 4.28379 8.73104L5.99276 9.97242L5.34 11.9817C5.22224 12.344 5.42047 12.7331 5.78267 12.8508C5.99272 12.919 6.22272 12.8826 6.40138 12.7528L8.11138 11.5117L9.82069 12.7531C10.0615 12.932 10.3909 12.932 10.6317 12.7531C10.8761 12.5794 10.9778 12.2662 10.8821 11.9821L10.2293 9.97242L11.9383 8.73104C12.2463 8.5069 12.3142 8.07552 12.09 7.76759ZM9.62103 9.56207C9.50009 9.64996 9.44953 9.80578 9.49586 9.94793L10.2262 12.1955L8.31414 10.8066C8.19332 10.7188 8.02978 10.7188 7.90897 10.8066L5.9969 12.1955L6.7269 9.94793C6.77306 9.80586 6.72254 9.65026 6.60172 9.56242L4.69 8.17345H7.0531C7.2025 8.17345 7.33487 8.07725 7.38103 7.93518L8.11138 5.6876L8.84172 7.93483C8.88789 8.0769 9.02026 8.17311 9.16966 8.17311L11.5328 8.17345L9.62103 9.56207Z"
        fill="#29394D"
        strokeWidth="0"
      />
      <path
        d="M15.3316 16.6373L13.4431 14.2095C14.055 14.0267 14.5836 13.6353 14.9371 13.1034C15.3818 12.3347 15.1807 11.3966 14.9861 10.4903C14.8685 10.0248 14.7981 9.5486 14.776 9.06896C14.798 8.5889 14.8684 8.11225 14.9861 7.64634C15.1795 6.73952 15.3818 5.80197 14.9371 5.03448C14.4766 4.23876 13.5493 3.94424 12.6524 3.65997C12.2059 3.53695 11.7735 3.36762 11.3623 3.15472C10.9891 2.91266 10.6426 2.63179 10.3285 2.31679C9.66311 1.69921 8.90867 1 7.94846 1C6.98825 1 6.2338 1.69921 5.56811 2.31648C5.25416 2.63156 4.90774 2.91254 4.53467 3.15472C4.12346 3.36719 3.69119 3.5361 3.24487 3.65872C2.34798 3.943 1.42067 4.23752 0.960114 5.03324C0.51539 5.80197 0.716493 6.74014 0.91108 7.64634C1.02874 8.11229 1.09903 8.5889 1.12087 9.06896C1.09892 9.54903 1.02855 10.0257 0.910769 10.4916C0.717425 11.3984 0.51508 12.336 0.959804 13.1034C1.31375 13.6355 1.84293 14.0268 2.45536 14.2092L0.565356 16.637C0.460149 16.7723 0.484549 16.9673 0.619899 17.0725C0.684916 17.1231 0.767312 17.1457 0.849011 17.1354L3.06798 16.8583L3.61573 18.775C3.64782 18.8873 3.7403 18.9721 3.85501 18.9944C3.87445 18.9981 3.89419 19 3.91398 19C4.0098 19.0001 4.1003 18.9559 4.15915 18.8802L6.14101 16.331C6.62872 16.8058 7.26935 17.0918 7.94846 17.1379C8.62757 17.0918 9.2682 16.8058 9.75591 16.331L11.7378 18.8793C11.7964 18.9553 11.8869 18.9998 11.9829 19C12.0027 19 12.0225 18.9981 12.0419 18.9944C12.1566 18.9721 12.2491 18.8873 12.2812 18.775L12.8289 16.8586L15.0479 17.1358C15.218 17.1571 15.3731 17.0365 15.3945 16.8665C15.4047 16.7848 15.3821 16.7024 15.3316 16.6373ZM4.04432 18.0165L3.59153 16.4319C3.54944 16.2849 3.40652 16.1905 3.2548 16.2094L1.51687 16.4266L3.07449 14.4243L3.24611 14.4792C3.692 14.6019 4.12385 14.7708 4.53467 14.9832C4.90786 15.2253 5.25435 15.5061 5.56842 15.8211L5.67518 15.9198L4.04432 18.0165ZM7.94846 16.5172C7.23156 16.5172 6.62856 15.9586 5.98987 15.3665C5.6424 15.0193 5.25858 14.7106 4.84501 14.4457C4.39505 14.2101 3.92139 14.0229 3.43201 13.8871C2.61177 13.6267 1.83684 13.3809 1.4967 12.7931C1.17208 12.2317 1.33967 11.4493 1.51749 10.6207C1.64547 10.1125 1.72058 9.59256 1.74156 9.06896C1.72069 8.54537 1.6457 8.02539 1.5178 7.51724C1.33998 6.68893 1.17239 5.90655 1.49701 5.34483C1.83839 4.75703 2.61208 4.51124 3.43232 4.25086C3.92162 4.11501 4.39513 3.92775 4.84501 3.69224C5.25847 3.42728 5.64221 3.11857 5.98956 2.77145C6.62856 2.17931 7.23156 1.62069 7.94846 1.62069C8.66536 1.62069 9.26835 2.17931 9.90704 2.77145C10.2545 3.11861 10.6383 3.42728 11.0519 3.69224C11.5019 3.92779 11.9755 4.11505 12.4649 4.25086C13.2851 4.51124 14.0601 4.75703 14.4002 5.34483C14.7248 5.90624 14.5573 6.68862 14.3794 7.51724C14.2514 8.02539 14.1763 8.54537 14.1554 9.06896C14.1762 9.59256 14.2512 10.1125 14.3791 10.6207C14.5569 11.449 14.7245 12.2314 14.3999 12.7931C14.0585 13.3809 13.2848 13.6267 12.4646 13.8871C11.9753 14.0229 11.5018 14.2102 11.0519 14.4457C10.6385 14.7106 10.2547 15.0194 9.90736 15.3665C9.26836 15.9586 8.66536 16.5172 7.94846 16.5172ZM12.6437 16.2094C12.4919 16.1905 12.349 16.2849 12.3069 16.4319L11.8526 18.0165L10.222 15.9201L10.3288 15.8214C10.6428 15.5064 10.9892 15.2254 11.3623 14.9832C11.7735 14.7707 12.2057 14.6018 12.652 14.4792L12.8237 14.4243L14.3816 16.4266L12.6437 16.2094Z"
        stroke="#29394D"
        strokeWidth="0.2"
      />
      <path
        d="M12.09 7.76759C11.9603 7.58936 11.7532 7.48389 11.5328 7.4838H9.42172L8.76655 5.47449C8.64763 5.11264 8.25789 4.91574 7.89603 5.03467C7.68789 5.10307 7.52461 5.26635 7.45621 5.47449L6.80276 7.4838H4.69C4.30909 7.48363 4.00017 7.7922 4 8.17311C3.99987 8.3938 4.10539 8.60117 4.28379 8.73104L5.99276 9.97242L5.34 11.9817C5.22224 12.344 5.42047 12.7331 5.78267 12.8508C5.99272 12.919 6.22272 12.8826 6.40138 12.7528L8.11138 11.5117L9.82069 12.7531C10.0615 12.932 10.3909 12.932 10.6317 12.7531C10.8761 12.5794 10.9778 12.2662 10.8821 11.9821L10.2293 9.97242L11.9383 8.73104C12.2463 8.5069 12.3142 8.07552 12.09 7.76759ZM9.62103 9.56207C9.50009 9.64996 9.44953 9.80578 9.49586 9.94793L10.2262 12.1955L8.31414 10.8066C8.19332 10.7188 8.02978 10.7188 7.90897 10.8066L5.9969 12.1955L6.7269 9.94793C6.77306 9.80586 6.72254 9.65026 6.60172 9.56242L4.69 8.17345H7.0531C7.2025 8.17345 7.33487 8.07725 7.38103 7.93518L8.11138 5.6876L8.84172 7.93483C8.88789 8.0769 9.02026 8.17311 9.16966 8.17311L11.5328 8.17345L9.62103 9.56207Z"
        stroke="#29394D"
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function HideEye({ className }) {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 490.034 490.034"
      className={className}
    >
      <g>
        <g>
          <path
            d="M435.667,54.311c-7-7.1-18.4-7-25.5,0l-64,64c-79.3-36-163.9-27.2-244.6,25.5c-60.1,39.2-96.6,88.5-98.1,90.6
			c-4.8,6.6-4.6,15.6,0.5,22c34.2,42,70,74.7,106.6,97.5l-56.3,56.3c-7,7-7,18.4,0,25.5c3.5,3.5,8.1,5.3,12.7,5.3s9.2-1.8,12.7-5.3
			l356-355.9C442.667,72.811,442.667,61.411,435.667,54.311z M200.467,264.011c-2.6-5.9-3.9-12.3-3.9-19c0-12.9,5-25.1,14.2-34.3
			c14.4-14.4,35.7-17.8,53.3-10.3L200.467,264.011z M290.667,173.911c-32.7-21-76.8-17.2-105.3,11.3c-16,16-24.7,37.2-24.7,59.7
			c0,16.4,4.7,32.1,13.4,45.6l-37.1,37.1c-32.5-18.8-64.5-46.6-95.6-82.9c13.3-15.6,41.4-45.7,79.9-70.8
			c66.6-43.4,132.9-52.8,197.5-28.1L290.667,173.911z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M486.067,233.611c-24.7-30.4-50.3-56-76.3-76.3c-7.9-6.1-19.2-4.7-25.4,3.1c-6.1,7.8-4.7,19.1,3.1,25.3
			c20.6,16.1,41.2,36.1,61.2,59.5c-11.8,13.8-34.8,38.6-66,61.3c-60.1,43.7-120.8,59.5-180.3,46.9c-9.7-2.1-19.3,4.2-21.3,13.9
			c-2.1,9.7,4.2,19.3,13.9,21.3c15.5,3.3,31.1,4.9,46.8,4.9c23.6,0,47.4-3.7,71.1-11.1c31.1-9.7,62-25.7,91.9-47.5
			c50.4-36.9,80.5-77.6,81.8-79.3C491.367,249.011,491.167,240.011,486.067,233.611z"
          />
        </g>
      </g>
    </svg>
  );
}

export function StarIcon({ className, color }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.79945 4.67051L8.91293 4.91181L9.17653 4.95201L13.2494 5.57319L10.2864 8.60434L10.1098 8.78507L10.1505 9.03449L10.8447 13.2825L7.2416 11.2946L7.00008 11.1613L6.75855 11.2946L3.1552 13.2824L3.84962 9.03425L3.89039 8.7848L3.7137 8.60406L0.750984 5.57339L4.82336 4.95227L5.08695 4.91207L5.20043 4.67078L7.00006 0.8442L8.79945 4.67051ZM11.2961 13.5315C11.2964 13.5317 11.2966 13.5318 11.2968 13.5319L11.2962 13.5316L11.2961 13.5315ZM9.25191 4.45773L7.2246 0.14675L9.25191 4.45773Z"
        stroke={color ? color : "#6D7F92"}
      />
    </svg>
  );
}
export function DuplicateIcon({ className }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.07891 1.92383H1.96525C1.48542 1.92383 1.0957 2.31355 1.0957 2.79338V10.1305C1.0957 10.6103 1.48542 11 1.96525 11H7.07891C7.55874 11 7.94846 10.6103 7.94846 10.1305V2.79338C7.94621 2.31355 7.55649 1.92383 7.07891 1.92383ZM7.33797 10.1282C7.33797 10.2724 7.22083 10.3895 7.07666 10.3895H1.963C1.81882 10.3895 1.70168 10.2724 1.70168 10.1282V2.79338C1.70168 2.6492 1.81882 2.53206 1.963 2.53206H7.07666C7.22083 2.53206 7.33797 2.6492 7.33797 2.79338V10.1282Z"
        fill="#18A0FB"
      />
      <path
        d="M9.03399 0H3.92033C3.4405 0 3.05078 0.389719 3.05078 0.869547C3.05078 1.0385 3.18594 1.17366 3.3549 1.17366C3.52385 1.17366 3.65901 1.0385 3.65901 0.869547C3.65901 0.725374 3.77616 0.608233 3.92033 0.608233H9.03399C9.17816 0.608233 9.2953 0.725374 9.2953 0.869547V8.20663C9.2953 8.35081 9.17816 8.46795 9.03399 8.46795C8.86503 8.46795 8.72987 8.60311 8.72987 8.77207C8.72987 8.94102 8.86503 9.07618 9.03399 9.07618C9.51382 9.07618 9.90354 8.68646 9.90354 8.20663V0.869547C9.90354 0.389719 9.51382 0 9.03399 0Z"
        fill="#18A0FB"
      />
    </svg>
  );
}
export function DashboardList({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.2539 1.85547H1.67578C1 1.85547 0.449219 2.40625 0.449219 3.08203V12.8477C0.449219 13.5234 1 14.0742 1.67578 14.0742H14.2578C14.9336 14.0742 15.4844 13.5234 15.4844 12.8477V3.08203C15.4805 2.40625 14.9336 1.85547 14.2539 1.85547ZM1.67578 2.8125H14.2578C14.4062 2.8125 14.5273 2.93359 14.5273 3.08203V4.67188H1.40625V3.08203C1.40625 2.93359 1.52734 2.8125 1.67578 2.8125ZM14.2539 13.1172H1.67578C1.52734 13.1172 1.40625 12.9961 1.40625 12.8477V5.62891H14.5273V12.8477C14.5234 12.9961 14.4023 13.1172 14.2539 13.1172Z"
        fill="#29394D"
      />
      <path
        d="M17.5508 14.9141V5.14844C17.5508 4.88281 17.3359 4.66797 17.0703 4.66797C16.8047 4.66797 16.5898 4.88281 16.5898 5.14844V14.9141C16.5898 15.0625 16.4687 15.1836 16.3203 15.1836H3.74219C3.47656 15.1836 3.26172 15.3984 3.26172 15.6641C3.26172 15.9297 3.47656 16.1445 3.74219 16.1445H16.3242C17 16.1406 17.5508 15.5898 17.5508 14.9141Z"
        fill="#29394D"
      />
      <path
        d="M19.5507 16.9183V7.15268C19.5507 6.88705 19.3359 6.67221 19.0702 6.67221C18.8046 6.67221 18.5898 6.88705 18.5898 7.15268V16.9183C18.5898 17.0667 18.4687 17.1878 18.3202 17.1878H5.74602C5.48039 17.1878 5.26555 17.4027 5.26555 17.6683C5.26555 17.9339 5.48039 18.1488 5.74602 18.1488H18.328C18.9999 18.1449 19.5507 17.5941 19.5507 16.9183Z"
        fill="#29394D"
      />
      <path
        d="M5.52342 4.22287C5.64842 4.22287 5.77342 4.17209 5.85936 4.08225C5.9492 3.9924 5.99998 3.87131 5.99998 3.74631C5.99998 3.62131 5.9492 3.49631 5.85936 3.40646C5.67967 3.22678 5.36327 3.22678 5.18358 3.40646C5.09373 3.49631 5.04295 3.6174 5.04295 3.74631C5.04295 3.87131 5.09373 3.99631 5.18358 4.08225C5.27342 4.17209 5.39842 4.22287 5.52342 4.22287Z"
        fill="#29394D"
      />
      <path
        d="M4.11726 4.22287C4.24226 4.22287 4.36726 4.17209 4.45711 4.08225C4.54695 3.9924 4.59773 3.87131 4.59773 3.74631C4.59773 3.62131 4.54695 3.49631 4.45711 3.40646C4.27742 3.22678 3.95711 3.22678 3.78133 3.40646C3.69148 3.49631 3.6407 3.6174 3.6407 3.74631C3.6407 3.87131 3.69148 3.99631 3.78133 4.08225C3.86726 4.17209 3.98836 4.22287 4.11726 4.22287Z"
        fill="#29394D"
      />
      <path
        d="M2.71091 4.22287C2.83591 4.22287 2.96091 4.17209 3.04684 4.08225C3.13669 3.9924 3.18747 3.87131 3.18747 3.74631C3.18747 3.62131 3.13669 3.49631 3.04684 3.40646C2.87106 3.22678 2.55075 3.22678 2.37106 3.40646C2.28122 3.49631 2.23044 3.6174 2.23044 3.74631C2.23044 3.87131 2.28122 3.99631 2.37106 4.08225C2.46091 4.17209 2.582 4.22287 2.71091 4.22287Z"
        fill="#29394D"
      />
    </svg>
  );
}
export function Pause({ className }) {
  return (
    <svg
      id="Capa_1"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path d="m437.02 74.98c-48.353-48.351-112.64-74.98-181.02-74.98s-132.667 26.629-181.02 74.98c-48.351 48.353-74.98 112.64-74.98 181.02s26.629 132.667 74.98 181.02c48.353 48.351 112.64 74.98 181.02 74.98s132.667-26.629 181.02-74.98c48.351-48.353 74.98-112.64 74.98-181.02s-26.629-132.667-74.98-181.02zm-181.02 407.02c-124.617 0-226-101.383-226-226s101.383-226 226-226 226 101.383 226 226-101.383 226-226 226z" />
        <path d="m346 141h-60c-8.284 0-15 6.716-15 15v200c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-200c0-8.284-6.716-15-15-15zm-15 200h-30v-170h30z" />
        <path d="m226 141h-60c-8.284 0-15 6.716-15 15v200c0 8.284 6.716 15 15 15h60c8.284 0 15-6.716 15-15v-200c0-8.284-6.716-15-15-15zm-15 200h-30v-170h30z" />
      </g>
    </svg>
  );
}

export function Collaborator({ className }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433286 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34783 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0V0ZM10 19.1667C8.18701 19.1667 6.41473 18.629 4.90728 17.6218C3.39983 16.6146 2.22491 15.1829 1.53111 13.5079C0.837305 11.8329 0.655775 9.98983 1.00947 8.21167C1.36317 6.43351 2.23621 4.80017 3.51819 3.51819C4.80017 2.23621 6.43352 1.36317 8.21168 1.00947C9.98983 0.65577 11.8329 0.837301 13.5079 1.5311C15.1829 2.22491 16.6146 3.39982 17.6218 4.90727C18.6291 6.41472 19.1667 8.187 19.1667 10C19.1667 12.4311 18.2009 14.7627 16.4818 16.4818C14.7627 18.2009 12.4312 19.1667 10 19.1667Z"
        fill="#C7E8FE"
      />
      <path
        d="M10 10C8.4087 10 6.88258 10.587 5.75736 11.6318C4.63214 12.6767 4 14.0938 4 15.5714C4 15.6851 4.04863 15.7941 4.13518 15.8745C4.22174 15.9548 4.33913 16 4.46154 16C4.58395 16 4.70134 15.9548 4.7879 15.8745C4.87445 15.7941 4.92308 15.6851 4.92308 15.5714C4.92308 14.3211 5.45797 13.122 6.41007 12.2379C7.36218 11.3538 8.65352 10.8571 10 10.8571C11.3465 10.8571 12.6378 11.3538 13.5899 12.2379C14.542 13.122 15.0769 14.3211 15.0769 15.5714C15.0769 15.6851 15.1255 15.7941 15.2121 15.8745C15.2987 15.9548 15.4161 16 15.5385 16C15.6609 16 15.7783 15.9548 15.8648 15.8745C15.9514 15.7941 16 15.6851 16 15.5714C16 14.8398 15.8448 14.1153 15.5433 13.4393C15.2417 12.7634 14.7998 12.1492 14.2426 11.6318C13.6855 11.1145 13.0241 10.7041 12.2961 10.4241C11.5681 10.1441 10.7879 10 10 10V10Z"
        fill="#C7E8FE"
      />
      <path
        d="M10 9C10.4052 8.98976 10.8043 8.90404 11.1744 8.74775C11.5445 8.59147 11.8784 8.36768 12.1569 8.08921C12.4354 7.81075 12.6531 7.48306 12.7976 7.12492C12.942 6.76678 13.0103 6.38522 12.9986 6.00208C13.0109 5.6186 12.943 5.23659 12.7989 4.87797C12.6547 4.51935 12.4371 4.19117 12.1585 3.91226C11.8799 3.63334 11.5458 3.40918 11.1754 3.25264C10.805 3.09609 10.4056 3.01024 10 3C9.59443 3.01024 9.19498 3.09609 8.82457 3.25264C8.45416 3.40918 8.12009 3.63334 7.8415 3.91226C7.56291 4.19117 7.34529 4.51935 7.20113 4.87797C7.05697 5.23659 6.9891 5.6186 7.00142 6.00208C6.98969 6.38522 7.058 6.76678 7.20243 7.12492C7.34685 7.48306 7.56456 7.81075 7.84309 8.08921C8.12162 8.36768 8.4555 8.59147 8.82562 8.74775C9.19573 8.90404 9.59481 8.98976 10 9V9ZM10 3.83276C10.29 3.84293 10.5749 3.90721 10.8385 4.02189C11.1021 4.13657 11.3391 4.29939 11.536 4.50099C11.7328 4.70259 11.8855 4.93899 11.9854 5.1966C12.0853 5.45421 12.1303 5.72795 12.1179 6.00208C12.1297 6.27587 12.0842 6.54917 11.9841 6.8063C11.884 7.06343 11.7311 7.29933 11.5344 7.50049C11.3376 7.70164 11.1008 7.86408 10.8375 7.9785C10.5742 8.09292 10.2896 8.15706 10 8.16724C9.71043 8.15706 9.42583 8.09292 9.16253 7.9785C8.89923 7.86408 8.66241 7.70164 8.46564 7.50049C8.26888 7.29933 8.11604 7.06343 8.01589 6.8063C7.91575 6.54917 7.87027 6.27587 7.88206 6.00208C7.86967 5.72795 7.91471 5.45421 8.01459 5.1966C8.11446 4.93899 8.26721 4.70259 8.46403 4.50099C8.66085 4.29939 8.89788 4.13657 9.16148 4.02189C9.42507 3.90721 9.71004 3.84293 10 3.83276V3.83276Z"
        fill="#C7E8FE"
      />
    </svg>
  );
}
export function BriefCase({ className }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.33325 4.66667C2.01109 4.66667 1.74992 4.92783 1.74992 5.25V11.0833C1.74992 11.4055 2.01109 11.6667 2.33325 11.6667H11.6666C11.9888 11.6667 12.2499 11.4055 12.2499 11.0833V5.25C12.2499 4.92783 11.9888 4.66667 11.6666 4.66667H2.33325ZM0.583252 5.25C0.583252 4.2835 1.36675 3.5 2.33325 3.5H11.6666C12.6331 3.5 13.4166 4.2835 13.4166 5.25V11.0833C13.4166 12.0498 12.6331 12.8333 11.6666 12.8333H2.33325C1.36675 12.8333 0.583252 12.0498 0.583252 11.0833V5.25Z"
        fill="#29394D"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.59582 1.67956C4.924 1.35137 5.36912 1.16699 5.83325 1.16699H8.16658C8.63071 1.16699 9.07583 1.35137 9.40402 1.67956C9.73221 2.00774 9.91658 2.45286 9.91658 2.91699V12.2503C9.91658 12.5725 9.65542 12.8337 9.33325 12.8337C9.01109 12.8337 8.74992 12.5725 8.74992 12.2503V2.91699C8.74992 2.76228 8.68846 2.61391 8.57906 2.50451C8.46967 2.39512 8.32129 2.33366 8.16658 2.33366H5.83325C5.67854 2.33366 5.53017 2.39512 5.42077 2.50451C5.31138 2.61391 5.24992 2.76228 5.24992 2.91699V12.2503C5.24992 12.5725 4.98875 12.8337 4.66659 12.8337C4.34442 12.8337 4.08325 12.5725 4.08325 12.2503V2.91699C4.08325 2.45286 4.26763 2.00774 4.59582 1.67956Z"
        fill="#29394D"
      />
    </svg>
  );
}
export function Euro({ className }) {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.39453 9.0332C5.64062 9.0332 5.87988 9.01497 6.1123 8.97852C6.34473 8.94206 6.56576 8.88737 6.77539 8.81445L6.97363 10.1816C6.70931 10.2454 6.43359 10.2956 6.14648 10.332C5.85938 10.3685 5.56771 10.3867 5.27148 10.3867C4.71094 10.3867 4.19596 10.3047 3.72656 10.1406C3.26172 9.97656 2.8584 9.73275 2.5166 9.40918C2.1748 9.08105 1.9082 8.67546 1.7168 8.19238C1.52995 7.70475 1.43652 7.13737 1.43652 6.49023V4.17285C1.43652 3.50749 1.52995 2.92643 1.7168 2.42969C1.9082 1.92839 2.17708 1.50911 2.52344 1.17188C2.87435 0.834635 3.28678 0.581706 3.76074 0.413086C4.23926 0.244466 4.7679 0.160156 5.34668 0.160156C5.62923 0.160156 5.90267 0.180664 6.16699 0.22168C6.43587 0.258138 6.70475 0.308268 6.97363 0.37207L6.77539 1.74609C6.57487 1.67773 6.35612 1.62305 6.11914 1.58203C5.88672 1.54102 5.65202 1.52051 5.41504 1.52051C5.06413 1.52051 4.7474 1.57292 4.46484 1.67773C4.18685 1.78255 3.94987 1.94206 3.75391 2.15625C3.55794 2.36589 3.40755 2.63704 3.30273 2.96973C3.20247 3.30241 3.15234 3.69889 3.15234 4.15918V6.49023C3.15234 6.94596 3.20475 7.33561 3.30957 7.65918C3.41895 7.97819 3.57161 8.24023 3.76758 8.44531C3.96354 8.64583 4.19824 8.79395 4.47168 8.88965C4.74967 8.98535 5.05729 9.0332 5.39453 9.0332ZM5.59961 3.8584V4.79492H0.253906V3.8584H5.59961ZM5.59961 5.69043V6.62695H0.253906V5.69043H5.59961Z"
        fill="#29394D"
      />
    </svg>
  );
}

export function FolderFilter({ className, color }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="5" fill="#F8F9FA" />
      <path
        d="M8.81071 13.805L8.75071 12.5C8.75071 11.7044 9.06678 10.9413 9.62939 10.3787C10.192 9.81607 10.9551 9.5 11.7507 9.5H17.2587C18.0543 9.50017 18.8172 9.81635 19.3797 10.379L20.6217 11.621C21.1842 12.1836 21.9471 12.4998 22.7427 12.5H28.7157C29.1326 12.5 29.5449 12.5868 29.9264 12.755C30.3078 12.9232 30.65 13.169 30.9312 13.4768C31.2123 13.7846 31.4262 14.1477 31.5592 14.5428C31.6922 14.9379 31.7414 15.3563 31.7037 15.7715L30.7482 26.2715C30.6805 27.0169 30.3366 27.71 29.784 28.2148C29.2315 28.7197 28.5102 28.9997 27.7617 29H12.2397C11.4913 28.9997 10.77 28.7197 10.2174 28.2148C9.66485 27.71 9.32095 27.0169 9.25321 26.2715L8.29771 15.7715C8.23379 15.0767 8.4153 14.3814 8.81071 13.8065V13.805ZM11.2857 14C11.0773 14 10.8713 14.0434 10.6806 14.1274C10.4899 14.2115 10.3189 14.3343 10.1783 14.4882C10.0377 14.642 9.93077 14.8234 9.86421 15.0209C9.79765 15.2183 9.77296 15.4275 9.79171 15.635L10.7472 26.135C10.7809 26.5077 10.9527 26.8543 11.2288 27.1069C11.5049 27.3594 11.8655 27.4996 12.2397 27.5H27.7617C28.1359 27.4996 28.4965 27.3594 28.7726 27.1069C29.0488 26.8543 29.2205 26.5077 29.2542 26.135L30.2097 15.635C30.2285 15.4275 30.2038 15.2183 30.1372 15.0209C30.0707 14.8234 29.9637 14.642 29.8231 14.4882C29.6826 14.3343 29.5115 14.2115 29.3208 14.1274C29.1302 14.0434 28.9241 14 28.7157 14H11.2857ZM18.3207 11.4395C18.1813 11.3 18.0157 11.1894 17.8335 11.114C17.6512 11.0386 17.4559 10.9998 17.2587 11H11.7507C11.3578 10.9999 10.9805 11.154 10.7 11.4292C10.4195 11.7044 10.2582 12.0786 10.2507 12.4715L10.2597 12.68C10.5807 12.563 10.9257 12.5 11.2857 12.5H19.3797L18.3192 11.4395H18.3207Z"
        fill={color ? color : "#06D9B1"}
      />
    </svg>
  );
}

export function CrossIcon({ className, width, color }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 14 14"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.33562 6.99954L0.344101 2.00802C-0.115375 1.54855 -0.115375 0.803594 0.344101 0.344184C0.803576 -0.115291 1.54847 -0.115291 2.00794 0.344184L6.99953 5.33577L11.9911 0.344118C12.4506 -0.115357 13.1955 -0.115357 13.655 0.344118C14.1144 0.803594 14.1144 1.54855 13.655 2.00796L8.66337 6.99948L13.655 11.9911C14.1144 12.4505 14.1144 13.1955 13.655 13.6549C13.1955 14.1144 12.4506 14.1144 11.9911 13.6549L6.99953 8.66332L2.00794 13.6549C1.54853 14.1144 0.803576 14.1144 0.344101 13.6549C-0.115375 13.1954 -0.115375 12.4505 0.344101 11.9911L5.33562 6.99954Z"
        fill={color ? color : "#3C4E64"}
      />
    </svg>
  );
}

export function GoogleIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      version="1.1"
      viewBox="0 0 128 128"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-rule="evenodd" fill-rule="evenodd">
        <rect width="128" height="128" fill="none" />
        <path
          d="M27.585,64c0-4.157,0.69-8.143,1.923-11.881L7.938,35.648    C3.734,44.183,1.366,53.801,1.366,64c0,10.191,2.366,19.802,6.563,28.332l21.558-16.503C28.266,72.108,27.585,68.137,27.585,64"
          fill="#FBBC05"
        />
        <path
          d="m65.457 26.182c9.031 0 17.188 3.2 23.597 8.436l18.644-18.618c-11.361-9.891-25.927-16-42.241-16-25.328 0-47.096 14.484-57.519 35.648l21.569 16.471c4.97-15.086 19.137-25.937 35.95-25.937"
          fill="#EA4335"
        />
        <path
          d="m65.457 101.82c-16.812 0-30.979-10.851-35.949-25.937l-21.57 16.468c10.423 21.167 32.191 35.651 57.519 35.651 15.632 0 30.557-5.551 41.758-15.951l-20.474-15.828c-5.777 3.639-13.052 5.597-21.284 5.597"
          fill="#34A853"
        />
        <path
          d="m126.63 64c0-3.782-0.583-7.855-1.457-11.636h-59.72v24.727h34.376c-1.719 8.431-6.397 14.912-13.092 19.13l20.474 15.828c11.766-10.92 19.419-27.188 19.419-48.049"
          fill="#4285F4"
        />
      </g>
    </svg>
  );
}

export function Office365Icon({ className, width }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 8L22 0L34 3V37L22 40L0 32L22 35V6L8 9V29L0 32V8Z"
        fill="#E64A19"
      />
    </svg>
  );
}

export function AgendaIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M21.0833 7.37012H0.916667C0.410667 7.37012 0 7.78078 0 8.28678V19.2501C0 20.7663 1.23383 22.0001 2.75 22.0001H19.25C20.7662 22.0001 22 20.7663 22 19.2501V8.28678C22 7.78078 21.5893 7.37012 21.0833 7.37012Z"
        fill="#ECEFF1"
      />
      <path
        d="M19.25 2.75H2.75C1.23108 2.75 0 3.98108 0 5.5V8.28667H22V5.5C22 3.98108 20.7689 2.75 19.25 2.75Z"
        fill="#2196F3"
      />
      <path
        d="M11 8.28662H0V19.25C0 20.7661 1.23383 22 2.75 22H11V8.28662Z"
        fill="#CDD0D2"
      />
      <path
        d="M11 2.75H2.75C1.23108 2.75 0 3.98108 0 5.5V8.28667H11V2.75Z"
        fill="#1D83D4"
      />
      <path
        d="M17.4163 0H16.4997C15.9937 0 15.583 0.410667 15.583 0.916667V4.58333C15.583 5.08933 15.9937 5.5 16.4997 5.5H17.4163C17.9223 5.5 18.333 5.08933 18.333 4.58333V0.916667C18.333 0.410667 17.9223 0 17.4163 0Z"
        fill="#1976D2"
      />
      <path
        d="M16.958 0H16.4997C15.9937 0 15.583 0.410667 15.583 0.916667V4.58333C15.583 5.08933 15.9937 5.5 16.4997 5.5H16.958V0Z"
        fill="#1667B7"
      />
      <path
        d="M5.50033 0H4.58366C4.07766 0 3.66699 0.410667 3.66699 0.916667V4.58333C3.66699 5.08933 4.07766 5.5 4.58366 5.5H5.50033C6.00633 5.5 6.41699 5.08933 6.41699 4.58333V0.916667C6.41699 0.410667 6.00633 0 5.50033 0Z"
        fill="#1976D2"
      />
      <path
        d="M5.04199 0H4.58366C4.07766 0 3.66699 0.410667 3.66699 0.916667V4.58333C3.66699 5.08933 4.07766 5.5 4.58366 5.5H5.04199V0Z"
        fill="#1667B7"
      />
    </svg>
  );
}

export function OutlookIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "14"}
      height={width ? width : "14"}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <title>background</title>
        <rect x="-1" y="-1" width="582" height="402" fill="none" />
      </g>
      <g>
        <title>Layer 1</title>
        <path
          d="m644.88 764.42v-271.72c19.329 13.255 37.371 25.627 55.413 37.996 16.194 11.101 18.919 11.045 35.633-0.064 92.48-61.468 184.98-122.92 277.48-184.36 2.803-1.861 5.698-3.585 9.774-6.141 0.322 4.208 0.777 7.36 0.777 10.514 0.035 118.22 0.089 236.44-7e-3 354.66-0.034 39.297-19.884 59.078-58.972 59.097-102.8 0.047-205.6 0.018-308.41 0.018-3.703-1e-3 -7.405-1e-3 -11.691-1e-3z"
          clip-rule="evenodd"
          fill="#0072c6"
          fill-rule="evenodd"
        />
        <path
          d="m645.62 216.85h10.489c108.56 0 217.12-9e-3 325.68 0.01 19.41 4e-3 34.427 11.871 40.529 30.528 2.68 8.197-0.047 12.205-6.669 16.641-84.095 56.307-168.01 112.88-251.98 169.38-11.994 8.072-24.149 15.92-35.93 24.292-6.448 4.579-12.154 4.828-18.844 0.521-19.187-12.357-38.738-24.161-57.786-36.721-3.179-2.095-6.486-6.876-6.505-10.434-0.337-63.505-0.176-127.01-0.094-190.52 5e-3 -0.712 0.412-1.423 1.109-3.701z"
          clip-rule="evenodd"
          fill="#0072c6"
          fill-rule="evenodd"
        />
        <path
          d="m596.72 1024c-199.08-41.667-397.39-83.177-596.44-124.84v-13.094c-1e-3 -252.51 0.076-505.03-0.273-757.54-0.016-10.461 2.793-14.09 13.038-16.049 159.15-30.403 318.22-61.241 477.31-91.971 35.081-6.777 70.167-13.528 106.37-20.507v1024zm-158.68-512.98c-0.402-41.613-6.094-80.035-26.656-114.85-16.6-28.107-39.024-49.44-71.278-58.626-62.755-17.872-122.84 11.521-152.41 75.036-18.947 40.696-22.994 83.874-19.337 128.08 3.169 38.303 14.261 73.688 38.958 103.96 49.093 60.169 138.44 60.569 188.18 0.776 32.939-39.589 41.886-86.711 42.538-134.37z"
          clip-rule="evenodd"
          fill="#0072c6"
          fill-rule="evenodd"
        />
        <path
          d="m232.92 511.94c-0.085-29.653 3.91-58.359 20.699-83.795 15.494-23.472 39.016-33.061 64.938-26.578 20.146 5.038 32.316 19.265 40.427 37.222 13.847 30.658 16.247 63.273 12.056 95.936-2.325 18.11-7.45 36.464-14.808 53.175-9.507 21.596-27.783 33.954-52.195 34.493-24.572 0.542-41.658-12.202-53.632-32.584-14.129-24.051-17.552-50.585-17.485-77.869z"
          clip-rule="evenodd"
          fill="#0072c6"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
}

export function LockIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "12"}
      height={width ? width : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.5 6C2.22386 6 2 6.22386 2 6.5V10C2 10.2761 2.22386 10.5 2.5 10.5H9.5C9.77614 10.5 10 10.2761 10 10V6.5C10 6.22386 9.77614 6 9.5 6H2.5ZM1 6.5C1 5.67157 1.67157 5 2.5 5H9.5C10.3284 5 11 5.67157 11 6.5V10C11 10.8284 10.3284 11.5 9.5 11.5H2.5C1.67157 11.5 1 10.8284 1 10V6.5Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 1.5C5.46957 1.5 4.96086 1.71071 4.58579 2.08579C4.21071 2.46086 4 2.96957 4 3.5V5.5C4 5.77614 3.77614 6 3.5 6C3.22386 6 3 5.77614 3 5.5V3.5C3 2.70435 3.31607 1.94129 3.87868 1.37868C4.44129 0.81607 5.20435 0.5 6 0.5C6.79565 0.5 7.55871 0.81607 8.12132 1.37868C8.68393 1.94129 9 2.70435 9 3.5V5.5C9 5.77614 8.77614 6 8.5 6C8.22386 6 8 5.77614 8 5.5V3.5C8 2.96957 7.78929 2.46086 7.41421 2.08579C7.03914 1.71071 6.53043 1.5 6 1.5Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function UnsharedIcon({ className, width }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.2 6.3998C2.31634 6.3998 1.6 7.11615 1.6 7.9998C1.6 8.88346 2.31634 9.5998 3.2 9.5998C4.08366 9.5998 4.8 8.88346 4.8 7.9998C4.8 7.11615 4.08366 6.3998 3.2 6.3998ZM0 7.9998C0 6.23249 1.43269 4.7998 3.2 4.7998C4.96731 4.7998 6.4 6.23249 6.4 7.9998C6.4 9.76712 4.96731 11.1998 3.2 11.1998C1.43269 11.1998 0 9.76712 0 7.9998Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8001 1.6C11.9164 1.6 11.2001 2.31634 11.2001 3.2C11.2001 4.08366 11.9164 4.8 12.8001 4.8C13.6838 4.8 14.4001 4.08366 14.4001 3.2C14.4001 2.31634 13.6838 1.6 12.8001 1.6ZM9.6001 3.2C9.6001 1.43269 11.0328 0 12.8001 0C14.5674 0 16.0001 1.43269 16.0001 3.2C16.0001 4.96731 14.5674 6.4 12.8001 6.4C11.0328 6.4 9.6001 4.96731 9.6001 3.2Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.234315 0.234315C0.546734 -0.0781049 1.05327 -0.0781049 1.36569 0.234315L6.88052 5.74915C6.96074 5.80391 7.03184 5.87392 7.08898 5.95761L14.9949 13.8635C15.0199 13.8832 15.0439 13.9045 15.067 13.9276C15.0897 13.9503 15.1107 13.9741 15.1301 13.9987L15.7657 14.6343C16.0781 14.9467 16.0781 15.4533 15.7657 15.7657C15.4533 16.0781 14.9467 16.0781 14.6343 15.7657L14.4235 15.5549C13.9389 15.839 13.3836 15.993 12.8123 15.9942C11.9671 15.9961 11.1554 15.6635 10.5545 15.069C9.95367 14.4745 9.61244 13.6664 9.60535 12.8211C9.60347 12.5973 9.62506 12.3757 9.66879 12.1596L4.99363 9.75118C4.60086 9.54884 4.44648 9.06641 4.64882 8.67364C4.85116 8.28086 5.33359 8.12648 5.72637 8.32882L8.76048 9.89185L6.2633 7.39467L5.72626 7.67123C5.33346 7.87351 4.85105 7.71907 4.64877 7.32626C4.44649 6.93346 4.60093 6.45105 4.99374 6.24877L5.07536 6.20673L0.234315 1.36569C-0.0781049 1.05327 -0.0781049 0.546734 0.234315 0.234315ZM11.2574 12.3888L13.2107 14.342C13.0805 14.3761 12.9456 14.394 12.8088 14.3943C12.3861 14.3952 11.9803 14.2289 11.6799 13.9316C11.3794 13.6344 11.2088 13.2303 11.2053 12.8077C11.2041 12.6651 11.2219 12.5244 11.2574 12.3888ZM11.3512 3.87364C11.5535 4.26641 11.3991 4.74884 11.0064 4.95118L8.89437 6.03918C8.50159 6.24152 8.01916 6.08714 7.81682 5.69437C7.61448 5.30159 7.76886 4.81916 8.16164 4.61682L10.2736 3.52882C10.6664 3.32648 11.1488 3.48086 11.3512 3.87364ZM13.0244 10.2792C13.2012 9.87422 13.6727 9.68925 14.0776 9.86601C14.7803 10.1727 15.3499 10.7208 15.6835 11.4111C15.8757 11.809 15.7091 12.2873 15.3113 12.4795C14.9134 12.6717 14.4351 12.5051 14.2429 12.1073C14.0756 11.7611 13.7899 11.4862 13.4376 11.3324C13.0326 11.1556 12.8477 10.6841 13.0244 10.2792Z"
        fill="white"
      />
    </svg>
  );
}

export function OriginalIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "12"}
      height={width ? width : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.5 2C3.36739 2 3.24021 2.05268 3.14645 2.14645C3.05268 2.24021 3 2.36739 3 2.5V9.52841L5.70938 7.59313C5.88323 7.46896 6.11677 7.46896 6.29062 7.59313L9 9.52841V2.5C9 2.36739 8.94732 2.24021 8.85355 2.14645C8.75978 2.05268 8.63261 2 8.5 2H3.5ZM2.43934 1.43934C2.72064 1.15804 3.10218 1 3.5 1H8.5C8.89782 1 9.27936 1.15804 9.56066 1.43934C9.84196 1.72064 10 2.10218 10 2.5V10.5C10 10.6873 9.89533 10.8589 9.72879 10.9446C9.56225 11.0303 9.36179 11.0157 9.20938 10.9069L6 8.61445L2.79062 10.9069C2.63821 11.0157 2.43774 11.0303 2.27121 10.9446C2.10467 10.8589 2 10.6873 2 10.5V2.5C2 2.10218 2.15804 1.72064 2.43934 1.43934Z"
        fill="#6D7F92"
      />
    </svg>
  );
}

export function ShareIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "12"}
      height={width ? width : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 1.5C8.44772 1.5 8 1.94772 8 2.5C8 3.05228 8.44772 3.5 9 3.5C9.55228 3.5 10 3.05228 10 2.5C10 1.94772 9.55228 1.5 9 1.5ZM7 2.5C7 1.39543 7.89543 0.5 9 0.5C10.1046 0.5 11 1.39543 11 2.5C11 3.60457 10.1046 4.5 9 4.5C7.89543 4.5 7 3.60457 7 2.5Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3 5C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7C3.55228 7 4 6.55228 4 6C4 5.44772 3.55228 5 3 5ZM1 6C1 4.89543 1.89543 4 3 4C4.10457 4 5 4.89543 5 6C5 7.10457 4.10457 8 3 8C1.89543 8 1 7.10457 1 6Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9 8.5C8.44772 8.5 8 8.94772 8 9.5C8 10.0523 8.44772 10.5 9 10.5C9.55228 10.5 10 10.0523 10 9.5C10 8.94772 9.55228 8.5 9 8.5ZM7 9.5C7 8.39543 7.89543 7.5 9 7.5C10.1046 7.5 11 8.39543 11 9.5C11 10.6046 10.1046 11.5 9 11.5C7.89543 11.5 7 10.6046 7 9.5Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.863 6.50323C4.00203 6.26464 4.30815 6.18393 4.54674 6.32296L7.96174 8.31296C8.20033 8.45199 8.28104 8.75811 8.14201 8.9967C8.00298 9.23529 7.69685 9.316 7.45826 9.17697L4.04326 7.18697C3.80468 7.04794 3.72397 6.74181 3.863 6.50323Z"
        fill="#6D7F92"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.13685 3.00295C8.27603 3.24145 8.19552 3.54762 7.95702 3.68681L4.54702 5.67681C4.30852 5.81599 4.00234 5.73548 3.86316 5.49698C3.72398 5.25848 3.80449 4.9523 4.04299 4.81312L7.45299 2.82312C7.69149 2.68394 7.99766 2.76445 8.13685 3.00295Z"
        fill="#6D7F92"
      />
    </svg>
  );
}
export function DuplicatedIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "12"}
      height={width ? width : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clip-path="url(#clip0_50501_533)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.5 5C5.22386 5 5 5.22386 5 5.5V10C5 10.2761 5.22386 10.5 5.5 10.5H10C10.2761 10.5 10.5 10.2761 10.5 10V5.5C10.5 5.22386 10.2761 5 10 5H5.5ZM4 5.5C4 4.67157 4.67157 4 5.5 4H10C10.8284 4 11.5 4.67157 11.5 5.5V10C11.5 10.8284 10.8284 11.5 10 11.5H5.5C4.67157 11.5 4 10.8284 4 10V5.5Z"
          fill="#6D7F92"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M2 1.5C1.86739 1.5 1.74021 1.55268 1.64645 1.64645C1.55268 1.74021 1.5 1.86739 1.5 2V6.5C1.5 6.63261 1.55268 6.75979 1.64645 6.85355C1.74021 6.94732 1.86739 7 2 7H2.5C2.77614 7 3 7.22386 3 7.5C3 7.77614 2.77614 8 2.5 8H2C1.60217 8 1.22064 7.84196 0.93934 7.56066C0.658035 7.27936 0.5 6.89782 0.5 6.5V2C0.5 1.60218 0.658035 1.22064 0.93934 0.93934C1.22064 0.658035 1.60218 0.5 2 0.5H6.5C6.89782 0.5 7.27936 0.658035 7.56066 0.93934C7.84196 1.22064 8 1.60217 8 2V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V2C7 1.86739 6.94732 1.74021 6.85355 1.64645C6.75979 1.55268 6.63261 1.5 6.5 1.5H2Z"
          fill="#6D7F92"
        />
      </g>
      <defs>
        <clipPath id="clip0_50501_533">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CheckMarkCircleIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "24"}
      height={width ? width : "24"}
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="24" height="24" rx="12" />
      <g clip-path="url(#clip0_45967_24443)">
        <path
          d="M10.758 17.1003C10.4409 17.1003 10.141 16.952 9.94826 16.6976L7.34464 13.2591C7.006 12.8119 7.09415 12.1752 7.54135 11.8364C7.98928 11.4975 8.62561 11.5862 8.9644 12.0331L10.6768 14.2943L14.9837 7.37899C15.2802 6.90323 15.9064 6.75767 16.3832 7.05376C16.8593 7.35014 17.0048 7.97671 16.7081 8.45291L11.6203 16.6216C11.4436 16.9056 11.1385 17.0843 10.8043 17.0994C10.7887 17.1 10.7734 17.1003 10.758 17.1003Z"
          fill="#02AF8E"
        />
      </g>
    </svg>
  );
}
export function InfoCircleIcon({ className, width }) {
  return (
    <svg
      width={width ? width : "24"}
      height={width ? width : "24"}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill="white"
        d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2.033 16.01c.564-1.789 1.632-3.932 1.821-4.474.273-.787-.211-1.136-1.74.209l-.34-.64c1.744-1.897 5.335-2.326 4.113.613-.763 1.835-1.309 3.074-1.621 4.03-.455 1.393.694.828 1.819-.211.153.25.203.331.356.619-2.498 2.378-5.271 2.588-4.408-.146zm4.742-8.169c-.532.453-1.32.443-1.761-.022-.441-.465-.367-1.208.164-1.661.532-.453 1.32-.442 1.761.022.439.466.367 1.209-.164 1.661z"
      />
    </svg>
  );
}

export function StandardIcon({ className, width }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      version="1.1"
      width={width ? width : "15"}
      height={width ? width : "12"}
      fill="#6D7F92"
      className={className}
    >
      <path d="M965.632 512a34.676364 34.676364 0 0 0-34.676364 31.930182c-17.547636 231.610182-224.535273 411.229091-466.222545 384.302545-192.139636-21.410909-347.438545-176.477091-368.872727-368.337454C67.700364 307.572364 265.565091 93.090909 512.674909 93.090909c137.076364 0 262.865455 65.210182 341.643636 175.755636l-365.14909 373.76-177.710546-151.877818a35.025455 35.025455 0 0 0-49.314909 3.816728 34.909091 34.909091 0 0 0 3.84 49.221818l194.304 166.074182a46.638545 46.638545 0 0 0 63.674182-2.862546l393.704727-402.990545h-0.139636a46.545455 46.545455 0 0 0 5.12-58.577455C831.185455 105.192727 677.352727 22.109091 509.184 23.272727c-256.698182 1.792-472.692364 208.128-485.306182 464.151273C10.053818 768.046545 234.658909 1000.727273 512.674909 1000.727273c257.070545 0 468.48-198.935273 487.936-450.746182A35.188364 35.188364 0 0 0 965.632 512" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/Icons/index.js